import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild,  ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { Edge, Node, Layout, GraphComponent } from '@swimlane/ngx-graph';
import { BehaviorSubject, Subject, Subscription  } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import * as shape from 'd3-shape';
import { DagreNodesOnlyLayout } from './customDagreNodesOnly';
import { v4 as uuidv4 } from 'uuid';
import { UntypedFormControl, Validators } from '@angular/forms';
import { RefineryViewModel } from '../viewModels/refineryViewModel';
import { DialogBlankCheckComponent } from './dialog-blank-check/dialog-blank-check.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../framework/confirm-dialog/confirm-dialog.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { RunStatusService } from 'src/app/services/run-status.service';
import { DataRefineryConfig, TableRefinery, RefineryConflictError } from '../domainObjects/dataRefineryConfig';
import { DatePipe } from '@angular/common';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SaveRefineryConfigDialogComponent } from './save-refinery-config-dialog/save-refinery-config-dialog.component';
import { NewSingleStringValueDialogComponent } from '../views/shared/new-single-string-value-dialog/new-single-string-value-dialog.component';
import { RefineryStatusUtil } from '../domainObjects/refineryStatus';
import { Router } from '@angular/router';
import { UserDataService } from '../services/user-data-service';
import { LinkNodeViewModel, NodeViewModel } from '../domainObjects/nodeViewModel';
import { FarmType, NodeBoxType } from '../domainObjects/masterConfig';

import { AboutThisNodeComponent } from './about-this-node/about-this-node.component';
import { RunNodeDialogComponent } from './run-node-dialog/run-node-dialog.component';

import { DataConnectorType } from '../domainObjects/dataConnector';
import { NodeRunStatus, NodeRunStatusUtil } from 'src/app/domainObjects/nodeRunStatus';
import { RunrefineryRequest } from '../model/RunrefineryRequest';
import { ReadRefineryRequest } from '../model/ReadRefineryRequest';
import { ImportRefineryError } from '../model/ImportRefineryError';
import { ImportRefineryDialogComponent } from '../views/shared/import-refinery-dialog/import-refinery-dialog.component';
import { ColumnInfo, IPreviewTableDelegate, PreviewTableComponent } from '../views/preview-table/preview-table.component';

import { PreviewDataOptions } from 'src/app/domainObjects/previewDataOptions';
import { GetCacheKeyRequest, GetDataFarmPreviewRequest } from 'src/app/messaging/getDataFarmPreviewRequest';
import { ColumnFilter } from '../domainObjects/columnFilter';
import { ColumnFilterInfo } from '../views/previewTable/filterUI/column-filter/column-filter.component';
import { ImportDataViewModel } from '../viewModels/importDataViewModel';
import { DataTransformerConfig } from '../domainObjects/dataTransformConfig';
import { InputPrvwFilterViewModel } from '../viewModels/inputPrvwFilterViewModel';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { SortInfo } from '../domainObjects/sortInfo';
import _ from 'lodash';
import { isEqual } from 'lodash';
import { CacheKeyType, PreviewType, TransformTypeUtil } from '../domainObjects/transformType';
import { GetSummaryDataFarmPreviewRequest } from '../messaging/getSummaryDataFarmPreviewRequest';
import { SelectFilterInfo } from '../views/shared/select-filter-option/select-filter-option.component';
import { PreviewData } from '../domainObjects/previewData';
import { GetFilteredselcolvalsRequest } from '../messaging/getFilteredselcolvalsRequest';
import { JoinerListRequest, JoinerListResponse } from '../views/transform/transformerDetail/joiner-transform-detail/joinerViewModel';
import { RunrefineryResponse } from '../model/RunrefineryResponse';
import { ResetRefineryNodesStatusRequest } from '../messaging/resetRefineryNodesStatusRequest';
import { TestWriterRequest } from '../views/transform/export-output-data-dynamic/export-output-data-dynamic.component';

class ViewModelT {
  activeFilters?: ColumnFilter[];
}


export interface ColorsP {
  id: number;
  name: string;
  hexCode: string;
  category?: 'Warm' | 'Yellow & Green' | 'Blue & Cyan' | 'Purple & Pink' | 'Neutral';
}

@Component({
    selector: 'app-nodedefinition',
    templateUrl: './nodedefinition.component.html',
    styleUrls: ['./nodedefinition.component.css'],
    standalone: false
})
export class NodedefinitionComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit, IPreviewTableDelegate {

  @ViewChild('blinkingText') blinkingText: ElementRef | undefined;
  @ViewChild('inputDataFarmPreviewTable') inputDataFarmPreviewTable: PreviewTableComponent;
  @ViewChild('outputDataFarmPreviewTable') outputDataFarmPreviewTable: PreviewTableComponent;

  @ViewChild('summaryDataFarmPreviewTableInput') summaryDataFarmPreviewTableInput: PreviewTableComponent;
  @ViewChild('summaryDataFarmPreviewTableOutput') summaryDataFarmPreviewTableOutput: PreviewTableComponent;
  @ViewChildren('joinerSummaryPreviewTable') joinerSummaryPreviewTables: QueryList<PreviewTableComponent>;

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @ViewChild(MatMenuTrigger) ingestMenuTrigger!: MatMenuTrigger;
  @ViewChild('ngxgraph', { static: false }) ngxgraph!: GraphComponent;
  graphWidth: number = 800; 
  graphHeight: number = 600; 

  transformerToggleState: { [nodeId: number]: boolean } = {};  // track toggle type/name per node
  transformerToggleLabels: { [nodeId: number]: string } = {};

  originalTitle: Map<string, string> = new Map();

  @ViewChildren('joinerInputPreviewTable') joinerInputPreviewTables: QueryList<PreviewTableComponent>;
  joinerPreviewTabs: { label: string; color: string; nodeName: string }[] = [];

  private readonly joinerInputPreviewTypes = [
    PreviewType.joinerInputA, PreviewType.joinerInputB, PreviewType.joinerInputC,
    PreviewType.joinerInputD, PreviewType.joinerInputE, PreviewType.joinerInputF,
    PreviewType.joinerInputG, PreviewType.joinerInputH, PreviewType.joinerInputI,
    PreviewType.joinerInputJ
  ];

  previewInputTableLabel:string="show";

  onResize(event) {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      console.log('🪟 Window resized, refreshing graph layout...');
      this.update$.next(true);
    }, 300);
  }
  setNgxGraphResize() {
    // dagre computes an unreliable (near-zero) bounding box for a single, edge-less
    // node - graphDims can't be trusted to size the container in that case, so leave
    // the container at its current size rather than shrinking the node out of view.
    if (this.viewModel.dataRefineryConfig.nodes.length <= 1) {
      return;
    }
    if (this.ngxgraph && this.ngxgraph.graphDims.width > 0 && this.ngxgraph.graphDims.height > 0) {
      this.graphWidth = this.ngxgraph.graphDims.width + this.viewModel.nodeWidth;
      this.graphHeight = this.ngxgraph.graphDims.height + this.viewModel.nodeHeight;
      console.log(`📐 Graph resized: ${this.graphWidth} x ${this.graphHeight}`);
      this.cdr.detectChanges();
    }
  }
  previewDataViewModel = new ImportDataViewModel();
  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();
  viewModelt = new ViewModelT();
  currentUser: string;
  inputColumnCount: number = 0;
  outputColumnCount: number = 0;
  inputPrvwFarmId: string = "";
  outputPrvwFarmId: string = "";
  selectedIndex: number = 0;

  constructor(
    errorLogger: ErrorReportingService,
    matDialog: MatDialog,
    public dialog: MatDialog,
    private configService: ConfigService,
    private snackBar: MatSnackBar,
    public datePipe: DatePipe,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private userData: UserDataService,
    private refineryPresence: RefineryPresenceService,
    private runStatus: RunStatusService) {
    super(errorLogger, matDialog);
    setTimeout(() => {
      this.setNgxGraphResize();
    }, 1500);
    this.currentUser = this.userData.getUserName();
    // Single source of truth for isReadOnly — only 'readOnly' mode blocks;
    // 'edit' and 'none' (nothing open, or a brand-new unsaved refinery with
    // nothing to lock yet) both allow.
    this.modeSub = this.refineryPresence.mode$.subscribe(mode => {
      this.isReadOnly = mode === 'readOnly';
    });
    this.lockLostSub = this.refineryPresence.lockLost$.subscribe(({ holderUserName }) => {
      this.displayWarning(
        `Your Edit access to this refinery expired and was picked up by ${holderUserName ?? 'another session'}. You're now viewing in Read-Only mode.`,
        'Edit Access Lost'
      );
    });
    this.userData.setLookupTabClicked(false);
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.userData.setApplyFilterBtnClicked(false);
    this.userData.setInputTabClicked(false);
    this.userData.setRawTabClicked(false);
    this.inputPrvwFilterViewModel.resetProps();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  

  activeSortsSet: SortInfo[]=[];

  clearAllSortFilter(){
    this.activeSortsSet = [];
    this.viewModelt.activeFilters=[];
  }
  

  update$: Subject<any> = new Subject();

  panelOpenState = false;
  refineryListpanelOpenState = false;
  refineryPreviewPanelOpenState = false;
  id: string = '';
  farmtypeid: string = '';
  // True whenever this TAB does not currently hold the Edit lock for the
  // open refinery — driven by refineryPresence.mode$ (see the subscription
  // in the constructor), never set directly except by that subscription.
  // Every mutating action in this component is gated on it; the backend
  // enforces the same thing independently (see ConfigController's
  // CheckEditLockAsync) so this is a UX convenience, not the security
  // boundary. Starts false (nothing loaded yet, nothing to protect); the
  // moment a refinery is opened it flips via that subscription, depending
  // on whether this tab won the automatic "first tab in gets Edit" race
  // (see tryAcquireEdit()) — there is no manual way to switch a Read-Only
  // tab to Edit.
  isReadOnly = false;
  public layoutSettings = {
    orientation: 'LR',
    Alignment: 'UL'
  };
  public curve: any = shape.curveLinear;
  public layout: Layout = new DagreNodesOnlyLayout();
  public JoinerNodeArr: Node[] = [];
  public filteredLinks: Edge[] = [];
  public LookUpNodeArr: Node[] = [];
  public ExistingJoinerArr: Node[] = [];
  public ExistingJoinerMenuDisabled: boolean = true;
  public JoinerMenuDisabled: boolean = true;
  public NewJoinerMenuDisabled: boolean = false;
  public FConverterMenuDisabled: boolean = true;
  public AddLookUpDisabled = true;

  public InsertProcessorDisabled = false;
  public InsertJoinerDisabled = false;
  public RemoveNodeDisabled = false;


  public UndoConfigDisabled = true;
  public undoConfigEvent:string = '';

  public highLightedID:string = '';
  public dataPreviewNodeID: string = 'No Node Selected. Choose Data Preview from Node Menu';
  public dataPreviewNodeColor: string = '#FFFFFF';

  NodeRunStatus = NodeRunStatus;
  NodeRunStatusUtil = NodeRunStatusUtil;

  nodeStatusArray: { id: string, status: string }[] = [];

  /**
   * Define the List of colors to be useed in lookup
  */
  colorPallet: ColorsP[] = [
    { id: 1, name: 'Pale Turquoise', hexCode: '#B6D8F2' },
    { id: 2, name: 'Yellow', hexCode: '#F7F6CF' },
    { id: 3, name: 'Linen', hexCode: '#F4CFDF' },
    { id: 4, name: 'Steel Blue', hexCode: '#5784BA' },
    { id: 5, name: 'Sky Blue', hexCode: '#9AC8EB' },
    { id: 6, name: 'Pale Leaf', hexCode: '#CCD4BF' },
    { id: 7, name: 'Burly Wood', hexCode: '#E7CBA9' },
    { id: 8, name: 'Zinnwaldite', hexCode: '#EEBAB2' },
    { id: 9, name: 'Vanilla Ice', hexCode: '#F5E2E4' }
  ];

  /**
   * Define the List of colors to be useed in Joiner Lines
  */
  PrimarycolorPallet: ColorsP[] = [
    // Warm — reds, oranges, peachy pinks
    { id: 1020, name: 'Red',           hexCode: '#FF0000', category: 'Warm' },
    { id: 1006, name: 'Bittersweet',   hexCode: '#fea051', category: 'Warm' },
    { id: 1007, name: 'Cheese',        hexCode: '#FF8C00', category: 'Warm' },
    { id: 1011, name: 'Mango',         hexCode: '#FF5200', category: 'Warm' },
    { id: 1017, name: 'Mona Lisa',     hexCode: '#ff9889', category: 'Warm' },
    // Yellow & Green
    { id: 1002, name: 'Yellow',        hexCode: '#FFFF00', category: 'Yellow & Green' },
    { id: 1019, name: 'Gold',          hexCode: '#FFCC00', category: 'Yellow & Green' },
    { id: 1009, name: 'Pear',          hexCode: '#d1e231', category: 'Yellow & Green' },
    { id: 1001, name: 'Green',         hexCode: '#00FF00', category: 'Yellow & Green' },
    { id: 1010, name: 'Spring Grass',  hexCode: '#00ff7c', category: 'Yellow & Green' },
    // Blue & Cyan
    { id: 1003, name: 'Cyan',          hexCode: '#00FFFF', category: 'Blue & Cyan' },
    { id: 1005, name: 'Below Zero',    hexCode: '#87cded', category: 'Blue & Cyan' },
    { id: 1018, name: 'Tractor Beam',  hexCode: '#00bffe', category: 'Blue & Cyan' },
    { id: 1025, name: 'Royal Blue',    hexCode: '#4169E1', category: 'Blue & Cyan' },
    { id: 1026, name: 'Cobalt Blue',   hexCode: '#086bf6', category: 'Blue & Cyan' },
    // Purple & Pink
    { id: 1004, name: 'Electric Indigo', hexCode: '#6600ff', category: 'Purple & Pink' },
    { id: 1008, name: 'Bright Purple', hexCode: '#be03fd', category: 'Purple & Pink' },
    { id: 1015, name: 'Mauve',         hexCode: '#e0b0ff', category: 'Purple & Pink' },
    { id: 1016, name: 'Bubble Gum',    hexCode: '#ff85ff', category: 'Purple & Pink' },
    { id: 1013, name: 'Bright Pink',   hexCode: '#fe01b1', category: 'Purple & Pink' },
    // Neutral
    { id: 1000, name: 'White',         hexCode: '#5A6B85', category: 'Neutral' },
    { id: 1021, name: 'Snow',          hexCode: '#85695C', category: 'Neutral' },
    { id: 1022, name: 'Gainsboro',     hexCode: '#7A7A55', category: 'Neutral' },
    { id: 1023, name: 'Silver',        hexCode: '#557A7A', category: 'Neutral' },
    { id: 1024, name: 'Dark Silver',   hexCode: '#7A5A85', category: 'Neutral' },
  ];

  nodeWidthFormControl               = new UntypedFormControl(200,  [Validators.required, Validators.max(400),  Validators.min(50)])
  nodeHeightRatioFormControl         = new UntypedFormControl(50,   [Validators.required, Validators.max(55),   Validators.min(35)])
  nodeGearSize_PerFormControl        = new UntypedFormControl(30,   [Validators.required, Validators.max(200),  Validators.min(1)])
  DatawriterSize_Per_FormControl     = new UntypedFormControl(21,   [Validators.required, Validators.max(200),  Validators.min(1)])
  nodePadding_XFormControl           = new UntypedFormControl(45,  [Validators.required, Validators.max(500),  Validators.min(1)])
  nodePadding_YFormControl           = new UntypedFormControl(45,   [Validators.required, Validators.max(500),  Validators.min(1)])
  nodeBorderWeightFormControl        = new UntypedFormControl(3,    [Validators.required, Validators.max(5),    Validators.min(1)])
  nodeFontSizeTitlePerFormControl    = new UntypedFormControl(10,   [Validators.required, Validators.max(20),   Validators.min(10)])
  nodeFontSizeSubtitlePerFormControl = new UntypedFormControl(8,    [Validators.required, Validators.max(20),   Validators.min(8)])
  nodeFontSizeFarmTypePerFormControl = new UntypedFormControl(10,   [Validators.required, Validators.max(20),   Validators.min(10)])
  nodeFontSizeStatusPerFormControl   = new UntypedFormControl(10,   [Validators.required, Validators.max(20),   Validators.min(10)])
  nodeMenuFontSizePerFormControl     = new UntypedFormControl(12,   [Validators.required, Validators.max(20),   Validators.min(10)])
  titlePadXControl                   = new UntypedFormControl(2,    [Validators.required, Validators.max(10),   Validators.min(0)])
  titlePadYControl                   = new UntypedFormControl(1,    [Validators.required, Validators.max(10),   Validators.min(0)])
  SubTitlePadXControl                = new UntypedFormControl(2,    [Validators.required, Validators.max(10),   Validators.min(0)])
  SubTitlePadYControl                = new UntypedFormControl(1,    [Validators.required, Validators.max(10),   Validators.min(0)])
  NodeIDPadXControl                  = new UntypedFormControl(4,    [Validators.required, Validators.max(10),   Validators.min(0)])
  NodeIDPadYControl                  = new UntypedFormControl(4,    [Validators.required, Validators.max(10),   Validators.min(0)])


  viewModel = new RefineryViewModel(200, 50, 0, 0, 21, 0, 30, 0, 0, 45, 45, 3, 0, 0, 0, 0, 0, 10, 8, 10, 10, 12, 0, new DataRefineryConfig(), 2, 1, 2, 1, 4, 4);
  filterlinks: Edge[]=[];
  onSettingChange() {
    if (this.viewModel.nodeWidth == null || this.viewModel.nodeWidth < 1) {
      this.viewModel.nodeWidth = 1
    }

    this.viewModel = new RefineryViewModel(this.viewModel.nodeWidth         ?? 200
      , this.viewModel.nodeHeightRatio_Per                                   ?? 50
      , this.viewModel.nodeHeight                                            ?? 0
      , this.viewModel.nodeGearSizePX                                        ?? 0
      , this.viewModel.dataWriterSize_Per                                    ?? 21
      , this.viewModel.dataWriterSizePX                                      ?? 0
      , this.viewModel.nodeGearSize_Per                                      ?? 30
      , this.viewModel.gearPosition_X                                        ?? 0
      , this.viewModel.gearPosition_Y                                        ?? 0
      , this.viewModel.nodePadding_X                                         ?? 45
      , this.viewModel.nodePadding_Y                                         ?? 45
      , this.viewModel.nodeBorderWeight                                      ?? 3
      , this.viewModel.nodeBorderStroke                                      ?? 0
      , this.viewModel.nodeFontSizeTitle                                     ?? 0
      , this.viewModel.nodeFontSizeSubtitle                                  ?? 0
      , this.viewModel.nodeFontSizeFarmType                                  ?? 0
      , this.viewModel.nodeFontSizeStatus                                    ?? 0
      , this.viewModel.nodeFontSizeTitlePer                                  ?? 10
      , this.viewModel.nodeFontSizeSubtitlePer                               ?? 8
      , this.viewModel.nodeFontSizeFarmTypePer                               ?? 10
      , this.viewModel.nodeFontSizeStatusPer                                 ?? 10
      , this.viewModel.nodeMenuFontSizePer                                   ?? 12
      , this.viewModel.menuFontSizePX                                        ?? 0
      , this.viewModel.dataRefineryConfig                                    ?? new DataRefineryConfig()
      , this.viewModel.titlePadXPer                                          ?? 2
      , this.viewModel.titlePadYPer                                          ?? 1
      , this.viewModel.subTitlePadXPer                                       ?? 2
      , this.viewModel.subTitlePadYPer                                       ?? 1
      , this.viewModel.nodeIDPadXPer                                         ?? 4
      , this.viewModel.nodeIDPadYPer                                         ?? 4);

    this.positioningNodes();
    this.update$.next(true);
  }
  nodepaddingx: number = this.viewModel.nodeWidth + this.viewModel.nodePadding_X;
  nodepaddingy: number = this.viewModel.nodeHeight + this.viewModel.nodePadding_Y;
  nodey: number = 0;
  nodecolorno: number = 0;
  rowno: number = 0;
  columnno: number = 0;

  async positioningNodes() {
    this.nodepaddingx = this.viewModel.nodeWidth + this.viewModel.nodePadding_X;
    this.nodepaddingy = this.viewModel.nodeHeight + this.viewModel.nodePadding_Y;
    this.nodey = this.viewModel.nodeHeight / 2 + 20;;
    var nodeingest = this.viewModel.dataRefineryConfig.nodes.filter(x => x.data.parentid == 0).sort((a, b) => { return (a.data.farmtypeid || 0) - (b.data.farmtypeid || 0); });
    var nodex = this.viewModel.nodeWidth / 2 + 20;
    this.nodecolorno=999;
    this.rowno=1;
    let currentRow = '';
    let groupIndex = -1;
    let colorIndex = 0;
    const groupedColors = this.PrimarycolorPallet.reduce((acc, color) => {
    if (!acc[color.category]) acc[color.category] = [];
      acc[color.category].push(color);
      return acc;
    }, {} as Record<string, ColorsP[]>);

    const categories = Object.keys(groupedColors);

    nodeingest.forEach(node => {
      this.columnno=1;
      node.data.rcNo= this.rowno.toString()+"."+this.columnno.toString() ;
      node.data.Descriptor = this.rowno.toString()+"."+this.columnno.toString()+" "+this.GetFarmName(node.data.farmtypeid)+": "+this.GetNodeBoxName(node.data.nodeboxtypeid);
      // Detect row change
      if (currentRow !== this.rowno.toString()) {
        currentRow = this.rowno.toString();

        // Move to next group
        groupIndex = (groupIndex + 1) % categories.length;
        colorIndex = 0; // reset color cycle
      }

      const currentCategory = categories[groupIndex];
      const colorGroup = groupedColors[currentCategory];

      const selectedColor = colorGroup[colorIndex % colorGroup.length];

      node.data.nodecolorno=selectedColor.id.toString();//this.nodecolorno.toString();
      // Move to next color in same group
      colorIndex++;

      node.data.x = nodex;
      node.data.y = this.nodey;
      node.data.nodePadding_X = this.viewModel.nodePadding_X;
      node.data.nodePadding_Y = this.viewModel.nodePadding_Y;
      node.data.ingestId=node.id;
      this.nodey = this.nodey + this.nodepaddingy;
      node.dimension = { width: this.viewModel.nodeWidth, height: this.viewModel.nodeHeight };
      var nodeids: string[] = [];
      var parentnodeid: string = node.id;
      nodeids.push(node.id);
      var childnodex = nodex + this.nodepaddingx;
      let i: number = 0;
      do {
        var childnodes = this.viewModel.dataRefineryConfig.nodes.filter(x => x.data.parentid == parentnodeid);
        let ni: number = 0
        var prevnodex = 0
        childnodes.forEach(n => {
          nodeids.push(n.id);
          n.dimension = { width: this.viewModel.nodeWidth, height: this.viewModel.nodeHeight };
          n.data.nodePadding_X = this.viewModel.nodePadding_X;
          n.data.nodePadding_Y = this.viewModel.nodePadding_Y;
          n.data.ingestId=node.id;
          this.nodecolorno++;
          this.columnno++;
          n.data.rcNo= this.rowno.toString()+"."+this.columnno.toString() ;
          n.data.Descriptor = this.rowno.toString()+"."+this.columnno.toString()+" "+this.GetFarmName(n.data.farmtypeid)+": "+this.GetNodeBoxName(n.data.nodeboxtypeid);
          // Detect row change
          if (currentRow !== this.rowno.toString()) {
            currentRow = this.rowno.toString();

            // Move to next group
            groupIndex = (groupIndex + 1) % categories.length;
            colorIndex = 0; // reset color cycle
          }

          const currentCategory = categories[groupIndex];
          const colorGroup = groupedColors[currentCategory];

          const selectedColor = colorGroup[colorIndex % colorGroup.length];

          node.data.nodecolorno=selectedColor.id.toString();//this.nodecolorno.toString();
          // Move to next color in same group
          colorIndex++;

          if (ni == 0) {
            parentnodeid = n.id;
            n.data.x = childnodex;
            childnodex = childnodex + this.nodepaddingx;
            n.data.y = node.data.y;
          } else {
            n.data.x = childnodex - this.nodepaddingx;
            n.data.y = this.nodey;
            this.nodey = this.nodey + this.nodepaddingy;
            this.positioningChildNodes(n.id, n.data.x, n.data.y,node.id)
          }
          ni++;
        });
        i++;
      } while (i < nodeids.length);
      this.nodecolorno++;
      this.rowno++;
    });
    this.updateRowColNos();
    this.updatePositionRowColNos();
    this.compactRows();

    this.updateLinkColor();
    this.updateLinkCountNo();
    this.updateLinkTotalCountNo();
    this.updateColumnLineCountNo();
    this.getNodeTransformNames();
    await this.getUniqueLinkForAttribution();
  }
  positioningChildNodes(id: string, x: number, y: number,ingestId:string) {
    var nodeids: string[] = [];
    nodeids.push(id);
    var nodex = x;
    let i: number = 0;
    do {
      var childnodes = this.viewModel.dataRefineryConfig.nodes.filter(x => x.data.parentid == id);
      let ni: number = 0
      childnodes.forEach(n => {
        n.dimension = { width: this.viewModel.nodeWidth, height: this.viewModel.nodeHeight };
        n.data.nodePadding_X = this.viewModel.nodePadding_X;
        n.data.nodePadding_Y = this.viewModel.nodePadding_Y;
        n.data.ingestId=ingestId;
        this.nodecolorno++;
        this.columnno++;
        n.data.rcNo= this.rowno.toString()+"."+this.columnno.toString() ;
        n.data.Descriptor = this.rowno.toString()+"."+this.columnno.toString()+" "+this.GetFarmName(n.data.farmtypeid)+": "+this.GetNodeBoxName(n.data.nodeboxtypeid);
        n.data.nodecolorno=this.nodecolorno.toString();
        if (ni == 0) {
          nodex = nodex + this.nodepaddingx;
          n.data.x = nodex;
          n.data.y = y;
          id = n.id;
          nodeids.push(id);
        } else {
          n.data.x = nodex;
          n.data.y = this.nodey;
          this.nodey = this.nodey + this.nodepaddingy;
          this.positioningChildNodes(n.id, n.data.x, n.data.y,ingestId)
        }
        ni++;
      });

      i++;
    } while (i < nodeids.length);
  }
  updateLinkColor(){
    const nodes = this.viewModel.dataRefineryConfig.nodes;
    const nodeById = new Map(nodes.map(n => [n.id, n]));

    // Group palette colors by category (preserving insertion order)
    const groupedColors = this.PrimarycolorPallet.reduce((acc, color) => {
      if (!acc[color.category]) acc[color.category] = [];
      acc[color.category].push(color);
      return acc;
    }, {} as Record<string, ColorsP[]>);
    const categories = Object.keys(groupedColors);

    // Collect unique rownos in ascending order from node rcNo ("rowno.columnno")
    const rownos: number[] = [];
    nodes.forEach(n => {
      if (n.data?.rcNo) {
        const rowno = parseInt(n.data.rcNo.split('.')[0]);
        if (!rownos.includes(rowno)) rownos.push(rowno);
      }
    });
    rownos.sort((a, b) => a - b);

    // rowno 1 → Neutral, rowno 2 → Warm, rowno 3 → Yellow & Green, … cycling
    const rowCategoryMap = new Map<number, string>();
    rownos.forEach((rowno, idx) => {
      rowCategoryMap.set(rowno, categories[idx % categories.length]);
    });

    // Assign color: category from rowno, color index from source column (0-indexed)
    // e.g. rowno 1: col 0→1 = White, col 1→2 = Snow, col 2→3 = Gainsboro, …
    this.viewModel.dataRefineryConfig.links.forEach(link => {
      const sourceNode = nodeById.get(link.source);
      if (sourceNode?.data?.rcNo) {
        const parts = sourceNode.data.rcNo.split('.');
        const rowno = parseInt(parts[0]);
        const colIdx = parseInt(parts[1]) - 1; // 0-indexed
        const category = rowCategoryMap.get(rowno) ?? categories[0];
        const colorGroup = groupedColors[category];
        const color = colorGroup[colIdx % colorGroup.length];
        link.data.linkcolorno = color.id;
      } else {
        link.data.linkcolorno = 1000;
      }
    });
  }
  updateLinkCountNo(){
    const allNodes = this.viewModel.dataRefineryConfig.nodes;
    // Built once for this whole call — every node lookup below (rcNoSort, adjacency checks,
    // per-link target/source resolution) looks the node up by id repeatedly; a single shared
    // Map turns each of those from an O(N) array scan into an O(1) lookup.
    const nodeById = new Map(allNodes.map(n => [n.id, n]));
    const rcNoSort = (aId: string, bId: string): number => {
      const aNode = nodeById.get(aId);
      const bNode = nodeById.get(bId);
      const aRow = aNode?.data.rowNo ?? 0;
      const bRow = bNode?.data.rowNo ?? 0;
      const aCol = aNode?.data.colNo ?? 0;
      const bCol = bNode?.data.colNo ?? 0;
      return aRow !== bRow ? aRow - bRow : aCol - bCol;
    };

    // First-sorted 'line'/'joiner' edge in a group (line-group order, then joiner-group
    // order — the same overall order the old unconditional siup===0/tiup===0 fallback used
    // to see) — used below only as a last-resort center anchor when NONE of the group's
    // edges are genuinely row-adjacent, so a node whose only line/joiner connections skip
    // rows still gets one real center-routed line instead of none.
    const firstLineOrJoinerLink = (links: any[]): any | null => {
      const lines = links.filter(l => l.data.linetype === 'line');
      const joiners = links.filter(l => l.data.linetype === 'joiner');
      return lines[0] ?? joiners[0] ?? null;
    };

    this.viewModel.dataRefineryConfig.nodes.forEach(node => {
      let siup = 0, sidown = 1, tiup = 0, tidown = 1;
      const srcRowNo: number = node.data.rowNo ?? 0;
      const srcColNo: number = node.data.colNo ?? 0;

      const sortedSourceLineOrJoiner = this.viewModel.dataRefineryConfig.links
        .filter(l => l.source === node.id && (l.data.linetype === 'line' || l.data.linetype === 'joiner'))
        .sort((a, b) => rcNoSort(b.target, a.target));
      const hasAdjacentSource = sortedSourceLineOrJoiner.some(l => {
        const t = nodeById.get(l.target);
        return !!t && srcRowNo === t.data.rowNo && (srcColNo + 1) === t.data.colNo;
      });
      const sourceFallbackCenterLink = hasAdjacentSource ? null : firstLineOrJoinerLink(sortedSourceLineOrJoiner);

      // --- SOURCE side ---
      ['line', 'joiner', 'dotted'].forEach(linetype => {
        let links = this.viewModel.dataRefineryConfig.links
          .filter(n => n.source === node.id && n.data.linetype === linetype);
        // 'dotted' sorts by the same byOwnerRowThenDistance() order used for
        // sourcepositionnumber in updateColumnLineCountNo() — not rcNoSort — so
        // sourcelinkcount (driving the Segment 1+2/3+4 height offset) and
        // sourcepositionnumber (driving the X-corridor fan) rank identically and
        // never cross each other's final approach segments.
        if (linetype === 'dotted') {
          links = links.slice().sort(this.byOwnerRowThenDistance(l => l.source, l => l.target, nodeById));
        } else {
          links = links.slice().sort((a, b) => rcNoSort(b.target, a.target));
        }
        links.forEach(link => {
          const targetNode = nodeById.get(link.target);
          const targetRowNo: number = targetNode?.data.rowNo ?? srcRowNo;
          const targetColNo: number = targetNode?.data.colNo ?? srcColNo;
          // Immediate horizontal neighbour on the same row: route straight through the center
          // instead of up/down, regardless of iteration order.
          const isAdjacentSameRow = srcRowNo === targetRowNo && (srcColNo + 1) === targetColNo;
          if (isAdjacentSameRow || link === sourceFallbackCenterLink) {
            link.data.sourcelinkcount = 0;
            link.data.sourcelineposition = 'center';
            link.data.sourcerowdist = 0;
            link.data.sourceweight = 0;
          } else {
            const targetY = targetNode?.data.y ?? node.data.y;
            link.data.sourcerowdist = Math.abs(srcRowNo - targetRowNo);
            if (node.data.y >= targetY) {
              link.data.sourcelinkcount = siup;
              link.data.sourcelineposition = 'up';
              siup++;
            } else {
              link.data.sourcelinkcount = sidown;
              link.data.sourcelineposition = 'down';
              sidown++;
            }
          }
        });
      });

      const sortedTargetLineOrJoiner = this.viewModel.dataRefineryConfig.links
        .filter(l => l.target === node.id && (l.data.linetype === 'line' || l.data.linetype === 'joiner'))
        .sort((a, b) => rcNoSort(a.source, b.source));
      const hasAdjacentTarget = sortedTargetLineOrJoiner.some(l => {
        const s = nodeById.get(l.source);
        return !!s && srcRowNo === s.data.rowNo && (s.data.colNo + 1) === srcColNo;
      });
      const targetFallbackCenterLink = hasAdjacentTarget ? null : firstLineOrJoinerLink(sortedTargetLineOrJoiner);

      // --- TARGET side ---
      ['line', 'joiner', 'dotted'].forEach(linetype => {
        let links = this.viewModel.dataRefineryConfig.links
          .filter(n => n.target === node.id && n.data.linetype === linetype);
        // 'dotted' sorts by byOwnerRowThenDistance() to match targetpositionnumber's ordering.
        if (linetype === 'dotted') {
          links = links.slice().sort(this.byOwnerRowThenDistance(l => l.target, l => l.source, nodeById));
        } else {
          links = links.slice().sort((a, b) => rcNoSort(a.source, b.source));
        }
        links.forEach(link => {
          const sourceNode = nodeById.get(link.source);
          const sourceRowNo: number = sourceNode?.data.rowNo ?? srcRowNo;
          const sourceColNo: number = sourceNode?.data.colNo ?? srcColNo;
          const nodeRowNo: number = node.data.rowNo ?? 0;
          const nodeColNo: number = node.data.colNo ?? 0;
          // Immediate horizontal neighbour on the same row: route straight through the center
          // instead of up/down, regardless of iteration order.
          const isAdjacentSameRow = nodeRowNo === sourceRowNo && (sourceColNo + 1) === nodeColNo;
          if (isAdjacentSameRow || link === targetFallbackCenterLink) {
            link.data.targetlinkcount = 0;
            link.data.targetlineposition = 'center';
            link.data.targetrowdist = 0;
            link.data.targetweight = 0;
          } else {
            const sourceY = sourceNode?.data.y ?? node.data.y;
            link.data.targetrowdist = Math.abs(nodeRowNo - sourceRowNo);
            if (node.data.y < sourceY) {
              link.data.targetlinkcount = tidown;
              link.data.targetlineposition = 'down';
              tidown++;
            } else {
              link.data.targetlinkcount = tiup;
              link.data.targetlineposition = 'up';
              tiup++;
            }
          }
        });
      });
    });
  }
  updateLinkTotalCountNo(){
    const allLinks = this.viewModel.dataRefineryConfig.links;
    const allNodes = this.viewModel.dataRefineryConfig.nodes;

    // Was 4 allLinks.filter() calls PER LINK (genuinely O(E^2) for E links) — replaced with
    // one O(E) pass that buckets every link by (node id, up/down position), for both source
    // and target, then O(1) Map lookups per link below. Same counts, same result, just not
    // recomputed by rescanning the whole link array for every single link.
    const sourceUpCount = new Map<string, number>();
    const sourceDownCount = new Map<string, number>();
    const targetUpCount = new Map<string, number>();
    const targetDownCount = new Map<string, number>();
    // Grouped arrays (by node id + position), used below for the weight pass — built in the
    // same O(E) pass, preserving each group's original allLinks relative order exactly like
    // .filter() would have produced.
    const sourceGroups = new Map<string, any[]>();
    const targetGroups = new Map<string, any[]>();
    allLinks.forEach(l => {
      if (l.data.sourcelineposition === 'up') { sourceUpCount.set(l.source, (sourceUpCount.get(l.source) ?? 0) + 1); }
      else if (l.data.sourcelineposition === 'down') { sourceDownCount.set(l.source, (sourceDownCount.get(l.source) ?? 0) + 1); }
      if (l.data.sourcelineposition === 'up' || l.data.sourcelineposition === 'down') {
        const key = `${l.source}|${l.data.sourcelineposition}`;
        (sourceGroups.get(key) ?? sourceGroups.set(key, []).get(key)!).push(l);
      }
      if (l.data.targetlineposition === 'up') { targetUpCount.set(l.target, (targetUpCount.get(l.target) ?? 0) + 1); }
      else if (l.data.targetlineposition === 'down') { targetDownCount.set(l.target, (targetDownCount.get(l.target) ?? 0) + 1); }
      if (l.data.targetlineposition === 'up' || l.data.targetlineposition === 'down') {
        const key = `${l.target}|${l.data.targetlineposition}`;
        (targetGroups.get(key) ?? targetGroups.set(key, []).get(key)!).push(l);
      }
    });

    allLinks.forEach(link => {
      link.data.sourcetotup   = sourceUpCount.get(link.source) ?? 0;
      link.data.sourcetotdown = sourceDownCount.get(link.source) ?? 0;
      link.data.targettotup   = targetUpCount.get(link.target) ?? 0;
      link.data.targettotdown = targetDownCount.get(link.target) ?? 0;
    });

    // Compute proportional row-distance weights: each link in a direction group
    // gets weight = rowDist / (maxDistInGroup + 1), giving unique, proportional gaps.
    allNodes.forEach(node => {
      (['up', 'down'] as const).forEach(pos => {
        const srcGroup = sourceGroups.get(`${node.id}|${pos}`) ?? [];
        if (srcGroup.length > 0) {
          const maxDist = Math.max(...srcGroup.map(l => l.data.sourcerowdist ?? 0));
          srcGroup.forEach(l => {
            l.data.sourceweight = maxDist > 0
              ? (l.data.sourcerowdist ?? 0) / (maxDist + 1)
              : 1 / (srcGroup.length + 1);
          });
        }
        const tgtGroup = targetGroups.get(`${node.id}|${pos}`) ?? [];
        if (tgtGroup.length > 0) {
          const maxDist = Math.max(...tgtGroup.map(l => l.data.targetrowdist ?? 0));
          tgtGroup.forEach(l => {
            l.data.targetweight = maxDist > 0
              ? (l.data.targetrowdist ?? 0) / (maxDist + 1)
              : 1 / (tgtGroup.length + 1);
          });
        }
      });
    });
  }
  // Column-level routing counts for 'dotted'/'joiner' edges, additional to
  // (not a replacement for) updateLinkTotalCountNo()'s per-node,
  // per-linetype counts above. Grouping is by colNo instead of by
  // individual node — a colNo can span multiple nodes stacked at different
  // rowNo — and 'dotted'/'joiner' share one combined count instead of being
  // counted separately, so two different nodes in the same visual column
  // (which today compute their offsets independently, with no awareness of
  // each other) get distinct, deterministic slots across the same shared
  // nodePadding_X half-gap. 'line' is excluded — its center slot is
  // reserved and never shares this fan-out.
  //
  // Data-layer only: does not feed into updateEdge() or the dedicated
  // dotted+up->down+dirxback===0 branch in customDagreNodesOnly.ts. Wiring
  // these values into actual routing geometry is a separate, later decision
  // — this only produces the additional deterministic fields themselves.
  // Shared deterministic ordering: primarily by the owning node's rowNo (the
  // persistent value that separates multiple nodes sharing one colNo), then by
  // row-DISTANCE from the owner (farthest other-endpoint first) — not by the
  // other endpoint's raw rcNo. Used by BOTH updateLinkCountNo() (assigning
  // sourcelinkcount/targetlinkcount for 'dotted' edges, driving each target's
  // own Segment 1/3/4 height offset) and updateColumnLineCountNo() (assigning
  // sourcepositionnumber/targetpositionnumber, driving the X-corridor fan in
  // customDagreNodesOnly.ts) — extracted to one place specifically so both
  // stay identically ordered. When they disagreed (dotted's linkcount was
  // previously left in raw/unsorted array order while positionnumber was
  // properly distance-sorted), two edges converging on the same target could
  // rank "outer" on one fan and "inner" on the other, crossing each other's
  // final approach segments. Equal distance falls back to rcNo for full
  // determinism.
  // `nodeByIdMap` lets callers that already built a lookup Map for this pass (updateLinkCountNo,
  // updateColumnLineCountNo) share it here instead of this rebuilding its own — falls back to
  // building one locally when omitted, so any other/future caller stays correct without having
  // to know about this optimization.
  private byOwnerRowThenDistance(ownerIdOf: (l: any) => string, otherIdOf: (l: any) => string, nodeByIdMap?: Map<string, any>) {
    const map = nodeByIdMap ?? new Map(this.viewModel.dataRefineryConfig.nodes.map(n => [n.id, n]));
    const nodeById = (id: string) => map.get(id);
    return (a: any, b: any) => {
      const ownerRowA = nodeById(ownerIdOf(a))?.data.rowNo ?? 0;
      const ownerRowB = nodeById(ownerIdOf(b))?.data.rowNo ?? 0;
      const rowDiff = ownerRowA - ownerRowB;
      if (rowDiff !== 0) { return rowDiff; }
      const otherRowA = nodeById(otherIdOf(a))?.data.rowNo ?? 0;
      const otherRowB = nodeById(otherIdOf(b))?.data.rowNo ?? 0;
      const distDiff = Math.abs(ownerRowA - otherRowB) - Math.abs(ownerRowA - otherRowA);
      if (distDiff !== 0) { return distDiff; }
      const aRcNo = nodeById(otherIdOf(a))?.data.rcNo ?? '0.0';
      const bRcNo = nodeById(otherIdOf(b))?.data.rcNo ?? '0.0';
      return aRcNo.localeCompare(bRcNo, undefined, { numeric: true });
    };
  }

  updateColumnLineCountNo(): void {
    const allLinks = this.viewModel.dataRefineryConfig.links;
    const allNodes = this.viewModel.dataRefineryConfig.nodes;
    const isNonLine = (l: any) => l.data?.linetype === 'dotted' || l.data?.linetype === 'joiner';
    // Built once for this call and shared with byOwnerRowThenDistance below, instead of each
    // doing its own O(N) .find() per lookup.
    const nodeByIdMap = new Map(allNodes.map(n => [n.id, n]));
    const nodeById = (id: string) => nodeByIdMap.get(id);

    const nonLineLinks = allLinks.filter(isNonLine);
    const byOwnerRowThenDistance = this.byOwnerRowThenDistance.bind(this);

    // --- Outgoing (source) side: grouped by the SOURCE node's colNo ---
    const startGroups = new Map<number, any[]>();
    nonLineLinks.forEach(link => {
      const col = nodeById(link.source)?.data.colNo;
      if (col === undefined || col === null) { return; }
      (startGroups.get(col) ?? startGroups.set(col, []).get(col)!).push(link);
    });
    startGroups.forEach(group => {
      const sorted = group.slice().sort(byOwnerRowThenDistance(l => l.source, l => l.target, nodeByIdMap));
      sorted.forEach((link, idx) => {
        link.data.totallinestart = sorted.length;
        link.data.sourcepositionnumber = idx + 1;
        // Raw per-unit step, NOT multiplied by sourcepositionnumber here — that
        // multiplication happens once, at the point of use (e.g. the seg2 dogleg
        // in customDagreNodesOnly.ts), as node_x_gap_start * sourcepositionnumber.
        // +1 in the denominator, matching every other gap formula in this file, so
        // the maximum positionnumber never reaches the exact center-line corridor
        // boundary (nodePadding_X/2) — only ever gets close to it.
        const nodePaddingX = nodeById(link.source)?.data.nodePadding_X ?? 0;
        link.data.node_x_gap_start = (nodePaddingX / 4) / (sorted.length + 1);
      });
    });

    // --- Incoming (target) side: grouped by the TARGET node's colNo ---
    const endGroups = new Map<number, any[]>();
    nonLineLinks.forEach(link => {
      const col = nodeById(link.target)?.data.colNo;
      if (col === undefined || col === null) { return; }
      (endGroups.get(col) ?? endGroups.set(col, []).get(col)!).push(link);
    });
    endGroups.forEach(group => {
      const sorted = group.slice().sort(byOwnerRowThenDistance(l => l.target, l => l.source, nodeByIdMap));
      sorted.forEach((link, idx) => {
        link.data.totallineend = sorted.length;
        link.data.targetpositionnumber = idx + 1;
      });
    });
  }
  async getNodeTransformNames() {
    var ingestNodes=this.viewModel.dataRefineryConfig.nodes.filter(node=>node.data.nodeboxtypeid===1);
    const guids: string[] = ingestNodes
      .map(node => node.data.configGuid)
      .filter(guid => !!guid);// removes null/undefined
    const configJson = await this.configService.getRefineryAllConfigs(guids); 

    this.viewModel.dataRefineryConfig.nodes.forEach(node => {
      const ingestNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id === node.data.ingestId);
      const config = configJson.find(cfg => cfg.guid === ingestNode?.data?.configGuid);

      let subtitle = "";

      // 🔄 Default to showing NAME, so toggle will offer "Show Transformer Type"
      if (this.transformerToggleState[node.id] === undefined) {
        this.transformerToggleState[node.id] = false;
      }

      const showType = this.transformerToggleState[node.id]; // false = show name

      // Default subtitles
      if (node.data.nodeboxtypeid === 1) {
        subtitle = "**No Connector Added**";
      } else if (node.data.nodeboxtypeid === 2) {
        subtitle = "**No Transformers Added**";
      } else if (node.data.nodeboxtypeid === 4) {
        subtitle = node.data.farmtypeid === 2 ? "SubTask->Task" :
                  node.data.farmtypeid === 3 ? "Task->Activity" : "";
      }

      if (config) {
        if (node.data.nodeboxtypeid === 1) {
          const dataConnector = config.dataConnectorMappings.find(x => x.guid === config.selectedIngestFarmGuid);
          if (dataConnector && dataConnector.name) {
            subtitle = `${dataConnector.name} - ${DataConnectorType[dataConnector.dataConnector.dataConnectorType]}`;
          }
        }

        if (node.data.nodeboxtypeid === 2) {
          var names="";
              config.transforms.filter(trans=>trans.nodeID==node.id).sort((a,b)=>a.index-b.index).forEach(transform=>{
                names=names+transform.name+" > ";
              })
              if(names!=""){
                subtitle=names.replace(/>\s*$/, "");
              }
        }
      }

      node.data.subtitle = subtitle;

      // 🔁 Set toggle label: what user will see NEXT
      this.transformerToggleLabels[node.id] = showType
        ? 'Show Transformer Name'
        : 'Show Transformer Type';
    });
  }
  updateRowColNos(): void {
    let rowNo = 1;
    const ingestNodes = this.viewModel.dataRefineryConfig.nodes.filter(n => n.data.parentid == 0)
      .sort((a, b) => (a.data.farmtypeid || 0) - (b.data.farmtypeid || 0));

    ingestNodes.forEach(ingest => {
      let colNo = 1;
      ingest.data.rcNo = `${rowNo}.${colNo}`;
      ingest.data.Descriptor = `${rowNo}.${colNo} ${this.GetFarmName(ingest.data.farmtypeid)}: ${this.GetNodeBoxName(ingest.data.nodeboxtypeid)}`;

      const visited = new Set<string>();
      const queue: string[] = [ingest.id];

      while (queue.length > 0) {
        const id = queue.shift()!;
        if (visited.has(id)) continue;
        visited.add(id);

        const children = this.viewModel.dataRefineryConfig.nodes.filter(n => n.data.parentid === id);
        children.forEach(child => {
          colNo++;
          child.data.rcNo = `${rowNo}.${colNo}`;
          child.data.Descriptor = `${rowNo}.${colNo} ${this.GetFarmName(child.data.farmtypeid)}: ${this.GetNodeBoxName(child.data.nodeboxtypeid)}`;
          queue.push(child.id);
        });
      }

      rowNo++;
    });
  }
  updatePositionRowColNos(): void {
    const uniqueX = [...new Set(this.viewModel.dataRefineryConfig.nodes.map(n => n.data.x as number))].sort((a, b) => a - b);
    const uniqueY = [...new Set(this.viewModel.dataRefineryConfig.nodes.map(n => n.data.y as number))].sort((a, b) => a - b);

    const colRank = new Map(uniqueX.map((x, i) => [x, i + 1]));
    const rowRank = new Map(uniqueY.map((y, i) => [y, i + 1]));

    this.viewModel.dataRefineryConfig.nodes.forEach(node => {
      node.data.colNo = colRank.get(node.data.x) ?? 1;
      node.data.rowNo = rowRank.get(node.data.y) ?? 1;
    });
  }
  compactRows(): void {
    const initialY = this.viewModel.nodeHeight / 2 + this.viewModel.nodePadding_Y + 20;
    let changed = true;
    while (changed) {
      changed = false;

      const ingestIds = [...new Set(this.viewModel.dataRefineryConfig.nodes.map(n => n.data.ingestId as string))];
      const groups = ingestIds
        .map(id => ({
          id,
          nodes: this.viewModel.dataRefineryConfig.nodes.filter(n => n.data.ingestId === id),
          minY: Math.min(...this.viewModel.dataRefineryConfig.nodes.filter(n => n.data.ingestId === id).map(n => n.data.y as number))
        }))
        .sort((a, b) => a.minY - b.minY);

      for (const group of groups) {
        if (group.minY <= initialY) continue;

        const otherYX = new Set(
          this.viewModel.dataRefineryConfig.nodes
            .filter(n => n.data.ingestId !== group.id)
            .map(n => `${n.data.y},${n.data.x}`)
        );

        const hasConflict = group.nodes.some(n =>
          otherYX.has(`${(n.data.y as number) - this.nodepaddingy},${n.data.x}`)
        );

        if (!hasConflict) {
          group.nodes.forEach(n => {
            n.data.y = (n.data.y as number) - this.nodepaddingy;
          });
          group.minY -= this.nodepaddingy;
          changed = true;
        }
      }
    }
    this.updatePositionRowColNos();
  }

  async getUniqueLinkForAttribution() {
    // Step 1: Deep clone the links to avoid mutating the original array
    const clonedLinks = _.cloneDeep(this.viewModel.dataRefineryConfig.links);
    const uniqueLinksMap = new Map<string, any>();
    const duplicateLinks: Edge[] = [];

    // Step 2: Process the cloned links
    for (const link of clonedLinks) {
      const key = `${link.source}-${link.target}`; // Unique key for source-target pair

      if (uniqueLinksMap.has(key)) {
        duplicateLinks.push(link);
      }

      if (!uniqueLinksMap.has(key) || link.data.linetype === 'line') {
        uniqueLinksMap.set(key, link); // Store the cloned link
      }
    }
    // Step 3: Create filtered links without modifying the original
    this.filterlinks = Array.from(uniqueLinksMap.values());
    // Step 4: Update duplicates to "doubleline"
    for (const link of duplicateLinks) {
      const linelink = this.filterlinks.find(
        (lnk) => lnk.source === link.source && lnk.target === link.target
      );
      if (linelink) {
        linelink.data.linetype = 'doubleline';
      }
    }
  }

  
  /**
   * Set the Variables for product setting and to create all the shapes
   * TODO: After we save these in config files, it will fetch from there
   * We will set these for differnt shapes below
   */
  public nodeTopLengthRatio_Per: number = 1;
  public nodeBottomLengthRatio_Per: number = 1;
  public nodeTopHeightRatio_Per: number = 1;
  public nodeBottomHeightRatio_Per: number = 1;
  public invertedNode: boolean = false;

  public points: string = '';

  public dwPadY = 0.1
  public dwPadX = 0.1
  public DataWriter_X = 1;
  public DataWriter_Y = 1;

  public nodeId_X: number = 1;
  public nodeId_Y: number = 1;


  /**
   * * This viewModel.dataRefineryConfig holds all the flowchart with nodes and datapipes
   * @param nodes: this contains all the node boxes
   * @param links: this holds all the connector lines from node box to box
   * TODO: Will save this in config to save the whole Refinery Data Flow Diagramre
   */
  //viewModel.dataRefineryConfig = { nodes: this.nodes, links: this.links }
  //viewModel.dataRefineryConfig = { nodes: [], links: [] }

  // Master data for the Refinery flow boxes and farm types — populated from the
  // server via loadMasterConfigs() (ConfigService.getMasterConfigs()), not hardcoded.
  nodeboxtype: NodeBoxType[] = [];
  farmtype: FarmType[] = [];

  /**
   * Method gate the Refinery box shape according to its type
   * @param nodeboxtypeid: number : id of the Refinery box (1-4)
   * @returns: string: It will return the corinate points to create the
   */
  NodeBoxShape(nodeboxtypeid: number) {
    if (nodeboxtypeid == 1) { // Ingest
      this.nodeTopLengthRatio_Per = 0.75;
      this.nodeBottomLengthRatio_Per = 1;
      this.nodeTopHeightRatio_Per = 0.25;
      this.nodeBottomHeightRatio_Per = 0.75;
      this.invertedNode = true;
    }
    if (nodeboxtypeid == 2) { // Processor
      this.nodeTopLengthRatio_Per = 1;
      this.nodeBottomLengthRatio_Per = 1;
      this.nodeTopHeightRatio_Per = 0;
      this.nodeBottomHeightRatio_Per = 1;
      this.invertedNode = false;
    }
    if (nodeboxtypeid == 3 || nodeboxtypeid == 5) { // Joiner
      this.nodeTopLengthRatio_Per = 0.75;
      this.nodeBottomLengthRatio_Per = 0.75;
      this.nodeTopHeightRatio_Per = 0.5;
      this.nodeBottomHeightRatio_Per = 0.5;
      this.invertedNode = false;
    }
    if (nodeboxtypeid == 4) { // Converter
      this.nodeTopLengthRatio_Per = 0;
      this.nodeBottomLengthRatio_Per = 0;
      this.nodeTopHeightRatio_Per = 0.1;
      this.nodeBottomHeightRatio_Per = 0.1;
      this.invertedNode = false;
    }
    if (nodeboxtypeid == 5) { // Data writer
      this.nodeTopLengthRatio_Per = 0.75;
      this.nodeBottomLengthRatio_Per = 1;
      this.nodeTopHeightRatio_Per = 0.25;
      this.nodeBottomHeightRatio_Per = 0.75;
      this.invertedNode = false;
    }

    var titlePadX = this.viewModel.titlePadXPer  ;
    var titlePadY = this.viewModel.titlePadYPer  ;
    var subtitlePadX = this.viewModel.subTitlePadXPer  ;
    var subtitlePadY = this.viewModel.subTitlePadYPer  ;


    var dataWriterPos = this.GetDataWriterPosition(this.nodeBottomHeightRatio_Per, this.nodeBottomLengthRatio_Per, this.invertedNode);
    var gearPos = this.GetGearPosition(this.nodeTopHeightRatio_Per, this.nodeTopLengthRatio_Per, this.invertedNode);
    var StatusPos = this.GetStatusPosition(this.nodeBottomHeightRatio_Per, this.nodeBottomLengthRatio_Per, this.invertedNode);
    var TitleSubTitlePos = this.GetTitleSubTitlePosition(titlePadY, titlePadX, subtitlePadY, subtitlePadX, this.invertedNode, this.nodeTopHeightRatio_Per, this.nodeBottomHeightRatio_Per) ;
    var NodeIDPos = this.GetNodeIDPosition(this.nodeTopLengthRatio_Per, this.nodeBottomLengthRatio_Per, this.nodeBottomHeightRatio_Per, this.nodeTopHeightRatio_Per, this.invertedNode ) ;

    if (this.invertedNode == true) {
      this.points = this.viewModel.nodeWidth + " 0, " + this.viewModel.nodeWidth + " " + this.viewModel.nodeHeight + ", " + (1 - this.nodeBottomLengthRatio_Per) * this.viewModel.nodeWidth + " " + this.viewModel.nodeHeight + ", 0 " + (1 - this.nodeBottomHeightRatio_Per) * this.viewModel.nodeHeight + ", 0 " + (this.nodeTopHeightRatio_Per) * this.viewModel.nodeHeight + ", " + (1 - this.nodeTopLengthRatio_Per) * this.viewModel.nodeWidth + " 0" + ""

    } else {
      this.points = "0 0, " + this.nodeTopLengthRatio_Per * this.viewModel.nodeWidth + " 0, " + this.viewModel.nodeWidth + " " + (this.nodeTopHeightRatio_Per) * this.viewModel.nodeHeight + ", " + this.viewModel.nodeWidth + " " + (1 - this.nodeBottomHeightRatio_Per) * this.viewModel.nodeHeight + ", " + this.nodeBottomLengthRatio_Per * this.viewModel.nodeWidth + " " + this.viewModel.nodeHeight + ", 0 " + this.viewModel.nodeHeight + ""

    }

    var returnData = {
      "points": this.points,
      "DataWriter_X": dataWriterPos.DataWriter_X,
      "DataWriter_Y": dataWriterPos.DataWriter_Y,
      "Gear_X": gearPos.Gear_X,
      "Gear_Y": gearPos.Gear_Y,
      "Status_Width": StatusPos.Status_Width,
      "Status_X": StatusPos.Status_X,
      "Status_Y": StatusPos.Status_Y,
      "Title_Y": TitleSubTitlePos.Title_Y,
      "Title_X": TitleSubTitlePos.Title_X,
      "SubTitle_X": TitleSubTitlePos.SubTitle_X,
      "SubTitle_Y": TitleSubTitlePos.SubTitle_Y,
      "nodeId_X": NodeIDPos.nodeId_X,
      "nodeId_Y": NodeIDPos.nodeId_Y

    };
    return returnData;
  }

  GetNodeIDPosition(topLengthRatio: number, bottomLengthRatio: number, bottomHeightRatio: number, topHeightRatio: number, invertedNode: boolean ){
    var nodeIdPadY = Math.round(this.viewModel.nodeHeight * (this.viewModel.nodeIDPadYPer/100) );
    var nodeIdPadX = Math.round(this.viewModel.nodeWidth * (this.viewModel.nodeIDPadXPer/100) ); 

    var NodeIdScale = 0.035
    var nodeIdSize = Math.round(NodeIdScale * this.viewModel.nodeHeight) ;

    var posY = 0;
    var posX = 0;


    if ((topHeightRatio * this.viewModel.nodeHeight) == (1 - bottomHeightRatio) * this.viewModel.nodeHeight) {
      posY = Math.round(this.viewModel.nodeHeight);

    } else {
      posY = Math.round((1-bottomHeightRatio) * this.viewModel.nodeHeight);
    }


    if (invertedNode == true) { // Will write
      posX = this.viewModel.nodeWidth - Math.round(this.nodeBottomLengthRatio_Per * this.viewModel.nodeWidth);

    }


    this.nodeId_X = posX + (1 + nodeIdPadX);
    this.nodeId_Y = posY - nodeIdSize * (1 + nodeIdPadY);

    var returnData = {
      "nodeId_X": this.nodeId_X,
      "nodeId_Y": this.nodeId_Y
    };

    return returnData;
  }

  /**
    * Use this function to get the X and Y position of the Data Writer icon.
    * Using the mmaths (given by Scott) to calculate the values as per DT-494
    * @param bottomHeightRatio 
    * @param bottomLengthRatio 
    * @returns: Json -  X and Y position for the DataWriter icons
  */
  GetDataWriterPosition(bottomHeightRatio: number, bottomLengthRatio: number, invertedNode: boolean) {
    var posY = 0;
    var posX = 0;


    if (invertedNode == true) {
      posY = this.viewModel.nodeHeight;
      posX = this.viewModel.nodeWidth;


    } else if ((this.nodeTopHeightRatio_Per) * this.viewModel.nodeHeight == (1 - bottomHeightRatio) * this.viewModel.nodeHeight) {

      posY = Math.round(this.viewModel.nodeHeight);
      posX = Math.round(this.nodeBottomLengthRatio_Per * this.viewModel.nodeWidth);


    } else {
      posY = Math.round((1-bottomHeightRatio) * this.viewModel.nodeHeight);
      posX = Math.round(this.viewModel.nodeWidth);
    }


    this.DataWriter_X = posX - this.viewModel.dataWriterSizePX * (1.03 + this.dwPadX);
    // (bottomLengthRatio - this.dwPadX) * this.viewModel.nodeWidth - this.viewModel.DatawriterSizePX;
    this.DataWriter_Y = posY - this.viewModel.dataWriterSizePX * (1.1 + this.dwPadY);
    //(1 - this.dwPadY) * this.viewModel.nodeHeight - this.viewModel.DatawriterSizePX - xLPad;

    var returnData = {
      "DataWriter_X": this.DataWriter_X,
      "DataWriter_Y": this.DataWriter_Y
    };

    return returnData;

  }

  /**
    * Use this function to get the X and Y position of the Data Writer icon.
    * Using the mmaths (given by Scott) to calculate the values as per DT-494
    * @param topHeightRatio 
    * @param topLengthRatio 
    * @returns: Json -  X and Y position for the DataWriter icons
  */
  GetGearPosition(topHeightRatio: number, topLengthRatio: number, invertedNode: boolean) {

    var gearPadY = 0.2;
    var gearPadX = 0.2;

    var posY = 0;
    var posX = 0;

    if (invertedNode == true) {
      posY = 0
      posX = this.viewModel.nodeWidth;


    } else if ((topLengthRatio * this.viewModel.nodeWidth) == 0) {

      posY = Math.round(topHeightRatio * this.viewModel.nodeHeight);
      posX = Math.round(this.viewModel.nodeWidth);


    } else {
      posY = 0
      posX = Math.round(topLengthRatio * this.viewModel.nodeWidth);
    }

    var Gear_X = posX - this.viewModel.nodeGearSizePX * (1 + gearPadX);
    //(topLengthRatio - gearPadX) * this.viewModel.nodeWidth - this.viewModel.nodeGearSizePX;
    var Gear_Y = posY + this.viewModel.nodeGearSizePX * gearPadY;
    //gearPadY * this.viewModel.nodeHeight + xLPad ;

    var returnData = {
      "Gear_X": Gear_X,
      "Gear_Y": Gear_Y
    };
    return returnData;

  }

  GetStatusPosition(bottomHeightRatio: number, bottomLengthRatio: number, invertedNode: boolean) {

    var stHeight = 15;
    var stWidth = 55;
    var stPadX = 0.4;
    var stPadY = 0.1;

    var posY = 0;
    var posX = 0;

    if (invertedNode == true) {
      posY = this.viewModel.nodeHeight;
      posX = this.viewModel.nodeWidth;


    } else if ((this.nodeTopHeightRatio_Per) * this.viewModel.nodeHeight == (1 - this.nodeBottomHeightRatio_Per) * this.viewModel.nodeHeight) {

      posY = Math.round(this.viewModel.nodeHeight);
      posX = Math.round(this.nodeBottomLengthRatio_Per * this.viewModel.nodeWidth);


    } else {
      posY = Math.round((1-this.nodeBottomHeightRatio_Per) * this.viewModel.nodeHeight);
      posX = Math.round(this.viewModel.nodeWidth);
    }

    if (posY < this.viewModel.nodeHeight) {
      stPadY = stPadY * (1 + stWidth / 100) * (1 + bottomHeightRatio) * (1 + bottomLengthRatio)
    }
    // var Status_X = Math.round(posX - stWidth * (1 + stPadX));
    var Status_X = Math.round(posX   *  stPadX);
    var Status_Y = Math.round(posY + stHeight * stPadY);
    var Status_Width = Math.round(Status_X + (Status_X *  0.5)   );

    var returnData = {
      "Status_Width": Status_Width,
      "Status_X": Status_X,
      "Status_Y": Status_Y
    };
    return returnData;

  }

  GetTitleSubTitlePosition(titlePadY: number, titlePadX: number, subtitlePadY: number, subtitlePadX: number, invertedNode:boolean, topHeightRatio: number, bottomHeightRatio: number ) {

    var posY = 0
    var posX = 0
   // var subtitlePadY = 0.1
   // var subtitlePadX = 0.02
   if (invertedNode == true) {
     if ( (this.viewModel.nodeWidth == (1-this.nodeBottomLengthRatio_Per) * this.viewModel.nodeWidth ) || (topHeightRatio + bottomHeightRatio < 0.5) ) {
       posX = 0 ;
       posY = Math.round(topHeightRatio * this.viewModel.nodeHeight );
     } else {
       posX = (1-this.nodeTopLengthRatio_Per) * this.viewModel.nodeWidth ;
       posY = 0;
     }
   } else {
     posX = 0 ;
     posY = 0;
     if (this.nodeTopLengthRatio_Per < 0.5) {
      posY =  Math.round(topHeightRatio * this.viewModel.nodeHeight);
      //  titlePadY =  titlePadY/5 * (1 + topHeightRatio * 5 * (1 - this.nodeTopLengthRatio_Per))
       
     }
   
   }

   var Title_X = posX + this.viewModel.nodeFontSizeTitle  * (titlePadX/5) ;
   var Title_Y = Math.round(posY +  this.viewModel.nodeFontSizeTitle * titlePadY/5 );
   // var Title_Y = (this.viewModel.nodeHeight - posY + this.viewModel.nodeFontSizeTitle) * titlePadY ;

   var SubTitle_X = posX + this.viewModel.nodeFontSizeTitle  * (subtitlePadX/5) ;
   var SubTitle_Y =  Math.round( Title_Y + this.viewModel.nodeFontSizeTitle * (1+subtitlePadY/5) );

   var returnData = {
     "Title_X": Title_X,
     "Title_Y": Title_Y,
     "SubTitle_X": SubTitle_X,
     "SubTitle_Y": SubTitle_Y
   };

   return returnData;

 }


  /**
   * Method to get the color for the farm type
   * @param farmtypeid: number : This is the farmtpye (like: Case, Task) master id
   * @returns:string: the style for the Refinery box according to farm type
   */
  FarmTypeColor(farmtypeid: number) {
    var ft = this.farmtype.find(x => x.id == farmtypeid);
    if (!ft) return '';
    return ft.color ;
  }
  FarmTypeIconPath(farmtypeid: number) {
    var ft = this.farmtype.find(x => x.id == farmtypeid);
    if (!ft) return '';
    return ft.iconpath ;
  }
  FarmTypeProcessorIconPath(farmtypeid: number) {
    var ft = this.farmtype.find(x => x.id == farmtypeid);
    if (!ft) return '';
    return ft.processoriconpath ;
  }
  FarmTypeIngestIconPath(farmtypeid: number) {
    var ft = this.farmtype.find(x => x.id == farmtypeid);
    if (!ft) return '';
    return ft.ingesticonpath ;
  }
  /**
   * Method to get the color for the farm type
   * @param farmtypeid: number : This is the farmtpye (like: Case, Task) master id
   * @returns:string: the style for the Refinery box according to farm type
   */
  NodeBoxColor(farmtypeid: number) {
    var ft = this.farmtype.find(x => x.id == farmtypeid);
    if (!ft) return '';
    return "fill: #000000;stroke: " + ft.color + ";stroke-width: " + this.viewModel.nodeBorderStroke + "; pointer-events: all !important;";
  }
  /**
   * Method to get the fram type name from id
   * @param farmtypeid : number: This is the farmtpye (like: Case, Task) master id
   * @returns : string: Farm type name
   */
  GetFarmName(farmtypeid: number) {
    var ft = this.farmtype.find(x => x.id == farmtypeid);
    if (!ft) return '';
    return ft.farmtype;
  }
  GetNodeBoxName(nodeboxtypeid: number) {
    var ft = this.nodeboxtype.find(x => x.id == nodeboxtypeid);
    if (!ft) return '';
    return ft.nodetype;
  }
  /**
   * Onselect Method: This method will be called when we select on the Refinery node box
   * @param event : the full event for the Refinery node box
   * TODO: Currently we are just setting rhe id and name, this we will use this more in future
   */
  onNodeSelect(event: any) {
    this.id = event.id;
    //this.name=event.label;
  }
  //Create Ingest node
  /**
   * This method is used to create a Refinery node box
   * @param farmtypeid : number : master farmtype id, will decide the color
   * @param farmtype : string : farmtype name, will show the type on the Refinery node box
   * @param nodeboxtypeid :number: master notebox type id, will decide the shape
   */
  async createIngest(farmtypeid: number, farmtype: string, nodeboxtypeid: number) {
    //get length unique farmtype
    const unique = [...new Set(this.viewModel.dataRefineryConfig.nodes.map((item) => item.data.farmtypeid))];

    var node = {
      id: "n" + uuidv4(),
      label: "",
      data: { farmtypeid: farmtypeid, nodeboxtypeid: nodeboxtypeid, subtitle: farmtype, isdbupdater: false, parentid: "0", isEditTitle: true, isEditSubtitle: false, dbWriterType: 'none', nodecolorno: 0, nodeStatus: NodeRunStatus.Idle }
    };
    const isFirstNode = this.viewModel.dataRefineryConfig.nodes.length === 0;
    this.viewModel.dataRefineryConfig.nodes.push(node);
    this.viewModel.dataRefineryConfig.nodes = [...this.viewModel.dataRefineryConfig.nodes];
    await this.positioningNodes();
    this.cdr.detectChanges();
    if (isFirstNode) {
      // ngx-graph needs two update cycles to initialize its layout engine on first node
      setTimeout(() => {
        this.update$.next(true);
        this.cdr.detectChanges();
        setTimeout(() => {
          this.update$.next(true);
          this.cdr.detectChanges();
          this.editTitle(node.id);
        }, 150);
      }, 100);
    } else {
      setTimeout(() => {
        this.update$.next(true);
        this.cdr.detectChanges();
        this.editTitle(node.id);
      }, 100);
    }
  }

  /** Create Processor node
   * This method is called to create the Refinery node box of all the farmtype
   * @param nodeboxtypeid
   * @returns
   */
  async createProcessor(nodeboxtypeid: number):Promise<void> {
    var eventname="";
    if(nodeboxtypeid==2){
      eventname="Add Processor";
    }else if(nodeboxtypeid==3){
      eventname="Add Joiner";
    }
    else if(nodeboxtypeid==4){
      eventname="Add Converter";
    }
    await this.UndoBuffer(eventname);

    var nodeid = "n" + uuidv4();
    var linkid = "l" + uuidv4();
    var currentDateTime =  this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

    var nbt = this.nodeboxtype.find(x => x.id == nodeboxtypeid);
    if (!nbt) return;

    var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.id);
    if (!nd) return;
    var Newfarmtypeid: any = nd.data.farmtypeid;

    /** Farmtype for Adding converter.  'Converter'= 4 */
    if (nodeboxtypeid == 4) {

      if (nd.data.farmtypeid == 1) {
        Newfarmtypeid = 2;
      } else if (nd.data.farmtypeid == 2) {
        Newfarmtypeid = 3;
      } else {
        Newfarmtypeid = nd.data.farmtypeid;
      }
    }
    /** joiner node count.  'Joiner'= 3  for line color  */
    // var joinernodecount = 0;
    // if (nodeboxtypeid == 3) {
    //   var joinernodecount = this.viewModel.dataRefineryConfig.nodes.filter(x => x.data.nodeboxtypeid == 3).length + 1000;
    // }

    /** Now putting color for all boxes. so commenting the if nodeboxtypeid == 3 */

    var joinernodecount = this.viewModel.dataRefineryConfig.nodes.length + 999;

    var node = {
      id: nodeid,
      label: "",
      data: { farmtypeid: Newfarmtypeid, nodeboxtypeid: nodeboxtypeid, subtitle: nbt.nodetype, isdbupdater: false, parentid: this.id, isEditTitle: true,
               isEditSubtitle: false, dbWriterType: 'none', nodecolorno: joinernodecount, nodeStatus: NodeRunStatus.Idle, createdDateTime: currentDateTime,
               lastSaveddDateTime: currentDateTime  },
      dimension: { height: this.viewModel.nodeHeight, width: this.viewModel.nodeWidth }
    };

    var countno = this.viewModel.dataRefineryConfig.links.filter(x => x.source == this.id).length + 1;
    if (countno > 0) {
      var lnks = this.viewModel.dataRefineryConfig.links.filter(x => x.source == this.id && x.data.countno == 1).length;
      if (lnks == 0) {
        countno = 1;
      }
      else {
        countno = countno + 1;
      }
    }
    else {
      countno = countno + 1;
    }

    var link = {
      id: linkid,
      source: this.id,
      target: nodeid,
      label: '',
      data: { linetype: "line", linkcolorno: joinernodecount, countno: countno }
    }
    // Insert the new node after the existing node
    const existinglinks = this.viewModel.dataRefineryConfig.links.filter(lnk => lnk.source == this.id);
    var nextIndex=existinglinks.length+1;
    const existingIndex = this.viewModel.dataRefineryConfig.nodes.findIndex(x => x.id == this.id);
    this.viewModel.dataRefineryConfig.nodes.splice((existingIndex+nextIndex), 0, node);
    //this.viewModel.dataRefineryConfig.nodes.push(node);
    
    this.viewModel.dataRefineryConfig.links.push(link);
    this.positioningNodes();
    this.update$.next(true);
    this.focusEditTitle(node.id);
  }
  /**   Create joiner
   * This method is called to the existing joiner
   * @param id : number : id of the target joiner Refinery box
   */
  async createJoiner(id: string):Promise<void> {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    var nodecolorno = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id);
    var countno = this.viewModel.dataRefineryConfig.links.filter(x => x.source == this.id).length+1;
    if (countno == 1) {
      countno = 2;
    }
    else {
      countno = countno + 1;
    }
    if (!nodecolorno) return;

    var link = {
      id: "j" + uuidv4(),
      source: this.id,
      target: id,
      label: '',
      data: { linetype: "joiner", linkcolorno: nodecolorno.data.nodecolorno, countno: countno }
    }
    this.viewModel.dataRefineryConfig.links.push(link);
    this.positioningNodes();
    await this.updateParentChildNodesStatus(id);
    await this.updateNodeStatusNotConfigured(id);
    var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
    this.update$.next(true);
  }

  /** Delete Joiner to
   * This method is called to delete the data pipe to a Exiting joiner
   * @param id: string: Id of the Joiner
  */
  async deleteJoiner(id: string):Promise<void> {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    this.viewModel.dataRefineryConfig.links.forEach((value, index) => {
      if (value.source == this.id && value.target == id) {
        this.viewModel.dataRefineryConfig.links.splice(index, 1);
      }
    });

    this.viewModel.dataRefineryConfig.nodes = [...this.viewModel.dataRefineryConfig.nodes];
    this.viewModel.dataRefineryConfig.links = [...this.viewModel.dataRefineryConfig.links];
    this.positioningNodes();
    await this.updateParentChildNodesStatus(id);
    await this.updateNodeStatusNotConfigured(id);
    var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
    this.update$.next(true);
  }

  /**  Delete Node & Children
   * This method is used to delete a pipeline
   * @param nodeid : string : id of thr Refinery node box id
   */
  async deleteNodeChildren():Promise<void> {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    await this.UndoBuffer("Delete Node & Children");
  // Find the primary node using this.id and retrieve its rcno
  const primaryNode = this.viewModel.dataRefineryConfig.nodes.find(node => node.id === this.id)
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: { 
        title: 'Delete', 
        message: `Delete this Node ${primaryNode?.data.rcNo} (${primaryNode.label}) and all children (downstream) nodes along with it?`
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        // Code to delete the item

        var nodeids: string[] = [this.id];
        let i: number = 0;
        do {
          var nodeid = nodeids[i];

          //var node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == nodeid);
          var childnodes = this.viewModel.dataRefineryConfig.nodes.filter(x => x.data.parentid == nodeid);
          if (childnodes) {
            childnodes.forEach(x => {
              nodeids.push(x.id);
            });
          }
          var sourcelinks = this.viewModel.dataRefineryConfig.links.filter(x => x.source == nodeid);
          if (sourcelinks) {
            sourcelinks.forEach((value, index) => {
              if (!value.id) return;
              this.removeElementFromLinks(value.id);
            });
          }
          var targetlinks = this.viewModel.dataRefineryConfig.links.filter(x => x.target == nodeid);
          if (targetlinks) {
            targetlinks.forEach((value, index) => {
              if (!value.id) return;
              this.removeElementFromLinks(value.id);
            });
          }
          this.removeElementFromNodes(nodeid);
          i++;
        } while (i < nodeids.length);
        this.viewModel.dataRefineryConfig.nodes = [...this.viewModel.dataRefineryConfig.nodes];
        this.viewModel.dataRefineryConfig.links = [...this.viewModel.dataRefineryConfig.links];
        var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
        this.positioningNodes();
      }
    });

  }
  /**
   * Delete All the connecting Refinery nodes when delete one Refinery node
   * @param key :string : id of the Refinery node box
   */
  async removeElementFromNodes(key: string) {
    this.viewModel.dataRefineryConfig.nodes.forEach((value, index) => {
      if (value.id == key) {
        this.viewModel.dataRefineryConfig.nodes.splice(index, 1);
      }
      if(value.id == this.highLightedID ){ // THis condition checking when node deleteing check for data preview.
        this.dataPreviewNodeID = 'No Node Selected. Choose Data Preview from Node Menu';
        this.dataPreviewNodeColor = '#FFFFFF'
      }
    });
  }
  /**
   * Delete All the connecting data pipes when delete one Refinery node
   * @param key :string : id of the Refinery node box
   */
  async removeElementFromLinks(key: string) {
    this.viewModel.dataRefineryConfig.links.forEach((value, index) => {
      if (value.id == key) {
        this.viewModel.dataRefineryConfig.links.splice(index, 1);
      }
    });
  }

  //Rename Title
  /**
   * This method is used to update the title of the Refinery node box
   * @param label : string: the new string to update the title
   */

  


 editTitle(id: string) {
  this.isMouseFocus = true;
  this.hideGearIconOver();

  const node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id);
  if (!node) return;

  node.data.isEditTitle = true;

  this.focusEditTitle(id);
}



  blankcheckTitle: boolean = true;
  RenameTitle(id: string, event: any): void {
    var node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id);
    if (!node) return;
     this.originalTitle.set(id, node.label);
    if (node.label?.length == 0) {
      if (!event.target) return;
      if (this.blankcheckTitle) {
        this.blankcheckTitle = false;
        let dialogRef = this.dialog.open(DialogBlankCheckComponent, {
          width: '250px',
          data: "Title"
        });
        dialogRef.afterClosed().subscribe(result => {
          event.target.focus();
          this.blankcheckTitle = true;
        });
      }
      return;
    }
    node.data.isEditTitle = false;

    node.data.isEditSubtitle = false;//true;
    node.data.isHighlightBlue = false;
    this.isMouseFocus = false;
    this.showGearIconOver();
    this.update$.next(true);
  }

handleEditKeydown(event: KeyboardEvent, node: any): void {
  if (event.key === 'Escape') {
    const inputId = "et" + node.id;
    const inputEl = document.getElementById(inputId) as HTMLInputElement | null;

    if (inputEl) {
      const original = this.originalTitle.get(node.id);
      if (original !== undefined) {
        node.label = original;
        inputEl.value = original; // optional
      }

      node.data.isEditTitle = false;
      node.data.isHighlightBlue = false;

      this.isMouseFocus = false; // ✅ Add this line to re-enable hover/mouseover

      event.preventDefault();
      event.stopPropagation();
    }
  }
}


focusEditTitle(id: string): void {
  setTimeout(() => {
    const input = document.getElementById("et" + id) as HTMLInputElement | null;
    if (!input) return;

    input.focus();

    // Select all ONLY when editor just opened
    if (!input.dataset['initialized']) {
      input.select();
      input.dataset['initialized'] = 'true';
    }
  }, 50);
}
onInputMouseDown(node: any, event: MouseEvent) {
  const input = event.target as HTMLInputElement;

  // single click → remove full highlight
  if (event.detail === 1) {
    setTimeout(() => {
      const pos = input.selectionStart ?? 0;
      input.setSelectionRange(pos, pos);
    });
  }
}


  idCreatForTitle(id: string) {
    return "et" + id;
  }

  async ngOnInit(): Promise<void> {
    this.refineryPreviewPanelOpenState = false;
    this.viewModel.dataRefineryConfig.nodes = [];
    this.viewModel.dataRefineryConfig.links = [];
    this.loadMasterConfigs();
    //this.loadRefineryConfigs();
    this.updateSub = this.update$.subscribe(() => {
      setTimeout(() => this.setNgxGraphResize(), 100);
    });
    if (history.state.refineryConfigGuid) {
      await this.loadConfigDetail(history.state.refineryConfigGuid);
    }
  }

  private updateSub?: Subscription;
  private modeSub?: Subscription;
  private lockLostSub?: Subscription;
  private resizeTimer: any;

  async ngAfterViewInit(): Promise<void> {

  }
  ngOnDestroy(): void {
    this.updateSub?.unsubscribe();
    this.modeSub?.unsubscribe();
    this.lockLostSub?.unsubscribe();
    clearTimeout(this.resizeTimer);
    this.stopFollowingRuns();
    this.stopRunningRefineriesRefresh();
    // Deliberately NOT releasing refinery presence here — this component is
    // destroyed on every in-app route navigation too (e.g. opening a node
    // routes to a transformer-detail page), not just on actually leaving the
    // refinery. Presence lifecycle lives in RefineryPresenceService (a root
    // singleton that survives route changes) precisely so "open a node"
    // doesn't look identical to "leave the refinery" and release the lock
    // out from under an Analyst who's still working inside it.
  }

  /**
   * Applies fresh node/dataWriter statuses (from a config already fetched by
   * the caller) into the live view model, and redraws if anything actually
   * changed since they last saw it. Shared by every caller that has a fresh
   * config in hand — whether fetched for its own decision-making (e.g.
   * runNode already pulls the latest config to check dependent-node status)
   * or purely to refresh the view before a mutating action
   * (refreshBeforeMutatingAction) — so a fresh fetch is never wasted and
   * never fetched twice for the same call.
   *
   * Deliberately silent (no "updated by another user" toast): a node's own
   * status naturally progresses (Idle → Running → Completed) as the direct,
   * expected result of a run/save/reset the Analyst just triggered — that's
   * not "someone else changed it", so a toast here fired on almost every
   * action, not just genuine external changes. Real external-change warnings
   * are handled separately and explicitly by warnAndBlockIfRefineryBusy.
   */
  private applyFreshRefineryStatuses(configJson: DataRefineryConfig | null): void {
    if (!configJson) return;
    let changed = false;
    this.viewModel.dataRefineryConfig.nodes.forEach(Node => {
      const nodeData = configJson.nodes.find(newNode => newNode.id === Node.id);
      const freshNodeStatus = nodeData?.data.nodeStatus ?? 0;
      const freshWriterStatus = nodeData?.data.dataWriterStatus ?? 0;
      if (Node.data.nodeStatus !== freshNodeStatus || Node.data.dataWriterStatus !== freshWriterStatus) {
        changed = true;
      }
      Node.data.nodeStatus = freshNodeStatus;
      Node.data.dataWriterStatus = freshWriterStatus;
    });
    if (changed) {
      this.update$.next(true);
    }
  }

  /** Fetches the latest refinery config and applies its node/dataWriter statuses. */
  private async pullLatestRefineryStatus(): Promise<DataRefineryConfig | null> {
    const refineryDetails = this.userData.getSelectedRefineryDetails();
    if (!refineryDetails?.guid) return null;

    try {
      const configJson = await this.configService.getRefineryConfigByGuidAsync(refineryDetails.guid);
      this.applyFreshRefineryStatuses(configJson);
      return configJson;
    } catch (error) {
      console.error("Error fetching refinery config:", error);
      return null;
    }
  }

  /**
   * Refreshes node/dataWriter statuses from the server immediately before a
   * mutating action (run/reset) proceeds. Freshness only matters at the
   * moment a decision or a mutating request is about to be made — not on a
   * fixed timer while a shared refinery sits open and idle — so there is no
   * background interval; this is called once, right before each such
   * action. No-op for non-shared refineries, which have no concurrent-editor
   * risk.
   */
  private async refreshBeforeMutatingAction(): Promise<void> {
    const refineryDetails = this.userData.getSelectedRefineryDetails();
    if (!refineryDetails?.guid) return;
    if (!refineryDetails.publicShared && refineryDetails.shared === 0) return;
    await this.pullLatestRefineryStatus();
  }
  /**
   * This method is used to open mat menu
   * @param menuTrigger : MatMenuTrigger: menu trigger id
   */
  disabledeletelookupmenu: boolean = true;
  deletelookupnode: Node[] = [];

  openMenu(id: string, farmtypeid: string, menuTrigger: MatMenuTrigger) {
    if (this.isMouseFocus) return;
    if (this.isRunInProgress) return;   // node actions are disabled while a run is followed
    this.showGearIconOver();
    //this.id = id;
    this.farmtypeid = farmtypeid;
    //disable button
    const nodedetail=this.viewModel.dataRefineryConfig.nodes.find(nd=>nd.id==id);
    if(nodedetail.data.nodeboxtypeid==1){

      this.InsertProcessorDisabled = true;
      this.InsertJoinerDisabled = true;
      this.RemoveNodeDisabled = true;
    }else if(nodedetail.data.nodeboxtypeid==4){
      this.InsertProcessorDisabled = false;
      this.RemoveNodeDisabled = true;
      this.InsertJoinerDisabled = true;
    }else{
      this.InsertProcessorDisabled = false;
      this.RemoveNodeDisabled = false;
      this.InsertJoinerDisabled = false;
      const linkdetail=this.viewModel.dataRefineryConfig.links.find(nd=>nd.source==id);
      if(!linkdetail){
        this.InsertJoinerDisabled = true;
      }
    }
    /** 
     * Here we are filtering the nodes for the joiner of same farmtype
    */
    this.JoinerNodeArr = [];
    this.JoinerMenuDisabled = true;

    // Filter the links where the source is the current node and store it in filteredLinks variable. 
    this.filteredLinks = this.viewModel.dataRefineryConfig.links.filter(link => link.source == id);

    this.viewModel.dataRefineryConfig.nodes.forEach((value, index) => {
      if (value.data.farmtypeid == this.farmtypeid && value.data.nodeboxtypeid == 3 && value.id != id) {
        if (this.filteredLinks.filter(filLink => filLink.target == value.id).length == 0) {
          this.JoinerMenuDisabled = false;
          this.JoinerNodeArr.push(value);

        }

      }
    });
    this.JoinerNodeArr = this.JoinerNodeArr.sort((b, a) => { return b.data.Descriptor!.localeCompare(a.data.Descriptor!); });
    /**
     * Filter for Existing joiners to delete
    */
    this.ExistingJoinerArr = [];
    this.ExistingJoinerMenuDisabled = true;

    // Filter the links where the source is the current node and store it in filteredLinks variable. 
    this.filteredLinks = this.viewModel.dataRefineryConfig.links.filter(link => link.source == id);
    
    this.viewModel.dataRefineryConfig.nodes.forEach((value, index) => {
      var targetLinks = this.viewModel.dataRefineryConfig.links.filter(link => link.target == value.id && (link.data.linetype == "line" || link.data.linetype == "joiner") );
      if (value.data.nodeboxtypeid == 3 && value.id != id) {
        if (this.filteredLinks.filter(filLink => filLink.target == value.id).length > 0 && (targetLinks.length > 1) ) {
          this.ExistingJoinerMenuDisabled = false;
          this.ExistingJoinerArr.push(value);
        }
      }
    });
    this.ExistingJoinerArr = this.ExistingJoinerArr.sort((b, a) => { return b.data.Descriptor!.localeCompare(a.data.Descriptor!); });
    /**
     * Here we are filtering for the Add Farm Converter
    */
    this.FConverterMenuDisabled = true;
    if (this.farmtypeid == '1' || this.farmtypeid == '2') {
      this.FConverterMenuDisabled = false;

    }
    /**
     * Here we are filtering for the menu for Farm Type 'Generic'
    */
    //this.FConverterMenuDisabled = true;
    if (this.farmtypeid == '7') {
      this.FConverterMenuDisabled = true;
      // this.JoinerMenuDisabled = true;
      // this.NewJoinerMenuDisabled = true;
      // this.ExistingJoinerMenuDisabled = true;
    }

    /**
     * Here we are filtering for Look ups
    */
    this.LookUpNodeArr = [];
    this.AddLookUpDisabled = true;
    // Filter the links where the source is the current node and store it in filteredLinks variable. 
    this.filteredLinks = this.viewModel.dataRefineryConfig.links.filter(link => link.source == id);

    this.viewModel.dataRefineryConfig.nodes.forEach((value, index) => {
      if (value.data.nodeboxtypeid == 2 && value.id != id) {
        if (this.filteredLinks.filter(filLink => filLink.target == value.id && filLink.data.linetype == 'dotted').length == 0) {
        //check if no line there
          //if (this.filteredLinks.filter(filLink => filLink.target == value.id && filLink.data.linetype == 'line').length == 0) {
            this.AddLookUpDisabled = false;
            this.LookUpNodeArr.push(value);
          //}
        }
      }
    });
    this.LookUpNodeArr = this.LookUpNodeArr.sort((b, a) => { return b.data.Descriptor!.localeCompare(a.data.Descriptor!); });


    //delete lookup menu filter
    this.deletelookupnode = [];
    this.disabledeletelookupmenu = true;
    var deletelookup = this.viewModel.dataRefineryConfig.links.filter(x => x.source == id && x.data.linetype == "dotted");
    if (deletelookup.length > 0) {
      this.disabledeletelookupmenu = false;
      deletelookup.forEach(link => {
        var node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == link.target);
        if (!node) return;
        this.deletelookupnode.push(node);
      });
      this.deletelookupnode = this.deletelookupnode.sort((b, a) => { return b.data.Descriptor!.localeCompare(a.data.Descriptor!); });

    }
    var node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id);
    if (!node) return;
    menuTrigger.openMenu();
  }
  /**
   * This method is used to close mat menu
   * @param menuTrigger : MatMenuTrigger: menu trigger id
   */
  closeMenu(event: any) {
    // this.nodemenuTrigger.closeMenu(); error in sub menu
    //event is undefined if you click outside
    if (!event)
      this.hideGearIconOver();
  }
  currentNodeEvent: any;
  gearelement: HTMLInputElement;
  hidegearstatus: boolean = true;
  isMouseFocus: boolean = false;
  showGearIcon(event: any, x: number, y: number, id: string, farmtypeid: string) {
    this.currentNodeEvent = event;
    this.id = id;
    this.farmtypeid = farmtypeid;
    let gearicon = event.target.childNodes[5];
    this.gearelement = gearicon;
    if (!this.isMouseFocus) {
      gearicon.setAttribute('style', "opacity: 10;");
      this.hidegearstatus = true;
    }
  }
  hideGearIcon(event: any) {
    setTimeout(() => {
      if (this.hidegearstatus) {
        let gearicon = event.target.childNodes[5];
        gearicon.setAttribute('style', "opacity: 0;");
      }
    }, 100);
  }
  showGearIconOver() {
    if (!this.gearelement) return;
    if (!this.isMouseFocus) {
      this.gearelement.setAttribute('style', "opacity: 10;");
      this.hidegearstatus = false;
    }
  }
  hideGearIconOver() {
    if (!this.gearelement) return;
    this.gearelement.setAttribute('style', "opacity: 0;");
  }
  addLookup(id: string) {
    //var sourcey = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.id)?.data.y;
    //var targety = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id)?.data.y;

    var maxlink = this.viewModel.dataRefineryConfig.links.filter(x => x.data.linetype == "dotted").sort((b, a) => { return (a.data.linkcolorno || 0) - (b.data.linkcolorno || 0); });

    if (maxlink.length == 0)
      var maxLookUpNo = 0;
    else
      maxLookUpNo = maxlink[0].data.linkcolorno;

    if (isNaN(maxLookUpNo)) {
      maxLookUpNo = 0;
    }

    var countno = this.viewModel.dataRefineryConfig.links.filter(x => x.source == this.id && x.data.linetype=="dotted").length+1;
    if (countno == 1) {
      countno = 2;
    }
    else {
      countno = countno + 1;
    }

    var link = {
      id: "l" + uuidv4(),
      source: this.id,
      target: id,
      label: '',
      data: { linetype: "dotted", lineposition: "up", linkcolorno: maxLookUpNo + 1, countno: countno }
    }
    this.viewModel.dataRefineryConfig.links.push(link);
    this.positioningNodes();
    this.update$.next(true);
  }
  deleteLookup(id: string) {
    this.viewModel.dataRefineryConfig.links.forEach((value, index) => {
      if (value.source == this.id && value.target == id && value.data.linetype== "dotted") {
        this.viewModel.dataRefineryConfig.links.splice(index, 1);
      }
    });
    this.viewModel.dataRefineryConfig.links = [...this.viewModel.dataRefineryConfig.links];
    this.positioningNodes();
    this.update$.next(true);
  }
  getColorfromPrimaryPallet(colorID: number) {
    if(colorID>1020){
      colorID=1000+(colorID-1020);
    }
    return this.PrimarycolorPallet.find(x => x.id == colorID);
  }

  ArrowColor(linkcolorid: string | undefined) {
    if (linkcolorid == null) {
      linkcolorid = "0";
    }else{
      // Threshold must match getColorfromPrimaryPallet()'s (>1020, not >1026) — otherwise a
      // linkcolorno in 1021-1026 gets remapped for the line's stroke color but not for the
      // arrowhead marker, pointing the two at different colors for the same link.
      if(parseInt(linkcolorid)>1020){
        linkcolorid=(1000+(parseInt(linkcolorid)-1020)).toString();
      }
    }
    return "url(#" + linkcolorid + ")";
  }
  getlinkpath(points: { x: number; y: number }[]): string {
    if (!Array.isArray(points) || points.length === 0) {
      return '';
    }
    const offset = 10;
    const adjustedPoints = points.map((point) => ({
      x: point.x,
      y: point.y + offset
    }));
    return adjustedPoints
      .map((pt, i) => (i === 0 ? `M${pt.x},${pt.y}` : `L${pt.x},${pt.y}`))
      .join(' ');
  }
  showSaveRefineryConfigDialog(onClosed: (configName: string, configDescription: string, refineryStatus: number) => any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { configName: this.viewModel.dataRefineryConfig.name, configDescription: this.viewModel.dataRefineryConfig.description, refineryStatus: this.viewModel.dataRefineryConfig.status };

    const dialogRef = this.matDialog.open(SaveRefineryConfigDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.name) { return; }

      // Name entered
      onClosed(result.name, result.description, result.status);
    });
  }


  resetParameters(): void {
    this.viewModel = new RefineryViewModel(
       200, 50, 0, 0, 21, 0, 30, 0, 0, 45, 45, 3, 0, 0, 0, 0, 0,
       10, 8, 10, 10, 12, 0,
       this.viewModel.dataRefineryConfig,
       2, 1, 2, 1, 4, 4
    );
    this.nodeWidthFormControl.setValue(200);
    this.nodeHeightRatioFormControl.setValue(50);
    this.nodeGearSize_PerFormControl.setValue(30);
    this.DatawriterSize_Per_FormControl.setValue(21);
    this.nodePadding_XFormControl.setValue(45);
    this.nodePadding_YFormControl.setValue(45);
    this.nodeBorderWeightFormControl.setValue(3);
    this.nodeFontSizeTitlePerFormControl.setValue(10);
    this.nodeFontSizeSubtitlePerFormControl.setValue(8);
    this.nodeFontSizeFarmTypePerFormControl.setValue(10);
    this.nodeFontSizeStatusPerFormControl.setValue(10);
    this.nodeMenuFontSizePerFormControl.setValue(12);
    this.titlePadXControl.setValue(2);
    this.titlePadYControl.setValue(1);
    this.SubTitlePadXControl.setValue(2);
    this.SubTitlePadYControl.setValue(1);
    this.NodeIDPadXControl.setValue(4);
    this.NodeIDPadYControl.setValue(4);
    this.positioningNodes();
    this.update$.next(true);
  }

  async saveRefineryConfig(): Promise<void> {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    if (this.viewModel.dataRefineryConfig.nodes.length != 0) {
      this.showSaveRefineryConfigDialog(async (configName: string, configDescription: string, refineryStatus: number) => {
        this.saveRefineryConfigServer(configName, configDescription, refineryStatus);
      });
    }
  }
  async saveRefineryConfigNoPrompt(): Promise<void> {
    if (this.viewModel.dataRefineryConfig.nodes.length != 0) {
      this.saveRefineryConfigServer(
        this.viewModel.dataRefineryConfig.name,
        this.viewModel.dataRefineryConfig.description,
        this.viewModel.dataRefineryConfig.status
      );
    }
  }
  
  async saveRefineryConfigServer(configName?: string, configDescription?: string, refineryStatus?: number): Promise<void> {
    const busyDialog = this.showBusyDialog('Saving...');
    try {
      if (!(await this.warnAndBlockIfRefineryBusy())) {
        busyDialog.close();
        return;
      }
      this.viewModel.dataRefineryConfig.name = configName;
      this.viewModel.dataRefineryConfig.description = configDescription;
      this.viewModel.dataRefineryConfig.status = refineryStatus;
      this.viewModel.dataRefineryConfig.nodeWidth = this.viewModel.nodeWidth;
      this.viewModel.dataRefineryConfig.nodeHeightRatio_Per = this.viewModel.nodeHeightRatio_Per;
      this.viewModel.dataRefineryConfig.nodeHeight = this.viewModel.nodeHeight;
      this.viewModel.dataRefineryConfig.nodeGearSizePX = this.viewModel.nodeGearSizePX;
      this.viewModel.dataRefineryConfig.dataWriterSize_Per = this.viewModel.dataWriterSize_Per;
      this.viewModel.dataRefineryConfig.dataWriterSizePX = this.viewModel.dataWriterSizePX;
      this.viewModel.dataRefineryConfig.nodeGearSize_Per = this.viewModel.nodeGearSize_Per;
      this.viewModel.dataRefineryConfig.gearPosition_X = this.viewModel.gearPosition_X;
      this.viewModel.dataRefineryConfig.gearPosition_Y = this.viewModel.gearPosition_Y;
      this.viewModel.dataRefineryConfig.nodePadding_X = this.viewModel.nodePadding_X;
      this.viewModel.dataRefineryConfig.nodePadding_Y = this.viewModel.nodePadding_Y;
      this.viewModel.dataRefineryConfig.nodeBorderWeight = this.viewModel.nodeBorderWeight;
      this.viewModel.dataRefineryConfig.nodeBorderStroke = this.viewModel.nodeBorderStroke;
      this.viewModel.dataRefineryConfig.nodeFontSizeTitle = this.viewModel.nodeFontSizeTitle;
      this.viewModel.dataRefineryConfig.nodeFontSizeSubtitle = this.viewModel.nodeFontSizeSubtitle;
      this.viewModel.dataRefineryConfig.nodeFontSizeFarmType = this.viewModel.nodeFontSizeFarmType;
      this.viewModel.dataRefineryConfig.nodeFontSizeStatus = this.viewModel.nodeFontSizeStatus;
      this.viewModel.dataRefineryConfig.nodeFontSizeTitlePer = this.viewModel.nodeFontSizeTitlePer;
      this.viewModel.dataRefineryConfig.nodeFontSizeSubtitlePer = this.viewModel.nodeFontSizeSubtitlePer;
      this.viewModel.dataRefineryConfig.nodeFontSizeFarmTypePer = this.viewModel.nodeFontSizeFarmTypePer;
      this.viewModel.dataRefineryConfig.nodeFontSizeStatusPer = this.viewModel.nodeFontSizeStatusPer;
      this.viewModel.dataRefineryConfig.nodeMenuFontSizePer = this.viewModel.nodeMenuFontSizePer;
      this.viewModel.dataRefineryConfig.menuFontSizePX = this.viewModel.menuFontSizePX;
      this.viewModel.dataRefineryConfig.titlePadXPer = this.viewModel.titlePadXPer;
      this.viewModel.dataRefineryConfig.titlePadYPer = this.viewModel.titlePadYPer;
      this.viewModel.dataRefineryConfig.subTitlePadXPer = this.viewModel.subTitlePadXPer;
      this.viewModel.dataRefineryConfig.subTitlePadYPer = this.viewModel.subTitlePadYPer;
      this.viewModel.dataRefineryConfig.nodeIDPadXPer = this.viewModel.nodeIDPadXPer;
      this.viewModel.dataRefineryConfig.nodeIDPadYPer = this.viewModel.nodeIDPadYPer;

      if(!this.viewModel.dataRefineryConfig.owner || this.viewModel.dataRefineryConfig.owner==""){
        this.viewModel.dataRefineryConfig.owner = this.userData.getUserName();
        //this.viewModel.dataRefineryConfig.organizationId = Number(localStorage.getItem('selectedOrganizationId'));
        
       this.viewModel.dataRefineryConfig.organizationId =this.userData.getSelectedOrganization();
      }
      var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
      this.viewModel.dataRefineryConfig = config;
      await this.loadRefineryConfigs();
      this.positioningNodes();
      this.update$.next(true);
      if(config.guid)
        {
          await this.saveRefineryTable(config);
        }
      //this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved refinery '${config.name}'`, 'Dismiss', {
        duration: 5000
      });
    } catch (err) {
      if (err instanceof RefineryConflictError) {
        const refineryGuid = this.viewModel.dataRefineryConfig.guid;
        this.displayWarning(err.message, 'Refinery Changed', undefined, async () => {
          if (refineryGuid) {
            await this.loadConfigDetail(refineryGuid);
          }
        });
      } else {
        this.displayError(`Failed to save '${configName}'`, 'Error', err);
      }
    } finally {
      busyDialog.close();
    }
  }
  hasError = false;
  hasConfigs = false;
  isLoadingRefineryConfigs = false;
  mappingConfigsSubject = new BehaviorSubject<DataRefineryConfig[]>(null);
  mappingConfigs = this.mappingConfigsSubject.asObservable();
  displayedColumns = ['name', 'owner' ,'createdDateTime', 'modifiedDateTime', 'status', 'description','shared','public', 'busy', 'actions'];
  RefineryStatusUtil = RefineryStatusUtil;
  // Presence snapshot for the refinery list, fetched once per list load —
  // not per row — so showing N refineries costs one request, not N.
  refineryPresenceMap: { [guid: string]: { userId: number, userName: string } } = {};
  async loadMasterConfigs(): Promise<void> {
    try {
      const masterconfigs = await this.configService.getMasterConfigs();
      this.userData.setMasterNodeBoxTypes(masterconfigs.nodeboxtypes);
      this.userData.setMasterTransformers(masterconfigs.transformers);
      this.userData.setMasterFarmtypes(masterconfigs.farmtypes);
      this.nodeboxtype = masterconfigs.nodeboxtypes;
      this.farmtype = masterconfigs.farmtypes;
    } catch (err) {
      this.displayError('Failed to load master configs', 'Error', err);
    }
  }
  /** Refineries with a run in progress on the server (any user) -- shown as a pulsing
   * "Running" in the Refinery list's Status column, refreshed while the list is open. */
  runningRefineryIds = new Set<string>();
  private runningRefineriesTimer: any = null;

  isRefineryRunning(config: DataRefineryConfig): boolean {
    return !!config?.guid && this.runningRefineryIds.has(config.guid);
  }

  private async refreshRunningRefineries(): Promise<void> {
    try {
      const jobs = await this.configService.getAllActiveRunJobs();
      this.runningRefineryIds = new Set(jobs.map(j => j.refineryId).filter(id => !!id));
    } catch {
      // A status indicator, not load-blocking: keep the last known state.
    }
  }

  /** Polls run status every 10 s while the Refinery list is open; stops when it closes. */
  private startRunningRefineriesRefresh(): void {
    if (this.runningRefineriesTimer) { return; }
    this.runningRefineriesTimer = setInterval(() => {
      if (!this.refineryListpanelOpenState) {
        this.stopRunningRefineriesRefresh();
        return;
      }
      void this.refreshRunningRefineries();
    }, 10000);
  }

  private stopRunningRefineriesRefresh(): void {
    clearInterval(this.runningRefineriesTimer);
    this.runningRefineriesTimer = null;
  }

  async loadRefineryConfigs(): Promise<void> {
    this.isLoadingRefineryConfigs = true;
    this.startRunningRefineriesRefresh();
    try {
      const [allConfigs, presenceMap] = await Promise.all([
        this.configService.getAllRefineryConfigs(),
        this.refineryPresence.getActivePresence().catch(err => {
          // Presence is a nice-to-have status indicator, not load-blocking —
          // if it fails, show the list anyway with nothing marked busy rather
          // than failing the whole list load over it.
          console.error('Failed to load refinery presence:', err);
          return {};
        }),
        this.refreshRunningRefineries()
      ]);
      const configs = allConfigs.sort((a, b) =>
        b.modifiedDateTime.getTime() - a.modifiedDateTime.getTime()
      );

      this.refineryPresenceMap = presenceMap;
      this.mappingConfigsSubject.next(configs);
      this.hasError = false;
      this.hasConfigs = configs.length > 0;

      //this.loadConfigDetail(configs[0]);
    } catch (err) {
      this.hasConfigs = false;
      this.hasError = true;
      this.displayError('Failed to load mapping configs', 'Error', err);
    } finally {
      this.isLoadingRefineryConfigs = false;
    }
  }

  isRefineryBusy(config: DataRefineryConfig): boolean {
    if (!config?.guid) return false;
    const presence = this.refineryPresenceMap[config.guid];
    // A refinery the Analyst's own session already has open isn't "busy" to
    // THEM — only flag it when someone else holds it.
    return this.refineryPresence.isBusyByAnotherUser({ isBusy: !!presence, userId: presence?.userId ?? null });
  }

  getRefineryBusyUserName(config: DataRefineryConfig): string {
    return config?.guid ? (this.refineryPresenceMap[config.guid]?.userName ?? '') : '';
  }

  /** Row-click handler for the refinery list — warns and refuses to open a
   * refinery someone else currently has open, instead of silently opening
   * into a session that's likely to hit "Refinery is Busy" moments later
   * anyway. Uses the SAME presence snapshot the list already fetched, no
   * extra round trip per click. */
  // A refinery someone else is editing is NOT blocked from opening — it
  // opens Read-Only. loadConfigDetail() -> tryAcquireEdit() already checks
  // the real, current server state (not the list's possibly-stale "busy"
  // badge) and silently falls back to Read-Only if another (user, tab)
  // holds the Edit lock. There is nothing left for this click handler to
  // gate: every refinery is always safe to open.
  async onRefineryRowClicked(config: DataRefineryConfig): Promise<void> {
    this.loadConfigDetail(config.guid);
  }
  async loadConfigDetail(guid: string): Promise<void> {
    this.stopFollowingRuns();
    this.refineryListpanelOpenState = false;
    const busyDialog = this.showBusyDialog('Downloading refinery...');
    try {
      this.userData.setRefineryId(guid);
      // "First tab in gets Edit": opening a refinery immediately tries to
      // become the Edit-lock holder. If someone else already holds it (or
      // another tab of THIS same user does), this tab quietly falls back
      // to Read-Only — no warning dialog, since losing that race on open is
      // the ordinary case, not an error, and there is no manual retry to
      // report the outcome to. Either way, nothing is mutated by the mere
      // act of viewing.
      let configJson = await this.configService.getRefineryConfigByGuidAsync(guid);
      // If Edit was granted, tryAcquireEdit resets every node to Idle server-side
      // and returns what the refinery looks like AFTER that reset — use THAT for
      // the view model below, not the pre-reset `configJson` fetched above, or
      // the reset's effect never reaches the screen (the node still renders
      // whatever status it had before the reset, e.g. "Completed" carried over
      // from an imported refinery's source environment).
      const editResult = await this.tryAcquireEdit(guid);
      if (editResult.refreshedConfig) {
        configJson = editResult.refreshedConfig;
      }
      //Save selected config in storage now on call getRefineryConfigByGuidAsync it save there
      // this.userData.setSelectedRefineryDetails(configJson);
     
      // const configs = await (await this.configService.getAllRefineryConfigs()).sort((a, b) =>
      //   b.modifiedDateTime.getTime() - a.modifiedDateTime.getTime()
      // );
      this.viewModel = new RefineryViewModel(
         configJson.nodeWidth               ?? 200
        ,configJson.nodeHeightRatio_Per     ?? 50
        ,configJson.nodeHeight              ?? 0
        ,configJson.nodeGearSizePX          ?? 0
        ,configJson.dataWriterSize_Per      ?? 21
        ,configJson.dataWriterSizePX        ?? 0
        ,configJson.nodeGearSize_Per        ?? 30
        ,configJson.gearPosition_X          ?? 0
        ,configJson.gearPosition_Y          ?? 0
        ,configJson.nodePadding_X           ?? 45
        ,configJson.nodePadding_Y           ?? 45
        ,configJson.nodeBorderWeight        ?? 3
        ,configJson.nodeBorderStroke        ?? 0
        ,configJson.nodeFontSizeTitle       ?? 0
        ,configJson.nodeFontSizeSubtitle    ?? 0
        ,configJson.nodeFontSizeFarmType    ?? 0
        ,configJson.nodeFontSizeStatus      ?? 0
        ,configJson.nodeFontSizeTitlePer    ?? 10
        ,configJson.nodeFontSizeSubtitlePer ?? 8
        ,configJson.nodeFontSizeFarmTypePer ?? 10
        ,configJson.nodeFontSizeStatusPer   ?? 10
        ,configJson.nodeMenuFontSizePer     ?? 12
        ,configJson.menuFontSizePX          ?? 0
        ,configJson
        ,configJson.titlePadXPer            ?? 2
        ,configJson.titlePadYPer            ?? 1
        ,configJson.subTitlePadXPer         ?? 2
        ,configJson.subTitlePadYPer         ?? 1
        ,configJson.nodeIDPadXPer           ?? 4
        ,configJson.nodeIDPadYPer           ?? 4
      );
      await this.positioningNodes();
      this.panelOpenState = false;
      const isFirstNode = this.viewModel.dataRefineryConfig.nodes.length <= 1;
      if (isFirstNode) {
        // ngx-graph needs two update cycles to initialize its layout engine on first node
        setTimeout(() => {
          this.update$.next(true);
          this.cdr.detectChanges();
          setTimeout(() => {
            this.update$.next(true);
            this.cdr.detectChanges();
          }, 150);
        }, 100);
      } else {
        setTimeout(() => {
          this.update$.next(true);
          this.cdr.detectChanges();
        }, 100);
      }

    } catch (err) {
      this.displayError('Failed to download refinery', 'Error', err);
    } finally {
      busyDialog.close();
    }
    // A run started before this page loaded may still be running: follow it.
    void this.resumeActiveRun(guid);
  }

  /** Attempts to become the Edit-lock holder for a refinery — "first tab in
   * gets Edit": every open silently tries this. A tab that loses the race
   * simply stays Read-Only, with no manual retry — there is no "Enter Edit
   * Mode" action; Read-Only is Read-Only until the current editor's tab
   * closes or its lock expires, at which point the NEXT open (not this
   * one) picks it up. Only on a grant does this run the node-status reset
   * that used to happen unconditionally on every open — that's a write,
   * and a Read-Only tab must never trigger one just by opening or by
   * losing a race for the lock. */
  private async tryAcquireEdit(guid: string): Promise<{ granted: boolean, holderUserName: string | null, refreshedConfig?: DataRefineryConfig }> {
    const result = await this.refineryPresence.requestEdit(guid);
    if (result.granted) {
      const resetRequest = new ResetRefineryNodesStatusRequest(guid, this.userData.getUserId(), this.refineryPresence.tabId);
      await this.configService.getresetRefineryNodesStatus(resetRequest);
      const refreshed = await this.configService.getRefineryConfigByGuidAsync(guid);
      // NOT applyFreshRefineryStatuses(refreshed) here — this method's only
      // caller (loadConfigDetail) hasn't built this refinery's view model yet
      // at this point, so merging into `this.viewModel.dataRefineryConfig`
      // would touch whatever refinery was PREVIOUSLY open (or nothing, on a
      // first-ever open) and be discarded the moment the real view model is
      // constructed. Returning the refreshed config lets the caller use it
      // directly for that construction instead.
      return { granted: result.granted, holderUserName: result.holderUserName, refreshedConfig: refreshed };
    }
    return { granted: result.granted, holderUserName: result.holderUserName };
  }

  async deleteConfig(config: DataRefineryConfig): Promise<void> {
    this.showConfirmDialog('Delete refinery config?', 'Are you sure you want to delete this refinery config?', async (result) => {
      if (result) {
        try {
          // Deleting is a mutation like any other — the backend now requires
          // holding the Edit lock, so acquire it here rather than surfacing a
          // raw 403 from a delete click that never went through Edit mode
          // (this action is reachable straight from the refinery list,
          // without ever opening the refinery first).
          const lock = await this.refineryPresence.requestEdit(config.guid);
          if (!lock.granted) {
            this.displayWarning(
              `Currently being edited by ${lock.holderUserName ?? 'another session'}. Cannot delete right now.`,
              'Refinery is Busy.'
            );
            return;
          }
          if (await this.configService.deleteRefineryConfigByGuid(config.guid)) {
            this.refineryPresence.stop();
            this.snackBar.open(`Successfully deleted refinery config`, 'Dismiss', {
              duration: 5000
            });
            //this.router.navigate(['/configs']);
            await this.loadRefineryConfigs();
            // if (this.viewModel.dataRefineryConfig.guid == config.guid) {
              this.viewModel.dataRefineryConfig = new DataRefineryConfig();
              this.viewModel.dataRefineryConfig.nodes = [];
              this.viewModel.dataRefineryConfig.links = [];
            // }
            // else {
            //   this.loadConfigDetail(this.viewModel.dataRefineryConfig);
            // }
          }
        } catch (err) {
          this.displayError('Failed to delete the config', 'Error', err);
        }
      }
    });
  }
  //Run Refinery
  /** Runs this page is following (a Run Node can run upstream nodes in sequence, so more
   * than one may be in flight). While any is followed the page shows a non-blocking
   * "Running" indicator instead of a modal: Open, New and Sign Out stay available, every
   * other action is disabled (docs/Run_Job_Architecture.md). */
  isRunInProgress = false;
  runInProgressLabel = '';
  private runFollows = new Set<AbortController>();

  private beginRunFollow(label: string): AbortController {
    const follow = new AbortController();
    this.runFollows.add(follow);
    this.runInProgressLabel = label;
    this.isRunInProgress = true;
    this.runStatus.setRunning(true);
    return follow;
  }

  private endRunFollow(follow: AbortController): void {
    this.runFollows.delete(follow);
    this.isRunInProgress = this.runFollows.size > 0;
    this.runStatus.setRunning(this.isRunInProgress);
  }

  /** Stops following every run (another refinery is opened, New, leaving the page). The
   * runs themselves continue on the server; reopening the refinery re-attaches. */
  private stopFollowingRuns(): void {
    this.refineryRun = null;
    this.runFollows.forEach(follow => follow.abort());
    this.runFollows.clear();
    this.isRunInProgress = false;
    this.runStatus.setRunning(false);
  }

  /** The Refinery run this page follows, for Cancel: its job id, the node running now,
   * and whether Cancel was already requested. */
  refineryRun: { jobId: string | null, currentStep: string, cancelling: boolean } | null = null;

  private trackRefineryRun(msg: any): void {
    if (!this.refineryRun) { return; }
    if (msg?.jobId) { this.refineryRun.jobId = msg.jobId; }
    if (msg?.status === 'running' && msg.processName) { this.refineryRun.currentStep = msg.processName; }
  }

  /** Cancel a Refinery run: confirm first; the node running now finishes, then the run
   * stops and a notice names the last node that ran (showRefineryRunOutcome). */
  cancelRefineryRun(): void {
    const run = this.refineryRun;
    if (!run?.jobId || run.cancelling) { return; }
    const step = run.currentStep || 'the current node';
    this.showConfirmDialog(
      'Stop the Refinery run?',
      `The node currently running (${step}) will finish first. No further nodes will run.`,
      async (confirmed) => {
        if (!confirmed || this.refineryRun !== run) { return; }
        try {
          await this.configService.cancelRunJob(run.jobId!);
          run.cancelling = true;
          this.runInProgressLabel = `Stopping after ${step}...`;
        } catch (err) {
          this.displayError('Failed to cancel the run', 'Error', err);
        }
      },
      'Stop Run');
  }

  /** The end of a followed Refinery run: the results popup, or -- if it was cancelled --
   * a notice naming the last node that ran. */
  private async showRefineryRunOutcome(result: RunrefineryResponse): Promise<void> {
    const outcome = result as any;
    if (outcome?.status === 'fatal_error') {
      await this.pullLatestRefineryStatus();
      this.update$.next(true);
      await this.showRunFailure(outcome, 'Refinery :' + this.viewModel.dataRefineryConfig.name,
                                this.viewModel.dataRefineryConfig.name);
      return;
    }
    if (outcome?.status === 'cancelled') {
      await this.pullLatestRefineryStatus();
      this.update$.next(true);
      this.showOkDialogWarning('Refinery run stopped',
        outcome.lastStep
          ? `The last node to run was ${outcome.lastStep}. No further nodes were run.`
          : 'The run was stopped before any node ran.',
        () => {});
      return;
    }
    await this.showRefineryRunResult(result);
    // A node that failed does not stop the run (other branches still run); the report
    // shows its rows, and this says which node failed and where to look.
    if (Array.isArray(outcome?.failedNodes) && outcome.failedNodes.length > 0) {
      this.displayError(outcome.message || 'One or more nodes failed.', 'Run completed with failures');
    }
  }

  /** Progress handling shared by every run this page follows -- started here, or
   * resumed after a reload (resumeActiveRun). */
  private onRunProgress(msg: RunrefineryResponse): void {
    console.log("Progress message:", msg);
    // Every run event, node starts included: the server writes a node's Processing (and
    // the next node's Next) before it sends the event, so this read always shows the
    // node that is running. Skipping "running" left the canvas showing the previous
    // node's snapshot -- the running node still as Next -- for a whole node (RCA 2026-10-07).
    this.pullLatestRefineryStatus();
    this.update$.next(true);
  }

  /** The end-of-run popup for a Run Refinery. */
  private async showRefineryRunResult(result: RunrefineryResponse): Promise<void> {
    const configJson = await this.configService.getRefineryConfigByGuidAsync(this.userData.getSelectedRefineryDetails().guid);
    this.nodeStatusArray = [];
    this.viewModel.dataRefineryConfig.nodes.forEach((Node, index) => {
      let nodeData = configJson.nodes.filter(newNode => newNode.id == Node.id)[0]
      Node.data.nodeStatus = (nodeData == undefined) ? 0 : nodeData.data.nodeStatus
      this.nodeStatusArray.push({id: Node.id, status: Node.data.nodeStatus });
    });
    const dialogConfig = new MatDialogConfig();
    dialogConfig.minWidth = '450px'
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { runNodeResponse: result['data'], nodeName: this.viewModel.dataRefineryConfig.name, farmTypeColor: '',
      runType:'Refinery :'+this.viewModel.dataRefineryConfig.name,
      nodedata: this.viewModel.dataRefineryConfig.nodes,nodestatusData:this.nodeStatusArray, totalRunTimeTaken: result['total_time_taken']};
    await this.matDialog.open(RunNodeDialogComponent, dialogConfig).afterClosed().toPromise();
  }

  /** A run that ended in failure (status fatal_error): the rows of what did run, when the
   * failure carries them, then the error itself. The results popup used to open on the
   * failure message as if it were a result -- empty, with no error shown (Fix B). */
  private async showRunFailure(result: any, runType: string, nodeName: string): Promise<void> {
    const rows = Array.isArray(result?.data) ? result.data : [];
    if (rows.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.minWidth = '450px';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = { runNodeResponse: rows, nodeName: nodeName, farmTypeColor: '', runType: runType,
        totalRunTimeTaken: result?.total_time_taken ?? rows[0]?.total_time_taken ?? '' };
      await this.matDialog.open(RunNodeDialogComponent, dialogConfig).afterClosed().toPromise();
    }
    this.displayError(result?.message || 'The run failed.', 'Run failed');
  }

  /** The end-of-run popup for a Run Node. */
  private async showNodeRunResult(result: RunrefineryResponse, nd: any): Promise<void> {
    if ((result as any)?.status === 'fatal_error') {
      await this.showRunFailure(result, 'Node : ' + nd.label + ' (' + nd.data?.descriptor + ')', nd.data?.descriptor);
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.minWidth = '450px'
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { runNodeResponse: result['data'], nodeName: nd.data?.descriptor, farmTypeColor: '',
      runType:'Node : '+nd.label+' ('+nd.data?.descriptor+')',
      totalRunTimeTaken: result['data']?.[0]?.['total_time_taken'] ?? '' };
    const dialogRef = this.matDialog.open(RunNodeDialogComponent, dialogConfig);
    await dialogRef.afterClosed().toPromise();
  }

  /** A Run Refinery / Run Node this user started before the page was (re)loaded is still
   * running on the server (docs/Run_Job_Architecture.md): follow it to its end, with the
   * same progress and popup as if this page had started it. */
  private async resumeActiveRun(guid: string): Promise<void> {
    let jobs: any[] = [];
    try {
      jobs = await this.configService.getActiveRunJobs(guid, this.userData.getUserId());
    } catch {
      return;
    }
    const job = jobs.find(j => j.kind === 'refinery') ?? jobs.find(j => j.kind === 'node');
    if (!job) {
      return;
    }
    const nd = job.kind === 'node' ? this.viewModel.dataRefineryConfig.nodes.find(x => x.id == job.nodeId) : null;
    const follow = this.beginRunFollow(job.kind === 'refinery'
      ? 'Running Refinery: ' + this.viewModel.dataRefineryConfig.name
      : 'Running Node: ' + (nd?.data?.descriptor ?? ''));
    const run = job.kind === 'refinery'
      ? (this.refineryRun = { jobId: job.jobId, currentStep: '', cancelling: false })
      : null;
    try {
      const result = await this.configService.followRunJob<RunrefineryResponse>(
        job.jobId, (msg) => { this.trackRefineryRun(msg); this.onRunProgress(msg); }, follow.signal);
      if (result && !follow.signal.aborted) {
        if (job.kind === 'refinery') {
          await this.showRefineryRunOutcome(result);
        } else if (nd) {
          await this.showNodeRunResult(result, nd);
        }
      }
    } catch (err) {
      if (!follow.signal.aborted) {
        this.displayError('Failed to follow the run in progress', 'Error', err);
      }
    } finally {
      if (run && this.refineryRun === run) { this.refineryRun = null; }
      this.endRunFollow(follow);
      if (!follow.signal.aborted) {
        await this.pullLatestRefineryStatus();
        this.update$.next(true);
      }
    }
  }

  async runRefineryConfig() {
      if (!(await this.warnAndBlockIfRefineryBusy())) {
        return;
      }
      // Replace the confirm with a custom confirmation dialog
    this.showRunRefineyConfirmDialog(
      'Run the entire Refinery?', // Title of the dialog
      'This could take some time.', // Message of the dialog

      async (result) => {
        //const busyDialog = this.showProgressBusyDialog('Running Refinery: '+this.viewModel.dataRefineryConfig.name,this.progressUpdates);
        const busyDialog = this.showBusyDialog('Running Refinery: '+this.viewModel.dataRefineryConfig.name);

        if (result) { // Proceed only if the user confirms (result is true)
          await this.refreshBeforeMutatingAction();
          var isConfigureAll= await this.isConfigureAll();
          if(!isConfigureAll){
            this.displayWarning("Please check the nodes with status 'Not Configured'.", 'Warning');
            busyDialog.close();
            return;
          }

          let refineryConfigID = this.viewModel.dataRefineryConfig.guid;
          var runRefineryRequest: RunrefineryRequest = new RunrefineryRequest(this.userData.getUserId(),this.userData.getOrgId(),refineryConfigID,"",this.refineryPresence.tabId);
          busyDialog.close();
          const follow = this.beginRunFollow('Running Refinery: ' + this.viewModel.dataRefineryConfig.name);
          const run = this.refineryRun = { jobId: null, currentStep: '', cancelling: false };
          try {
            const requestUrl = await this.configService.runRefineryRequestUrl();
            await this.configService.streamPost<RunrefineryRequest, RunrefineryResponse>(
              requestUrl,
              runRefineryRequest,
              (msg) => { this.trackRefineryRun(msg); this.onRunProgress(msg); },
              follow.signal
            ).then(async result => {
              if (result && !follow.signal.aborted){
                await this.showRefineryRunOutcome(result);
              }
            });
          } catch(err) {
            if (!follow.signal.aborted) {
              this.displayError('Failed to run the refinery', 'Error', err);
            }
          } finally {
            if (this.refineryRun === run) { this.refineryRun = null; }
            this.endRunFollow(follow);
          }
        }
        busyDialog.close();
      }
    );
  }

  async resetRefineryConfig() {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    const busyDialog = this.showBusyDialog('Resetting refinery...');

    const confirmationResult = await new Promise<boolean>((resolve) => {
      this.showConfirmDialog(
        'Reset Refinery will reset all nodes to the Idle state !',
        ' ',
        (result) => resolve(result)
      );
    });
    if (!confirmationResult) {
      busyDialog.close();
      return;
    }
    await this.refreshBeforeMutatingAction();
     let refineryConfigID = this.viewModel.dataRefineryConfig.guid;
     var runRefineryRequest: RunrefineryRequest = new RunrefineryRequest(this.userData.getUserId(),this.userData.getOrgId(),refineryConfigID,"",this.refineryPresence.tabId);
     try {
      var resetRefineryResponse = await this.configService.resetRefinery(runRefineryRequest);
     } catch(err) {
        this.displayError('Failed to reset the refinery', 'Error', err);
     } finally {
        await this.pullLatestRefineryStatus();
        this.update$.next(true);
        busyDialog.close();
     }
  }

  onClickOpenButton() {
    this.refineryListpanelOpenState = true;
    this.loadRefineryConfigs();
  }

 async onClickExportButton() {
    const selectedDataRefinery = this.viewModel.dataRefineryConfig;
    const selectedDataRefineryGUID = selectedDataRefinery.guid;
    if (selectedDataRefineryGUID === undefined) {
      return;
    }

    const busyDialog = this.showBusyDialog('Exporting the selected refinery...');
    try {
      const { blob, fileName } = await this.configService.exportRefinery(selectedDataRefineryGUID);

      // Same createObjectURL + anchor-click + revokeObjectURL pattern as
      // JsonDownloadService.downloadJsonFile — just downloading a server-fetched
      // blob instead of client-built JSON.
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      this.displayError('Failed to export the refinery', 'Error', err);
    } finally {
      busyDialog.close();
    }
  }

  onClickImportButton() {
    const dialogRef = this.matDialog.open(ImportRefineryDialogComponent, {
      width: '500px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (selectedFile: File | undefined) => {
      if (!selectedFile) {
        return;
      }

      const busyDialog = this.showBusyDialog('Importing the refinery package...');
      try {
        const result = await this.configService.importRefinery(selectedFile);
        await this.loadRefineryConfigs();

        const warningsHtml = result.warnings.length > 0
          ? `<p><strong>Warnings:</strong></p><ul>${result.warnings.map(w => `<li>${w}</li>`).join('')}</ul>`
          : '';
        this.displayInfoHTML(
          `<p>Imported refinery '<strong>${result.refineryName}</strong>'.</p>${warningsHtml}`,
          'Import Complete'
        );
      } catch (err) {
        if (err instanceof ImportRefineryError) {
          this.displayWarning(err.message, 'Import Failed');
        } else {
          this.displayError('Failed to import the refinery package', 'Error', err);
        }
      } finally {
        busyDialog.close();
      }
    });
  }

  NewRefineryConfig(trigger: MatMenuTrigger) {
    this.stopFollowingRuns();
    this.displayInfoHTML(
      `<ol style="margin: 0; padding-left: 5px;">
          <li>Add an Ingest Node</li>
          <li>Give the Ingest Node a name</li>
          <li>Open the New Ingest Node</li>
          <li>Configure the Node and Save (you can also configure the Node later)</li>
          <li>You will be prompted to Name the new Refinery and enter a Description and a Status</li>
          <li>Now your new Refinery is saved and ready to go!</li>
        </ol>`,
      "You have started the process of creating a new Refinery, to proceed:","", (result) => {
        // Actually leaving whatever refinery was open, unlike navigating
        // into a node — release its presence.
        this.refineryPresence.stop();
        this.viewModel.dataRefineryConfig = new DataRefineryConfig();
        this.viewModel.dataRefineryConfig.nodes = [];
        this.viewModel.dataRefineryConfig.links = [];
        this.filterlinks=[];
        //clear
        this.userData.clearSelectedRefineryDetails()
        trigger.openMenu();
      }
    );
  }
  async duplicateConfig(config: DataRefineryConfig): Promise<void> {
    const proposedName = this.generateProposedName(config, 1);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.data = { title: 'Duplicate Refinery', stringValue: proposedName, placeholder: 'Enter Refinery name' };

    const dialogRef = this.matDialog.open(NewSingleStringValueDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {
      if (!result.stringValue) { return; }

      const dialog = this.showBusyDialog('Duplicating Refinery...');

      try {
        let newConfig = new DataRefineryConfig();
        newConfig = Object.assign(newConfig, config);
        newConfig.guid = null;
        newConfig.name = result.stringValue;
        newConfig.createdDateTime = null;
        newConfig.modifiedDateTime = null;
        newConfig.shared=0;
        newConfig.publicShared=false;
        newConfig.owner=this.currentUser;
        newConfig.organizationId =this.userData.getSelectedOrganization();

       // newConfig = await this.configService.UpsertRefineryConfig(newConfig);

        // const configs = this.mappingConfigsSubject.value;
        // configs.push(newConfig);
        // configs.sort( (a, b) =>
        //   b.modifiedDateTime.getTime() - a.modifiedDateTime.getTime()
        // );

        // this.mappingConfigsSubject.next(configs);
        for (const refconfig of newConfig.nodes.filter(ingest => ingest.data.nodeboxtypeid == 1)) {
          if (refconfig.data.configGuid) {
            const config = await this.configService.getConfigByGuidAsync(refconfig.data.configGuid);
            config.guid = null;
            const saveconf = await this.duplicateConfigPipeLine(config,proposedName);
            refconfig.data.configGuid = saveconf.guid;
          }
        }
        
        newConfig = await this.configService.UpsertRefineryConfig(newConfig);
        this.loadConfigDetail(newConfig.guid);
        //this.viewModel.dataRefineryConfig = newConfig;

        if(newConfig.guid)
          {
            await this.saveRefineryTable(newConfig);
          }


        await this.loadRefineryConfigs();
        this.positioningNodes();
        this.update$.next(true);
      } catch (error) {
        this.displayError('Failed to duplicate Refinery', 'Error', error);
      } finally {
        dialog.close();
      }
    });
  }
  islinehOverText:boolean=true;
  linehOverText(LineID: string| undefined){
    if(this.islinehOverText){
      this.islinehOverText=false;
      setTimeout(() => {
        var hoverText:string ="";
        var linktoHover:any = this.viewModel.dataRefineryConfig.links.find(x => x.id == LineID);
        if(!linktoHover){
          return hoverText;
        }
        var sourceNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == linktoHover.source);
        var targetNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == linktoHover.target);
        if(sourceNode && targetNode){
          hoverText = `Source: ${sourceNode.data?.Descriptor} - ${sourceNode.label}. Target: ${targetNode.data?.Descriptor} - ${targetNode.label}.`;
        }
        this.islinehOverText=true;
        return hoverText;
      }, 5000);
    }
  }


  private generateProposedName(config: DataRefineryConfig, proposedCount: number): string {
    const countIndexStart = config.name.lastIndexOf('(');
    const countIndexEnd = config.name.lastIndexOf(')');
    let baseName = config.name;

    const countString = String(proposedCount);
    if (countIndexStart !== -1 && countIndexEnd !== -1) {
      baseName = config.name.substring(0, countIndexStart - 1);
    }
    const count = Number(countString) + 1;
    const proposedName = baseName + ` (${count})`;
    const configNames = this.mappingConfigsSubject.value.map(c => c.name);
    if (configNames.find(n => n === proposedName)) {
      return this.generateProposedName(config, proposedCount + 1);
    }

    return proposedName;
  }

async getNodeTransformNamesValue(nodeId: string): Promise<string> {
  const configJson = await this.configService.getAllConfigs(1); 

  let subtitle = "";
  const targetNode = this.viewModel.dataRefineryConfig.nodes.find(node => node.id === nodeId);

  if (!targetNode) return "";

  const ingestNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id === targetNode.data.ingestId);
  const config = configJson.find(cfg => cfg.guid === ingestNode?.data?.configGuid);

  if (this.transformerToggleState[targetNode.id] === undefined) {
    this.transformerToggleState[targetNode.id] = false;
  }

  const showType = this.transformerToggleState[targetNode.id];

  if (targetNode.data.nodeboxtypeid === 1) {
    subtitle = "**No Connector Added**";
  } else if (targetNode.data.nodeboxtypeid === 2) {
    subtitle = "**No Transformers Added**";
  } else if (targetNode.data.nodeboxtypeid === 4) {
    subtitle = targetNode.data.farmtypeid === 2 ? "SubTask->Task" :
               targetNode.data.farmtypeid === 3 ? "Task->Activity" : "";
  }

  if (config) {
    if (targetNode.data.nodeboxtypeid === 1) {
      const dataConnector = config.dataConnectorMappings.find(x => x.guid === config.selectedIngestFarmGuid);
      if (dataConnector && dataConnector.name) {
        subtitle = `${dataConnector.name} - ${DataConnectorType[dataConnector.dataConnector.dataConnectorType]}`;
      }
    }

    if (targetNode.data.nodeboxtypeid === 2) {
      let names = "";
      config.transforms
        .filter(trans => trans.nodeID === targetNode.id)
        .sort((a, b) => a.index - b.index)
        .forEach(transform => {
          names += transform.name + " > ";
        });

      if (names !== "") {
        subtitle = names.replace(/>\s*$/, "");
      }
    }
  }

  targetNode.data.subtitle = subtitle;
  return subtitle;
}


async ShowTransformerTypeValues(): Promise<string> {
  const clickedNodeId = this.id;
  const configJson = await this.configService.getAllConfigs(1);

  // Find only the clicked node
  const node = this.viewModel.dataRefineryConfig.nodes.find(n => n.id === clickedNodeId);
  if (!node) {
    console.warn("Clicked node not found:", clickedNodeId);
    return "";
  }

  const ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id === node.data.ingestId);
  const config = configJson.find(config => config.guid === ingestnode?.data?.configGuid);

  let subtitle = "";

  if (config && node.data.nodeboxtypeid === 2) {
    let names = "";
    config.transforms
      .filter(trans => trans.nodeID === node.id)
      .sort((a, b) => a.index - b.index)
      .forEach(transform => {
        let val = TransformTypeUtil.toString(transform.transformType).replace(/\s*Transform\s*$/, '');
        names += val + " > ";
      });

    if (names !== "") {
      subtitle = names.replace(/>\s*$/, "");
    }
  }

  node.data.subtitle = subtitle;
  return subtitle;
}


  async openAboutThisNode(): Promise<any>
  {
const nodeId = this.id;

let subtitle = "";
let transformerLabel = "";

// ✅ Just check the toggle state, don't change it
if (this.transformerToggleState[nodeId]) {
  subtitle = await this.ShowTransformerTypeValues();
  transformerLabel="Transformers Type";
} else {
  subtitle = await this.getNodeTransformNamesValue(nodeId);
   transformerLabel="Transformers Name";
}
    var refineryName = this.viewModel.dataRefineryConfig.name;
    var refineryConfig = await this.configService.getRefineryConfigByGuidAsync(this.viewModel.dataRefineryConfig.guid);
   
    var nodeClicked = refineryConfig.nodes.find(x => x.id == this.id);
   
    var inputfarms = ''
    var attrFarms = ''

    var LinksforNode_Data = refineryConfig.links.filter(l => l.target == this.id && l.data.linetype == "line" ) ;
    var LinksforNode_Attr = refineryConfig.links.filter(l => l.target == this.id && l.data.linetype == "dotted" ) ;

    LinksforNode_Data.forEach(link => {
      var nodesource = refineryConfig.nodes.find(nt=>nt.id==link.source);
      if (nodesource) {
        inputfarms += nodesource.data.rcNo + ',';
      }
    })
    inputfarms = inputfarms.slice(0, -1);

    LinksforNode_Attr.forEach(link => {
      var nodesource = refineryConfig.nodes.find(nt=>nt.id==link.source);
      if (nodesource) {
        attrFarms += nodesource.data.rcNo + ',';
      }
    })
    attrFarms = attrFarms.slice(0, -1);

    var nodeType = this.GetNodeBoxName(nodeClicked.data.nodeboxtypeid)
    var nodeStatus = nodeClicked.data.nodeStatus ;
    var FarmTypeColor = this.FarmTypeColor(nodeClicked.data.farmtypeid) ;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.minWidth = '357px'
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { 
      label: nodeClicked.label, subtitle: subtitle, Descriptor: nodeClicked.data.descriptor, inputNode: inputfarms, inputAttr:attrFarms,
      farmtypeid:nodeClicked.data.farmtypeid, nodeboxtypeid: nodeClicked.data.nodeboxtypeid, farmTypeColor:FarmTypeColor,
      refineryName:refineryName, nodeType:nodeType, nodeStatus:nodeStatus, created: nodeClicked.data?.createdDateTime, lastSaved: nodeClicked.data?.lastSaveddDateTime,
      lastRun: nodeClicked.data?.lastRunOndDateTime, rowsIN: nodeClicked.data?.runInRows, rowsOut: nodeClicked.data?.runOutRows, runTime: nodeClicked.data?.runTime,transformerLabel: transformerLabel
    };

    const dialogRef = this.matDialog.open(AboutThisNodeComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.name) { return; }

      // Name entered
      // onClosed(result.name);
    });
  }


  dataWriterRunMsg(roomNumber: number): void {
    alert('Clicked ' + roomNumber);
  }
  previewNodeId:string="";
  async dataPreviewNode(event: any): Promise<boolean> {
    // check the status for dependent nodes
    this.previewNodeId=this.id;
    this.userData.setNodeId(this.previewNodeId);
    this.userData.setDataPreviewNodeId(this.previewNodeId);
    var allDependent_Status = NodeRunStatus.Completed ;
    var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.previewNodeId);
    var LinksforNodeTarget_Attr = this.viewModel.dataRefineryConfig.links.filter(l => l.target == this.previewNodeId);
    LinksforNodeTarget_Attr.forEach(link => {
      var nodesource = this.viewModel.dataRefineryConfig.nodes.find(nt=>nt.id==link.source);
      if(nodesource?.data?.nodeStatus != NodeRunStatus.Completed){allDependent_Status = nodesource.data.nodeStatus}
    })
    // Check if all dependent nodes are completed
    if (allDependent_Status !== NodeRunStatus.Completed) {
      this.displayWarning("Cannot open the data preview window as one or more of its input nodes are not in ‘Completed’ Status.", 'Warning', '');
      return false;  // This will return false if the condition is not met
    }
    var nodeClicked = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.previewNodeId);
    this.highLightedID = nodeClicked.id
    this.dataPreviewNodeID = 'Node: '+nodeClicked.data.Descriptor+'. - '+nodeClicked.label;
    this.dataPreviewNodeColor = this.FarmTypeColor(nodeClicked.data.farmtypeid) ;

    // Get all elements with the class 'nodeHighLighted'
    var elements = document.querySelectorAll('.nodeHighLighted');
    // Loop through the elements and remove the class from each one
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove('nodeHighLighted');
    }
    this.currentNodeEvent.target.childNodes[0].setAttribute('class', "nodeHighLighted")
    this.clearAllSortFilter();
    const busyIndicator = this.showBusyDialog('Please wait...');
    await this.DataPreview(this.previewNodeId);
    busyIndicator.close();
    return true;
  }
  onDescriptionClick(event: Event) {
    event.stopPropagation();  // Prevent the click event from closing the panel
  
    // Custom logic here
    // Example: Reset highlight or perform an action
    this.removeHighlightClass();
    
    // Check if the panel is open, and close it if it's open
    if (this.refineryPreviewPanelOpenState) {
      this.refineryPreviewPanelOpenState = false;
    }
    // If the panel is closed, set it to open (so the description click only toggles once)
    else {
      this.refineryPreviewPanelOpenState = true;
     // this.currentNodeEvent.target.childNodes[0].setAttribute('class', "nodeHighLighted")
   //  this.dataPreviewNode(this.currentNodeEvent);
    }
  }
  
  removeHighlightClass()
  {
// Get all elements with the class 'nodeHighLighted'
var elements = document.querySelectorAll('.nodeHighLighted');
// Loop through the elements and remove the class from each one
for (var i = 0; i < elements.length; i++) {
  elements[i].classList.remove('nodeHighLighted');
}

  }
  async isConfigChanged(): Promise<boolean> {
    const savedConfig = this.userData.getSelectedRefineryDetails();
    const currentConfig = await this.configService.getRefineryConfigByGuidAsync(savedConfig.guid);
    const areEqual = isEqual(
      JSON.parse(JSON.stringify(savedConfig)),
      JSON.parse(JSON.stringify(currentConfig))
    );

    if (areEqual) {
      console.log("Configuration has not changed.");
      return false;
    } else {
      console.log("Configuration has changed.");
      return true;
    }
  }

  /**
   * Staleness-only check — shared by warnAndBlockIfRefineryBusy() (below)
   * and by VIEW-ONLY actions like openNode() that must stay available in
   * Read-Only mode and so must NOT go through the Read-Only gate. Returns
   * false (and shows the warning, reloading the refinery on OK) if this
   * refinery changed since it was loaded; true if it's safe to proceed.
   *
   * Only checks anything for a SHARED refinery. A private refinery has
   * exactly one Analyst able to touch it, so there is no concurrent-editor
   * risk to check for — running isConfigChanged() there would just be a
   * wasted fetch + deep-equality comparison on every single action for zero
   * benefit. No-op (always true) too for a refinery that hasn't been saved
   * yet, since there's nothing on the server to be stale against.
   */
  private async checkRefineryFreshness(): Promise<boolean> {
    const refineryDetails = this.userData.getSelectedRefineryDetails();
    if (refineryDetails == null) {
      return true;
    }
    if (!refineryDetails.publicShared && refineryDetails.shared === 0) {
      return true;
    }
    if (await this.isConfigChanged()) {
      const refineryGuid = this.viewModel.dataRefineryConfig.guid;
      this.displayWarning(
        "Someone is currently working in this refinery. Please wait.",
        "Refinery is Busy.",
        undefined,
        async () => {
          // isConfigChanged() already told us this refinery is stale — refresh
          // it now instead of leaving the Analyst looking at old data until
          // some other action happens to trigger a reload.
          if (refineryGuid) {
            await this.loadConfigDetail(refineryGuid);
          }
        }
      );
      return false;
    }
    return true;
  }

  /**
   * Shared gate used by every MUTATING node/refinery action — Save, Run,
   * Reset, and the node-menu actions (Run Node, Reset Node, Add Processor,
   * Add Joiner, Insert/Remove Node, Undo, etc). Blocks immediately if this
   * tab is Read-Only (see isReadOnly / RefineryPresenceService); otherwise
   * defers to the staleness check above. openNode() is deliberately NOT
   * gated by this — viewing a node's configuration/output must remain
   * available in Read-Only mode, so it calls checkRefineryFreshness()
   * directly instead. The backend enforces the same Edit-lock requirement
   * independently on every mutating endpoint (CheckEditLockAsync), so this
   * client-side gate is a UX convenience, not the security boundary.
   */
  private async warnAndBlockIfRefineryBusy(): Promise<boolean> {
    if (this.isReadOnly) {
      this.displayWarning(
        "You're viewing this refinery in Read-Only mode. It's currently being edited elsewhere.",
        "Read-Only"
      );
      return false;
    }
    return this.checkRefineryFreshness();
  }

  async openNode(): Promise<boolean> {
    var nodeId:string=this.id;
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      this.userData.setSelectedIngestMappingGUID("");
      this.userData.setSelectedIngestMappingType("");
      // View-only — must stay available in Read-Only mode, so this checks
      // staleness directly rather than going through the Read-Only gate
      // that warnAndBlockIfRefineryBusy() applies to mutating actions.
      if (!(await this.checkRefineryFreshness())) {
        busyIndicator.close();
        return false;
      }
      // this.refineryPreviewPanelOpenState = false;
      // this.inputPrvwFilterViewModel.resetProps();
      // this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
      if(this.viewModel.dataRefineryConfig.guid){
        // check the status for dependent nodes
        var allDependent_Status = NodeRunStatus.Completed ;
        var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == nodeId);
        var LinksforNodeTarget_Attr = this.viewModel.dataRefineryConfig.links.filter(l => l.target == nodeId);
        LinksforNodeTarget_Attr.forEach(link => {
          var nodesource = this.viewModel.dataRefineryConfig.nodes.find(nt=>nt.id==link.source);
          if(nodesource?.data?.nodeStatus != NodeRunStatus.Completed){
            allDependent_Status = nodesource.data.nodeStatus
          }
        })

        if(allDependent_Status != NodeRunStatus.Completed){
          if (this.isReadOnly) {
            // Read-Only cannot run anything to complete the missing
            // upstream work (runNode() is Edit-only), and opening this
            // node before its input data exists would error out exactly
            // the way Edit mode's own failure path below does — so block
            // it the same way Edit mode blocks when its auto-run fails,
            // instead of silently letting the Analyst into a node with no
            // data to show. This mirrors Edit mode's dependency check; it
            // just can't self-heal by running anything.
            busyIndicator.close();
            this.displayWarning(
              "This node's upstream dependencies haven't completed yet, so there is no data to view. Ask the Analyst currently editing this refinery to run them, then try again.",
              "Not Yet Run"
            );
            return false;
          } else {
          // Directly run upstream nodes without confirmation
            var nodeLinks = this.viewModel.dataRefineryConfig.links.filter(link => link.target == nodeId) || [];
            for (const link of nodeLinks) {
              var nodedetails = this.viewModel.dataRefineryConfig.nodes.find(node => node.id === link.source);

              if (nodedetails.data?.nodeStatus != NodeRunStatus.Completed) {
                await this.runNode(link.source, true,false);
              }
            }
            // Fetch updated config
            var savedRefineryConfig = await this.configService.getRefineryConfigByGuidAsync(
              this.viewModel.dataRefineryConfig.guid
            );
            var prevnodestatus = true;
            for (const link of nodeLinks) {
              var nodesource = savedRefineryConfig.nodes.find(nt => nt.id == link.source);
              if (nodesource?.data?.nodeStatus != NodeRunStatus.Completed) {
                prevnodestatus = false;
              }
            }
            // Handle failure case
            if (!prevnodestatus) {
              busyIndicator.close();
              return false;
            }
          }
        }
        //check farm joiner link count
        if(nd.data.nodeboxtypeid==3){
          if(LinksforNodeTarget_Attr.length <2){
            this.displayWarning("This Joiner Node only has one input node.  Please add one or more input Nodes before proceeding.",'Warning','');
            busyIndicator.close();
            return false;
          }
        }  

        // Read-Only: skip this save entirely rather than let it fire and get
        // rejected. This call exists to persist local view-state (e.g. node
        // gear positions) before navigating into the node's editor — a
        // Read-Only tab has nothing of its own to persist, and the backend
        // would reject it anyway (no Edit lock held) since this tab was
        // never granted Edit in the first place. Previously this fired
        // unconditionally, got a 403, and the resulting throw below
        // silently aborted the whole open — blocking viewing entirely.
        if (!this.isReadOnly) {
          try {
            await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
          } catch (err) {
            if (err instanceof RefineryConflictError) {
              busyIndicator.close();
              const refineryGuid = this.viewModel.dataRefineryConfig.guid;
              this.displayWarning(
                err.message,
                'Refinery Changed',
                undefined,
                async () => {
                  if (refineryGuid) {
                    await this.loadConfigDetail(refineryGuid);
                  }
                }
              );
              return false;
            }
            throw err;
          }
        }
        this.redirectNode(nodeId);
      }
      else{
        this.showSaveRefineryConfigDialog(async (configName: string, configDescription: string, refineryStatus: number) => {
          this.viewModel.dataRefineryConfig.name = configName;
          this.viewModel.dataRefineryConfig.description = configDescription;
          this.viewModel.dataRefineryConfig.status = refineryStatus;
          this.viewModel.dataRefineryConfig.nodeWidth = this.viewModel.nodeWidth;
          this.viewModel.dataRefineryConfig.nodeHeightRatio_Per = this.viewModel.nodeHeightRatio_Per;
          this.viewModel.dataRefineryConfig.nodeHeight = this.viewModel.nodeHeight;
          this.viewModel.dataRefineryConfig.nodeGearSizePX = this.viewModel.nodeGearSizePX;
          this.viewModel.dataRefineryConfig.dataWriterSize_Per = this.viewModel.dataWriterSize_Per;
          this.viewModel.dataRefineryConfig.dataWriterSizePX = this.viewModel.dataWriterSizePX;
          this.viewModel.dataRefineryConfig.nodeGearSize_Per = this.viewModel.nodeGearSize_Per;
          this.viewModel.dataRefineryConfig.gearPosition_X = this.viewModel.gearPosition_X;
          this.viewModel.dataRefineryConfig.gearPosition_Y = this.viewModel.gearPosition_Y;
          this.viewModel.dataRefineryConfig.nodePadding_X = this.viewModel.nodePadding_X;
          this.viewModel.dataRefineryConfig.nodePadding_Y = this.viewModel.nodePadding_Y;
          this.viewModel.dataRefineryConfig.nodeBorderWeight = this.viewModel.nodeBorderWeight;
          this.viewModel.dataRefineryConfig.nodeBorderStroke = this.viewModel.nodeBorderStroke;
          this.viewModel.dataRefineryConfig.nodeFontSizeTitle = this.viewModel.nodeFontSizeTitle;
          this.viewModel.dataRefineryConfig.nodeFontSizeSubtitle = this.viewModel.nodeFontSizeSubtitle;
          this.viewModel.dataRefineryConfig.nodeFontSizeFarmType = this.viewModel.nodeFontSizeFarmType;
          this.viewModel.dataRefineryConfig.nodeFontSizeStatus = this.viewModel.nodeFontSizeStatus;
          this.viewModel.dataRefineryConfig.nodeFontSizeTitlePer = this.viewModel.nodeFontSizeTitlePer;
          this.viewModel.dataRefineryConfig.nodeFontSizeSubtitlePer = this.viewModel.nodeFontSizeSubtitlePer;
          this.viewModel.dataRefineryConfig.nodeFontSizeFarmTypePer = this.viewModel.nodeFontSizeFarmTypePer;
          this.viewModel.dataRefineryConfig.nodeFontSizeStatusPer = this.viewModel.nodeFontSizeStatusPer;
          this.viewModel.dataRefineryConfig.nodeMenuFontSizePer = this.viewModel.nodeMenuFontSizePer;
          this.viewModel.dataRefineryConfig.menuFontSizePX = this.viewModel.menuFontSizePX;
          this.viewModel.dataRefineryConfig.titlePadXPer = this.viewModel.titlePadXPer;
          this.viewModel.dataRefineryConfig.titlePadYPer = this.viewModel.titlePadYPer;
          this.viewModel.dataRefineryConfig.subTitlePadXPer = this.viewModel.subTitlePadXPer;
          this.viewModel.dataRefineryConfig.subTitlePadYPer = this.viewModel.subTitlePadYPer;
          this.viewModel.dataRefineryConfig.nodeIDPadXPer = this.viewModel.nodeIDPadXPer;
          this.viewModel.dataRefineryConfig.nodeIDPadYPer = this.viewModel.nodeIDPadYPer;
          this.viewModel.dataRefineryConfig.owner = this.userData.getUserName();
          this.viewModel.dataRefineryConfig.organizationId =this.userData.getSelectedOrganization();
          var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
          this.viewModel.dataRefineryConfig = config;
        
          if(config.guid)
          {
            await this.saveRefineryTable(config);
          }
          this.redirectNode(nodeId);
        });
      }
    }catch (error) {
      console.error('Error saving refinery table:', error);
      
    }finally {
      busyIndicator.close();
    }
    return true;
  }

  // New saveRefineryTable function
  private async saveRefineryTable(config: DataRefineryConfig) {
    try {
    
      var tr=new TableRefinery();
      tr.Id=0;
      tr.RefineryId=config.guid;
      tr.RefineryName=config.name;
      tr.Owner=config.owner;
      tr.Description=config.description;
      tr.Status=config.status;
      tr.Shared=config.shared;
      tr.publicShared=config.publicShared;
      tr.OrganizationId=config.organizationId;
    
      await this.configService.UpsertRefineryTable(tr);
    } catch (error) {
      console.error('Error saving refinery table:', error);
    }
  }

  async runNode(selectnodeid:string=this.id,isShowPopUp:boolean=true,isDbWriter:boolean=true): Promise<any> {
      if (!(await this.warnAndBlockIfRefineryBusy())) {
        return;
      }
      var id:string=selectnodeid;
      // check the status for dependent nodes
      var allDependent_Status = NodeRunStatus.Completed ;
      // Fetch fresh before deciding anything below — this refinery may be
      // shared, and other Analysts' runs/resets change nodeStatus/
      // dataWriterStatus between the time this refinery was opened and the
      // moment "Run" is clicked. Also syncs the view (applyFreshRefineryStatuses)
      // so the graph reflects reality, not just this method's own decision.
      var savedRefineryConfig = await this.configService.getRefineryConfigByGuidAsync(this.viewModel.dataRefineryConfig.guid)
      this.applyFreshRefineryStatuses(savedRefineryConfig);
      var nd = savedRefineryConfig.nodes.find(x => x.id ==id);
      var nodeId=nd?.id;
      var LinksforNodeTarget_Attr = savedRefineryConfig.links.filter(l => l.target == nodeId);

      if (nodeId === undefined) {
        this.displayWarning("This node is not saved, please hit 'Save' in the Refinery before running this node.",'Warning','');
        return
      }
      if (nd?.data?.nodeStatus == NodeRunStatus.NotConfigured) {
        this.displayWarning("This node is not configured yet. Please open and save the config.",'Warning','');
        return
      }
      /** Check for the configs for the nodes -- START */
      var ingestConfigID = nd.data?.ingestId ;
      var ingestNode = savedRefineryConfig.nodes.find(x => x.id == ingestConfigID);
      var transformerConfigID = ingestNode.data?.configGuid ;
      if (transformerConfigID === undefined) {
        this.displayWarning("This node has no transformers or configs added.",'Warning','');
        return
      }
      var transformerCofig = await this.configService.getConfigByGuidAsync(transformerConfigID)
      if(nd.data?.nodeboxtypeid == 1 ){
        if (transformerCofig.dataConnectorMappings[0].guid === undefined) {
          this.displayWarning("This Ingest node has no  configs added.",'Warning','');
          return
        }
      }else if(nd.data?.nodeboxtypeid == 3){
        var transformers = transformerCofig.transforms.find(x => x.nodeID == nodeId);
        if(transformers === undefined ){
          this.displayWarning("This node is not configured yet.Please open and save the config.",'Warning','');
          return
        }else if(transformers.transformConfig?.fieldMap.length==0 ){
          this.displayWarning("Please open and save the config.",'Warning','');
          return
        }
        else if(transformers.transformConfig?.fieldMap.length!=LinksforNodeTarget_Attr.length){
          this.displayWarning("Kindly open and save the configuration, as changes (additions or deletions) may have occurred in the joiner.",'Warning','');
          return
        }
      }else if(nd.data?.nodeboxtypeid == 4){
        var transformers = transformerCofig.transforms.find(x => x.nodeID == nodeId);
        if(transformers === undefined ){
          this.displayWarning("This node is not configured yet.Please open and save the config.",'Warning','');
          return
        }else if(transformers.transformConfig?.mapTable.length==0 ){
          this.displayWarning("Please open and save the config.",'Warning','');
          return
        }
      }else{
        var transformers = transformerCofig.transforms.find(x => x.nodeID == nodeId);
        if(transformers === undefined ){
          this.displayWarning(nd.data?.rcNo +" This node has no  transformers added.",'Warning','');
          return
        }
      }
      /** Check for the configs for the nodes -- END*/

      LinksforNodeTarget_Attr.forEach(link => {
        var nodesource = savedRefineryConfig.nodes.find(nt=>nt.id==link.source);

        if(nodesource?.data?.nodeStatus != NodeRunStatus.Completed){allDependent_Status = nodesource.data.nodeStatus}

      })
      var runNodeRequest: RunrefineryRequest = new RunrefineryRequest(this.userData.getUserId(),this.userData.getOrgId(),savedRefineryConfig.guid, nodeId, this.refineryPresence.tabId);

      //const busyDialog = this.showProgressBusyDialog('Running Node: '+ nd.data?.descriptor,this.progressUpdates);
      const busyDialog = this.showBusyDialog('Running Node: '+ nd.data?.descriptor);
      try { 
         
        if(allDependent_Status != NodeRunStatus.Completed){
          if(isShowPopUp){
            const confirmationResult = await new Promise<boolean>((resolve) => {
            this.showConfirmDialog(
              'One or more of the Nodes in the pipeline are not in `Completed` status.',
              'Are you sure you want to run all dependent Nodes?',
              (result) => resolve(result)
            );
            });
      
            if (!confirmationResult) {
              busyDialog.close();
              return;
            }
          }
        }
        
        // Proceed with running the node: the modal covered only the checks above; while
        // the run itself is followed the page stays usable (Open / New / Sign Out).
        busyDialog.close();
        const follow = this.beginRunFollow('Running Node: ' + (nd.data?.descriptor ?? ''));
        const requestUrl = await this.configService.runRefineryNodeRequestUrl();
        await this.configService.streamPost<RunrefineryRequest, RunrefineryResponse>(
          requestUrl,
          runNodeRequest,
          (msg) => this.onRunProgress(msg),
          follow.signal
        ).then(async result => {
          if (result && !follow.signal.aborted){
            var farmTypeColor = this.FarmTypeColor(nd.data.farmtypeid)
            if(isShowPopUp){
              await this.showNodeRunResult(result, nd);
            }
            if (this.refineryPreviewPanelOpenState) {
              await this.dataPreviewNode(this.currentNodeEvent); // ✅ Refresh input/output preview here
            }
            else
            {
              var nodeClicked = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id);
              this.highLightedID = nodeClicked.id
              this.dataPreviewNodeID = 'Node: '+nodeClicked.data.Descriptor+'. - '+nodeClicked.label;
              this.dataPreviewNodeColor = this.FarmTypeColor(nodeClicked.data.farmtypeid) ;

                // Get all elements with the class 'nodeHighLighted'
              var elements = document.querySelectorAll('.nodeHighLighted');
              // Loop through the elements and remove the class from each one
              for (var i = 0; i < elements.length; i++) {
                elements[i].classList.remove('nodeHighLighted');
              }
              
              this.inputColumnCount = 0;
              this.outputColumnCount = 0;
              if (this.inputDataFarmPreviewTable?.clear) {
                this.inputDataFarmPreviewTable.clear();
              }
              if (this.outputDataFarmPreviewTable?.clear) {
                this.outputDataFarmPreviewTable.clear();
              }
            }
            //run data writer
            if(isDbWriter){
              await this.runDataWriter(id);
              this.pullLatestRefineryStatus();
              this.update$.next(true);
            }
          }
        }).finally(() => this.endRunFollow(follow));
        return ;

    } catch(err) {
      busyDialog.close() ;
      this.displayError('Failed to run the Node', 'Error', err);
    } finally {
      busyDialog.close() ;
    }
  }

  async redirectNode(id:string) {
    if(this.viewModel.dataRefineryConfig.guid){
      var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == id);
      if (!nd) return;

       // const busyDialog = this.showBusyDialog('Downloading ingest...');
       const busyDialog = this.showBusyDialog('Opening Node...');
        try {
          var refineryConfigGuid=this.viewModel.dataRefineryConfig.guid;
          var refineryName=this.viewModel.dataRefineryConfig.name;
          var nodename=nd.label;
          var nodeId=nd.id;
          var ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == nd.data.ingestId);
          var configGuid=ingestnode.data.configGuid;
          // var nodeDescriptor = nd.data.Descriptor ;
          // var farmColor = this.FarmTypeColor(nd.data.farmtypeid) ;

          var LinksforNode_Data = this.viewModel.dataRefineryConfig.links.filter(l => l.target == nodeId && (l.data.linetype == "line" || l.data.linetype == "joiner") ) ;
          var LinksforNode_Attr = this.viewModel.dataRefineryConfig.links.filter(l => l.target == nodeId && l.data.linetype == "dotted" ) ;
          
          var LinksforNodeTarget_Attr = this.viewModel.dataRefineryConfig.links.filter(l => l.target == nodeId);
          var LinksforNodeSource_Attr = this.viewModel.dataRefineryConfig.links.filter(l => l.source == nodeId);
          var sourcenodeist: LinkNodeViewModel[]=[];
          var targetnodelist: LinkNodeViewModel[]=[];
          LinksforNodeTarget_Attr.forEach(link => {
              var nodesource=this.viewModel.dataRefineryConfig.nodes.find(nt=>nt.id==link.source);
              var sourcenodeview=new LinkNodeViewModel(
                link.id
                ,link.source
                ,nodesource.data.Descriptor//nodesource.label
                ,nodesource.data.farmtypeid
                ,this.GetFarmName(nodesource.data.farmtypeid)
                ,link.data.linetype
                );
                sourcenodeist.push(sourcenodeview);
          });

          LinksforNodeSource_Attr.forEach(link => {
            var nodetarget=this.viewModel.dataRefineryConfig.nodes.find(nt=>nt.id==link.target);
            var targetnodeview=new LinkNodeViewModel(
              link.id
              ,link.source
              ,nodetarget.data.Descriptor//nodetarget.label
              ,nodetarget.data.farmtypeid
              ,this.GetFarmName(nodetarget.data.farmtypeid)
              ,link.data.linetype
              );
              targetnodelist.push(targetnodeview);
        });

          var nodeview=new NodeViewModel(
            nd.id
            ,nd.label
            ,nd.data.Descriptor
            ,this.FarmTypeColor(nd.data.farmtypeid) 
            ,nd.data.farmtypeid
            ,this.GetFarmName(nd.data.farmtypeid)
            ,nd.data.nodeboxtypeid
            ,this.GetNodeBoxName(nd.data.nodeboxtypeid)
            ,sourcenodeist
            ,targetnodelist
            ,nd.data.rcNo
            ,configGuid
            ,this.viewModel.dataRefineryConfig.guid
            ,this.viewModel.dataRefineryConfig.id
            ,this.viewModel.dataRefineryConfig.name
            ,this.FarmTypeIconPath(nd.data.farmtypeid)
            ,this.FarmTypeIngestIconPath(nd.data.farmtypeid)
            ,this.FarmTypeProcessorIconPath(nd.data.farmtypeid)
            );
          this.userData.setSelectedNodeDetails(nodeview);
          this.userData.setNodeId(nodeview.id);
          this.userData.setRefineryId(nodeview.refineryConfigGuid);
          this.userData.setNodeParentDataLine(LinksforNode_Data);
          this.userData.setNodeAttributionLine(LinksforNode_Attr);
          
            // THIS WILL MOVE TO A FUNCTION AND WILL BE CALLED FROM HERE.
          switch (nd.data.farmtypeid) {
            case 5:
              var DataFarmTypeID = 1
              break;
            case 4:
              var DataFarmTypeID = 2
              break;
            case 6:
              var DataFarmTypeID = 3
              break;
              case 7:
              var DataFarmTypeID = 7
              break;
            case 3:
              var DataFarmTypeID = 4
              break;
            case 2:
              var DataFarmTypeID = 5
              break;
            case 1:
              var DataFarmTypeID = 6
              break;
            default:
              //alert(0)
              var DataFarmTypeID = 0
              break;
          }

          if(configGuid){
            const configJson = await this.configService.getConfigByGuidAsync(configGuid);
            this.userData.setSelectedConfigJson(configJson);
            if(nd.data.nodeboxtypeid==1){
             // alert("node box 1");
              this.userData.setSelectedTabIndex(0);
              this.router.navigateByUrl(`dataTransformConfig/${configGuid}/configDetail`, {state: {config: configJson, dataSourceType:DataFarmTypeID, selectedTabIndex: 0,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId, nodeType:nd.data.nodeboxtypeid, LinksforNode_Data:LinksforNode_Data, LinksforNode_Attr:LinksforNode_Attr  }});
            }
            else if(nd.data.nodeboxtypeid==2){
              this.userData.setSelectedTabIndex(1);
              this.router.navigateByUrl(`dataTransformConfig/${configGuid}/configDetail`, {state: {config: configJson, selectedTabIndex: 1,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId, nodeType:nd.data.nodeboxtypeid, LinksforNode_Data:LinksforNode_Data, LinksforNode_Attr:LinksforNode_Attr }});
            }
            else if(nd.data.nodeboxtypeid==3){
              this.userData.setSelectedTabIndex(1);
              this.router.navigateByUrl(`dataTransformConfig/${configGuid}/configDetail`, {state: {config: configJson, selectedTabIndex: 1,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId, nodeType:nd.data.nodeboxtypeid, LinksforNode_Data:LinksforNode_Data, LinksforNode_Attr:LinksforNode_Attr }});
              //this.router.navigateByUrl(`dataTransformConfig/${configGuid}/joinerTransformDetail`, {state: {config: configJson, selectedTabIndex: 1,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId, nodeType:nd.data.nodeboxtypeid, LinksforNode_Data:LinksforNode_Data, LinksforNode_Attr:LinksforNode_Attr }});
            }
            else if(nd.data.nodeboxtypeid==4){
              this.userData.setSelectedTabIndex(1);
              this.router.navigateByUrl(`dataTransformConfig/${configGuid}/configDetail`, {state: {config: configJson, selectedTabIndex: 1,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId, nodeType:nd.data.nodeboxtypeid, LinksforNode_Data:LinksforNode_Data, LinksforNode_Attr:LinksforNode_Attr }});
              //this.router.navigateByUrl(`dataTransformConfig/${configGuid}/farmconverterTransformDetail`, {state: {config: configJson, selectedTabIndex: 1,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId, nodeType:nd.data.nodeboxtypeid, LinksforNode_Data:LinksforNode_Data, LinksforNode_Attr:LinksforNode_Attr }});
            }
            else{
    
            }
          }
          else{
            if(nd.data.nodeboxtypeid==1){
              this.userData.setSelectedTabIndex(0);
              this.userData.setSelectedConfigJson(null);
              this.router.navigateByUrl(`dataTransformConfig/null/configDetail`, {state: {dataSourceType:DataFarmTypeID, newConfigDataSourceType: DataFarmTypeID, refineryConfig:this.viewModel.dataRefineryConfig, selectedTabIndex: 0,refineryConfigGuid:refineryConfigGuid,refineryName:refineryName,nodename:nodename,nodeId:nodeId}});
            }
            else{
              this.displayError('The Ingest Node is not configured to ingest data, please correct before proceeding.','warning','');
            }
          }

          
      } catch (err) {
        this.displayError('Failed to download pipeline', 'Error', err);
      } finally {
        busyDialog.close();
      }
    }
  }

  async DataPreview(nodeId:string): Promise<void> {
    await this.resetAllPreviewData();

    this.inputPrvwFilterViewModel.resetProps();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);

    this.refineryPreviewPanelOpenState = false;
    var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == nodeId);

    if(nd.data.nodeboxtypeid == 3){
      this.outputDataFarmPreviewTable.onRefreshClicked();

      var joinerlists:JoinerListResponse[];
      var request=new JoinerListRequest();
      request.userId=this.userData.getUserId();
      request.orgId=this.userData.getOrgId();
      request.refineryId=this.viewModel.dataRefineryConfig.guid;
      request.nodeId=nodeId;
      request.cacheKeyType=CacheKeyType.node;
      joinerlists= await this.configService.getJoinerList(request);
      //Joiner
      this.previewInputTableLabel="";
      this.joinerPreviewTabs = [];
      this.joinerSelectValues = [];
      this.joinerSelectEmptyColumns = [];
      this.joinerSelectFilterValues = [];
      this.joinerTotalSummaryRows = [];

      [...joinerlists].sort((a, b) => a.index - b.index).forEach(map => {
        this.joinerPreviewTabs.push({
          label: "Node " + map.indexName + " (" + map.nodePreviewData.data.columns.length + " Columns)",
          color: map.nodeColor,
          nodeName: "Node " + map.indexName
        });
        this.joinerSelectValues.push([]);
        this.joinerSelectEmptyColumns.push([]);
        this.joinerSelectFilterValues.push([]);
        this.joinerTotalSummaryRows.push("");
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.joinerInputPreviewTables.forEach(table => {
          this.refreshPreviewTable(table);
        });
      });
    }else{
      this.joinerPreviewTabs = [];
      this.joinerSelectValues = [];
      this.joinerSelectEmptyColumns = [];
      this.joinerSelectFilterValues = [];
      this.joinerTotalSummaryRows = [];
      this.previewInputTableLabel="Input ("+this.inputColumnCount+" Columns)";

      if(this.inputDataFarmPreviewTable){
        this.refreshPreviewTable(this.inputDataFarmPreviewTable);
      }else{
        setTimeout(() => {
          this.refreshPreviewTable(this.inputDataFarmPreviewTable);
        });
      }
      this.refreshPreviewTable(this.outputDataFarmPreviewTable);
     
    }
    this.cdr.detectChanges();
  }

  async refreshPreviewTable(sender: PreviewTableComponent): Promise<void> {
    // Download the data for the previewTable
    if (sender === this.inputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    }else if (sender === this.outputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    }else if (sender === this.summaryDataFarmPreviewTableInput){
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    }else if (sender === this.summaryDataFarmPreviewTableOutput){
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    }else if ((this.joinerSummaryPreviewTables?.toArray().indexOf(sender) ?? -1) >= 0) {
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    }else {
      const inputIdx = this.joinerInputPreviewTables?.toArray().indexOf(sender) ?? -1;
      if (inputIdx >= 0) {
        var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.previewNodeId);
        var ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == nd.data.ingestId);
        var configGuid=ingestnode.data.configGuid;
        if(configGuid){
          var configJson = await this.configService.getConfigByGuidAsync(configGuid);
        }
        var joinerTrans=configJson.transforms.find(t=>t.nodeID==this.previewNodeId);
        var fieldMap=joinerTrans.transformConfig.fieldMap;
        const dataFarmId = fieldMap.find(x => x.index === inputIdx).nodeID;
        this.refreshJoinerDataFarmPreviewAsync(sender, dataFarmId);
      }
    }
  }
  
  async refreshInputDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    const busyDialog = this.showBusyDialog('Loading Data...');
    try {
      if(sender){
        sender.isGettingData.next(true);
      }
      const inputOutputTabDataFrFilter = this.userData.getInputTabDataFrFilter();
      var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.previewNodeId);
      var ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == nd.data.ingestId);
      var configGuid=ingestnode.data.configGuid;
      if(configGuid){
        var configJson = await this.configService.getConfigByGuidAsync(configGuid);
      }
      const configconnector=configJson.dataConnectorMappings.find(x=>x.guid==configJson.selectedIngestFarmGuid);//[0];
      var dataconnector=configconnector.dataConnector;
      delete dataconnector['dataSourceType'];
      const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage);
      // options.NodeID = this.viewModel.activeFilters;
      const filters = sender.activeFilterSet?.map(f => {
        const filterInfo = new ColumnFilter();
        filterInfo.field = f.columnName;
        filterInfo.values = f.values;
        return filterInfo;
      });
      options.filters = filters;//this.viewModelt.activeFilters;
      options.sortInfo=this.activeSortsSet;

      var parentNodes = ""
      if(nd.data.nodeboxtypeid == 1) {
        parentNodes = this.previewNodeId;
      } else {
        if(nd.data.nodeboxtypeid != 1) {
          var links = this.viewModel.dataRefineryConfig.links.find(x => x.target == this.previewNodeId && x.data.linetype=="line");
          parentNodes = (inputOutputTabDataFrFilter.previewType == "RefineryInput" && inputOutputTabDataFrFilter.farmId.length > 0) ? inputOutputTabDataFrFilter.farmId : links.source;
        }
      }
      
      var selectedNodes = (inputOutputTabDataFrFilter.previewType == "RefineryOutput" && inputOutputTabDataFrFilter.farmId.length > 0) ? inputOutputTabDataFrFilter.farmId : this.previewNodeId;
      var refineryConfig= this.userData.getSelectedRefineryDetails() ;
      var refineryConfigGuid = refineryConfig.guid ;

      var request :GetDataFarmPreviewRequest = null;
      let transformId = (this.userData.getTransformId() == undefined) ? null : this.userData.getTransformId();
      if ((sender === this.inputDataFarmPreviewTable && (nd.data.nodeboxtypeid !=1 || nd.data.nodeboxtypeid ==1))) {
        request = new GetDataFarmPreviewRequest(
          this.userData.getUserId(),
          this.userData.getOrgId(),
          this.userData.getRefineryId(),
          parentNodes,//this.userData.getNodeId(),
          transformId,
          CacheKeyType.node,
          options);
          this.inputPrvwFarmId = request.nodeId;
      }  else if (sender === this.outputDataFarmPreviewTable) {
        request = new GetDataFarmPreviewRequest(
          this.userData.getUserId(),
          this.userData.getOrgId(),
          this.userData.getRefineryId(),
          selectedNodes,//this.userData.getNodeId(),
          transformId,
          CacheKeyType.node,
          options);
          this.outputPrvwFarmId = request.nodeId;
      } 
       
      const response = await this.configService.getInputDataForNode(request);
      if(response.data.totalRows==0){
      //later implement input or output have file or not
        if (sender == this.inputDataFarmPreviewTable) {
          this.inputColumnCount = 0;
          this.inputDataFarmPreviewTable.clear();
        } else {
          this.outputColumnCount = 0;
          this.outputDataFarmPreviewTable.clear();
        }
      }
      else{
        sender.bindData(response.data, 'No Preview Data');
        if (sender == this.inputDataFarmPreviewTable) {
          this.inputColumnCount = response.data.columns.length;
          if(this.selectFilterValuesInput.length > 0) {
            this.refreshSummaryDataFarmPreviewAsync(this.summaryDataFarmPreviewTableInput, true);
          }
        } else {
          this.outputColumnCount = response.data.columns.length;
          if(this.selectFilterValuesOutput.length > 0) {
            this.refreshSummaryDataFarmPreviewAsync(this.summaryDataFarmPreviewTableOutput, true);
          }
          
        }
        (this.selectedIndex == 0) ? this.setInputOutputTabDataFrFilter(this.inputPrvwFarmId, "RefineryInput") :  this.setInputOutputTabDataFrFilter(this.outputPrvwFarmId, "RefineryOutput");
        if(this.refineryListpanelOpenState == false) {
          this.refineryPreviewPanelOpenState = true;
        }
      }
      
    } catch (err) {
      this.displayError('Failed to get data farm preview...........', 'Error', err);
    } finally {
      if(sender){
        sender.isGettingData.next(true);
      }
      busyDialog.close();
    }
  }
  async refreshJoinerDataFarmPreviewAsync(sender: PreviewTableComponent,dataFarmId:string): Promise<void> {
    try {
      if(sender){
        sender.isGettingData.next(true);
      }
      var configJson = this.userData.getSelectedConfigJson();

      const configconnector=configJson.dataConnectorMappings[0];
      var dataconnector=configconnector.dataConnector;
      delete dataconnector['dataSourceType'];

      const filters = sender.activeFilterSet?.map(f => {
        const filterInfo = new ColumnFilter();
        filterInfo.field = f.columnName;
        filterInfo.values = f.values;
        return filterInfo;
      });
      const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage,this.activeSortsSet,filters);
       let transformId = (this.userData.getTransformId() == undefined) ? null : this.userData.getTransformId();
       var request :GetDataFarmPreviewRequest = null;
       request = new GetDataFarmPreviewRequest(
        this.userData.getUserId(),
        this.userData.getOrgId(),
        this.userData.getRefineryId(),
        dataFarmId,//this.userData.getNodeId(),
        transformId,
        CacheKeyType.node,
        options);
      
      const response = await this.configService.getInputDataForNode(request);
      sender.bindData(response.data, 'No input preview data');
      const inputIdx = this.joinerInputPreviewTables?.toArray().indexOf(sender) ?? -1;
      if (inputIdx >= 0 && (this.joinerSelectFilterValues[inputIdx]?.length ?? 0) > 0) {
        const summaryTable = this.joinerSummaryPreviewTables?.toArray()[inputIdx];
        if (summaryTable) {
          this.refreshSummaryDataFarmPreviewAsync(summaryTable, true);
        }
      }
      //this.lookupcolumncount=response.data.columns.length;
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
    }
  }
  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;

    // Alert the tab index and label
  // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
  if(selectedTabLabel.match("Input") && selectedTabIndex == 0) {
    this.setInputOutputTabDataFrFilter(this.inputPrvwFarmId, "RefineryInput");
  } else {
    this.setInputOutputTabDataFrFilter(this.outputPrvwFarmId, "RefineryOutput");
  }
  //  if(selectedTabLabel.match("Summary") && selectedTabIndex == 2) {
  //    if(this.source.length > 0) {
  //       let selectFilterInfoSummary = new SelectFilterInfo(this.source, this.selectFilterValues);
  //       this.onApplySelect(selectFilterInfoSummary);
  //    }
  //  }
  //  if(selectedTabLabel==""){
  //   this.refreshPreviewTable(this.previewTableA);
  //  }
  }

setInputOutputTabDataFrFilter(prvwFarmId: string, previewType: string) {
  this.inputPrvwFilterViewModel.farmId = prvwFarmId;
  this.inputPrvwFilterViewModel.previewType = previewType;
  this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
}
 
onToggleChange(isChecked: boolean, config: DataRefineryConfig): void {
  // Convert isChecked to a number (1 for true, 0 for false)
  const checkedValue = isChecked ? 1 : 0;

  const title = checkedValue === 1 ? 'Share refinery config?' : 'Unshare refinery config?';
  const message = checkedValue === 1 
    ? 'Are you sure you want to share this refinery config?' 
    : 'Are you sure you want to unshare this refinery config?';

  this.showConfirmDialog(title, message, async (result) => {
    if (result) {
      try {
        config.shared = checkedValue; // Directly assign the number (1 or 0)
        // This save goes through the same backend Edit-lock check as any
        // other — but toggling a row in the LIST never opened this
        // refinery for editing, so acquire the lock just long enough for
        // this one save (see withTransientEditLock) rather than letting it
        // 403 outright.
        const lock = await this.refineryPresence.withTransientEditLock(config.guid, async () => {
          await this.configService.UpsertRefineryConfig(config);
          await this.saveRefineryTable(config);
        });
        if (!lock.granted) {
          config.shared = checkedValue === 0 ? 1 : 0; // revert — nothing was saved
          this.displayWarning(
            `Currently being edited by ${lock.holderUserName ?? 'another session'}. Cannot change sharing right now.`,
            'Refinery is Busy.'
          );
          return;
        }

        const snackbarMessage = checkedValue === 1
          ? 'Successfully shared refinery config'
          : 'Successfully unshared refinery config';

        this.snackBar.open(snackbarMessage, 'Dismiss', {
          duration: 5000
        });

      } catch (err) {
        // Log the error or display an error message
        // this.displayError('Failed to update the config', 'Error', err);
      }
    } else {
      // Revert the shared state if the user cancels the operation
      config.shared = checkedValue === 0 ? 1 : 0; // Revert the value as a number
    }
  });
}
onPublicToggleChange(isChecked: boolean, config: DataRefineryConfig): void {
 
  const title = isChecked ? 'Make refinery configuration public?' : 'Remove refinery configuration from public access?';
  const message = isChecked 
    ? 'Are you sure you want to make this refinery configuration public? This will share it across all organizations.'
    : 'Are you sure you want to remove this refinery configuration from public access? It will no longer be shared with other organizations.';
  
  this.showConfirmDialog(title, message, async (result) => {
    if (result) {
      try {
        config.publicShared = isChecked;
        // See onToggleChange() — same reasoning: this row's save needs a
        // transient Edit-lock acquire since the list never opened it.
        const lock = await this.refineryPresence.withTransientEditLock(config.guid, async () => {
          await this.configService.UpsertRefineryConfig(config);
          await this.saveRefineryTable(config);
        });
        if (!lock.granted) {
          config.publicShared = !isChecked; // revert — nothing was saved
          this.displayWarning(
            `Currently being edited by ${lock.holderUserName ?? 'another session'}. Cannot change sharing right now.`,
            'Refinery is Busy.'
          );
          return;
        }

        const snackbarMessage = isChecked
          ? 'Refinery configuration has been made public successfully.'
          : 'Refinery configuration has been removed from public access successfully.';

        this.snackBar.open(snackbarMessage, 'Dismiss', {
          duration: 5000,
        });
      } catch (err) {
        // Handle error appropriately
        // this.displayError('Failed to update the refinery configuration', 'Error', err);
      }
    } else {
      // Revert the toggle state if user cancels the action
      config.publicShared = !isChecked;
    }
  });
}

async duplicateConfigPipeLine(config: DataTransformerConfig,refineryName:string): Promise<DataTransformerConfig> {
  let newConfig = new DataTransformerConfig();
  const proposedName = refineryName;//this.generateProposedNamePipeLine(config, 1);

  // const dialogConfig = new MatDialogConfig();
  // dialogConfig.disableClose = true;
  // dialogConfig.autoFocus = true;
  // dialogConfig.width = '400px';
  // dialogConfig.data = {title: 'Duplicate Pipeline', stringValue: proposedName, placeholder: 'Enter Pipeline name'};

  //const dialogRef = this.matDialog.open(NewSingleStringValueDialogComponent, dialogConfig);

  //dialogRef.afterClosed().subscribe( async result => {
    //if (!result.stringValue) { return; }

    const dialog = this.showBusyDialog('Duplicating pipeline...');
    
    try {
      newConfig = Object.assign(newConfig, config);
      newConfig.guid = uuidv4();
      newConfig.name = proposedName;
      newConfig.transforms.forEach(t => t.guid = uuidv4());
      newConfig.createdDateTime = null;
      newConfig.modifiedDateTime = null;

      newConfig = await this.configService.upsertConfig(newConfig);
      //const configs = this.mappingConfigsSubject.value;
      //configs.push(newConfig);
      //configs.sort( (a, b) =>
        //b.modifiedDateTime.getTime() - a.modifiedDateTime.getTime()
      //);

      //this.mappingConfigsSubject.next(configs);
      
    } catch (error) {
      this.displayError('Failed to duplicate pipeline', 'Error', error);
    } finally {
      dialog.close();
    }
  //});
  return newConfig;
}
async ResetNode(): Promise<any> {
  if (!(await this.warnAndBlockIfRefineryBusy())) {
    return;
  }
  var nodeId=this.id;
  const busyDialog = this.showBusyDialog('Resetting node...');

  const confirmationResult = await new Promise<boolean>((resolve) => {
    this.showConfirmDialog(
      'Reset Node  will reset the node to the Idle state !',
      ' ',
      (result) => resolve(result)
    );
  });
  if (!confirmationResult) {
    busyDialog.close();
    return;
  }
  await this.refreshBeforeMutatingAction();
   let refineryConfigID = this.viewModel.dataRefineryConfig.guid;
   var runNodeRequest: RunrefineryRequest = new RunrefineryRequest(this.userData.getUserId(), this.userData.getOrgId(),refineryConfigID,nodeId, this.refineryPresence.tabId);
   try {
    var resetRefineryResponse = await this.configService.resetNodeRefinery(runNodeRequest);
        // Get all elements with the class 'nodeHighLighted'
        var elements = document.querySelectorAll('.nodeHighLighted');
        // Loop through the elements and remove the class from each one
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove('nodeHighLighted');
        }
     this.inputColumnCount = 0;
     this.outputColumnCount = 0;

     if (this.inputDataFarmPreviewTable?.clear) {
       this.inputDataFarmPreviewTable.clear();
     }
     if (this.outputDataFarmPreviewTable?.clear) {
       this.outputDataFarmPreviewTable.clear();
      }
   } catch(err) {
      this.displayError('Failed to reset the refinery', 'Error', err);
   } finally {
      await this.pullLatestRefineryStatus();
      this.update$.next(true);
      busyDialog.close()
   }
}

  async insertNode(nodeboxtypeid: number): Promise<void> {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    const selectedNodeId:any = this.id;
    this.showConfirmDialog('Insert Confirmation', `Inserting a node may compromise the pipeline`,async (confirmed) => {
      if (confirmed) {
        var eventname="";
        if(nodeboxtypeid==2){
          eventname="Insert Processor";
        }else if(nodeboxtypeid==3){
          eventname="Insert Joiner";
        }
        await this.UndoBuffer(eventname);

        var nodeid = "n" + uuidv4();
        var linkid = "l" + uuidv4();
        var currentDateTime =  this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

        var nbt = this.nodeboxtype.find(x => x.id == nodeboxtypeid);
        if (!nbt) return;

        var nd = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == selectedNodeId);
        if (!nd) return;
        var Newfarmtypeid: any = nd.data.farmtypeid;

        /** Farmtype for Adding converter.  'Converter'= 4 */
        if (nodeboxtypeid == 4) {
          if (nd.data.farmtypeid == 1) {
            Newfarmtypeid = 2;
          } else if (nd.data.farmtypeid == 2) {
            Newfarmtypeid = 3;
          } else {
            Newfarmtypeid = nd.data.farmtypeid;
          }
        }
        //Insert After/Before
        var isInsertBefore=true;
        if(nodeboxtypeid == 2 || nodeboxtypeid == 4) {
          isInsertBefore=true;
        }else if(nodeboxtypeid == 3){
          isInsertBefore=false;
        }
        var joinernodecount = this.viewModel.dataRefineryConfig.nodes.length + 999;

        if(isInsertBefore){
          var existingNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == selectedNodeId);
          var existingLink = this.viewModel.dataRefineryConfig.links.find(x => x.target == selectedNodeId && x.data.linetype=="line");
          //if this node is farm convert then change farmtypeid
          if(existingNode.data.nodeboxtypeid==4){
            var ingestNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == existingNode.data.ingestId);
            Newfarmtypeid=ingestNode.data.farmtypeid;
          }
          //create Node & set parent id
          var node = {
            id: nodeid,
            label: "",
            data: { farmtypeid: Newfarmtypeid, nodeboxtypeid: nodeboxtypeid, subtitle: nbt.nodetype, isdbupdater: false, parentid: existingNode.data.parentid, isEditTitle: true,
                    isEditSubtitle: false, dbWriterType: 'none', nodecolorno: joinernodecount, nodeStatus: NodeRunStatus.Idle, createdDateTime: currentDateTime,
                    lastSaveddDateTime: currentDateTime  },
            dimension: { height: this.viewModel.nodeHeight, width: this.viewModel.nodeWidth }
          };

          //create Link
          var countno = this.viewModel.dataRefineryConfig.links.filter(x => x.source == existingNode.data.parentid).length + 1;
          if (countno > 0) {
            var lnks = this.viewModel.dataRefineryConfig.links.filter(x => x.source == existingNode.data.parentid && x.data.countno == 1).length;
            if (lnks == 0) {
              countno = 1;
            }
            else {
              countno = countno + 1;
            }
          }
          else {
            countno = countno + 1;
          }

          var link = {
              id: linkid,
              source: nodeid,
              target: selectedNodeId,
              label: '',
              data: { linetype: "line", linkcolorno: joinernodecount, countno: existingLink.data.countno }
            }
          //update parent id of existing 
          existingNode.data.parentid=nodeid;
          //update existing link
          existingLink.target=nodeid;

          // Insert the new node before the existing node
          const existingIndex = this.viewModel.dataRefineryConfig.nodes.findIndex(x => x.id == selectedNodeId);
          this.viewModel.dataRefineryConfig.nodes.splice(existingIndex, 0, node);

          //this.viewModel.dataRefineryConfig.nodes.push(node);
          this.viewModel.dataRefineryConfig.links.push(link);
        }else{
          var existingNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == selectedNodeId);
          var existingLink = this.viewModel.dataRefineryConfig.links.find(x => x.source == selectedNodeId && x.data.linetype=="line");
          //create Node & set parent id
          var node = {
            id: nodeid,
            label: "",
            data: { farmtypeid: Newfarmtypeid, nodeboxtypeid: nodeboxtypeid, subtitle: nbt.nodetype, isdbupdater: false, parentid: selectedNodeId, isEditTitle: true,
                    isEditSubtitle: false, dbWriterType: 'none', nodecolorno: joinernodecount, nodeStatus: NodeRunStatus.Idle, createdDateTime: currentDateTime,
                    lastSaveddDateTime: currentDateTime  },
            dimension: { height: this.viewModel.nodeHeight, width: this.viewModel.nodeWidth }
          };

          //create Link
          var countno = this.viewModel.dataRefineryConfig.links.filter(x => x.source == existingNode.data.parentid).length + 1;
          if (countno > 0) {
            var lnks = this.viewModel.dataRefineryConfig.links.filter(x => x.source == existingNode.data.parentid && x.data.countno == 1).length;
            if (lnks == 0) {
              countno = 1;
            }
            else {
              countno = countno + 1;
            }
          }
          else {
            countno = countno + 1;
          }

          var link = {
              id: linkid,
              source: nodeid,
              target: existingLink.target as any,
              label: '',
              data: { linetype: "line", linkcolorno: joinernodecount, countno: existingLink.data.countno }
            }
          //update parent id of existing 
          var nextNode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == existingLink.target);
          nextNode.data.parentid=nodeid;
          //update existing link
          existingLink.target=nodeid;

          // Insert the new node before the existing node
          const existingIndex = this.viewModel.dataRefineryConfig.nodes.findIndex(x => x.id == selectedNodeId);
          this.viewModel.dataRefineryConfig.nodes.splice(existingIndex+1, 0, node);

          //this.viewModel.dataRefineryConfig.nodes.push(node);
          this.viewModel.dataRefineryConfig.links.push(link);
        }
        
        await this.updateParentChildNodesStatus(nodeid);
        var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
        this.positioningNodes();
        this.update$.next(true);
        this.focusEditTitle(nodeid);
      }
    });
  }
renameNode(): void {
  const id: any = this.id;
  this.isMouseFocus = true;
  this.hideGearIconOver();

  const node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id === id);
  if (!node) return;

  node.data.isEditTitle = true;
  node.data.isHighlightBlue = true;

  this.focusEditTitle(id);
}

  async removeNode(): Promise<void> {
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    const nodeid = this.id;
    var existingLinks = this.viewModel.dataRefineryConfig.links.filter(x => x.source == nodeid);
    if(existingLinks.length>1){
      this.displayWarning("Cannot remove node that have multiple output pipes","Cannot remove node");
      return;
    }else{
      this.showConfirmDialog('Remove Confirmation', `Removing the node may compromise the pipeline`, async (confirmed) => {
        if (confirmed) {
          const busyIndicator = this.showBusyDialog('Removing Node.');
          try {
            var nodeDetails = this.viewModel.dataRefineryConfig.nodes.find(node => node.id === nodeid);
            var eventname="";
            var nextNode:Node =null;
            if(nodeDetails.data.nodeboxtypeid==2){
              eventname="Remove Processor";
            }else if(nodeDetails.data.nodeboxtypeid==3){
              eventname="Remove Joiner";
            }
            else if(nodeDetails.data.nodeboxtypeid==4){
              eventname="Remove Converter";
            }
            await this.UndoBuffer(eventname);
            if(existingLinks.length==0){
              var targetlinks = this.viewModel.dataRefineryConfig.links.filter(x => x.target == nodeid);
              if (targetlinks) {
                targetlinks.forEach((value, index) => {
                  if (!value.id) return;
                  this.removeElementFromLinks(value.id);
                });
              }
              this.removeElementFromNodes(nodeid);
            }
            else{
              const primaryNode = this.viewModel.dataRefineryConfig.nodes.find(node => node.id === nodeid);
              const primaryLink = this.viewModel.dataRefineryConfig.links.find(link=>link.target == nodeid && link.data?.linetype=="line");
              const nextLink = this.viewModel.dataRefineryConfig.links.find(link=>link.source == nodeid && link.data?.linetype=="line");
              var sourcelinks = this.viewModel.dataRefineryConfig.links.filter(x => x.source == nodeid);
              if (sourcelinks) {
                sourcelinks.forEach((value, index) => {
                  if (!value.id) return;
                  this.removeElementFromLinks(value.id);
                  if(value.data?.linetype=="joiner"){
                    this.updateNodeStatusNotConfigured(value.target);
                  }
                });
              }
              var targetlinks = this.viewModel.dataRefineryConfig.links.filter(x => x.target == nodeid && x.data?.linetype!="line");
              if (targetlinks) {
                targetlinks.forEach((value, index) => {
                  if (!value.id) return;
                  this.removeElementFromLinks(value.id);
                });
              }
              this.removeElementFromNodes(nodeid);
              if(nextLink){
                primaryLink.target=nextLink.target;
                //update parent id to after node
                nextNode = this.viewModel.dataRefineryConfig.nodes.find(node => node.id === nextLink.target);
                nextNode.data.parentid=primaryNode.data.parentid;
              }else{
                this.removeElementFromLinks(primaryLink.id);
              }
            }
            this.viewModel.dataRefineryConfig.nodes = [...this.viewModel.dataRefineryConfig.nodes];
            this.viewModel.dataRefineryConfig.links = [...this.viewModel.dataRefineryConfig.links];
            this.positioningNodes();
            if(nextNode!=null){
              await this.updateParentChildNodesStatus(nextNode.id);
            }
            var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
            this.update$.next(true);
          } 
          catch (err) {
            this.displayError('Failed to remove node', 'Error', err);
          } finally {
            busyIndicator.close();
          }
        }
      });
    }   
  }
  dataRefineryConfigNodesBackup:Node[]=[];
  dataRefineryConfigLinksBackup:Edge[]=[];
  async UndoConfig(){
    if (!(await this.warnAndBlockIfRefineryBusy())) {
      return;
    }
    this.showConfirmDialog('Undo Confirmation', `Undo will change the refinery back to its previous state`,async (confirmed) => {
      if (confirmed) {
        this.UndoConfigDisabled = true;
        this.undoConfigEvent="";   
        this.viewModel.dataRefineryConfig.nodes=[...this.dataRefineryConfigNodesBackup];
        this.viewModel.dataRefineryConfig.links=[...this.dataRefineryConfigLinksBackup];
        var config = await this.configService.UpsertRefineryConfig(this.viewModel.dataRefineryConfig);
        this.positioningNodes();
        this.update$.next(true);
      }
    });
  }
  async UndoBuffer(event:string){
    this.UndoConfigDisabled = false;
    this.undoConfigEvent="("+event+")";
    this.dataRefineryConfigNodesBackup = _.cloneDeep(this.viewModel.dataRefineryConfig.nodes);
    this.dataRefineryConfigLinksBackup = _.cloneDeep(this.viewModel.dataRefineryConfig.links);
  }
  async updateParentChildNodesStatus(id:string): Promise<void>{
    await this.updateNodeStatus(id);
    await this.updateChildNodesStatus(id); 
  }
  async updateChildNodesStatus(id:string): Promise<void>{
    var childLink =this.viewModel.dataRefineryConfig.links.find(link=>link.source===id);
    if (!childLink) return;
    //Recursively update the status of each target node
    //for (const link of childLinks) {
      await this.updateNodeStatus(childLink.target); // update the immediate target's status
      await this.updateChildNodesStatus(childLink.target); // recursive call to go deeper
    //}
  }
  async updateNodeStatus(id:string): Promise<void>{
    var nodeDetails=this.viewModel.dataRefineryConfig.nodes.find(node=>node.id===id);
    if (!nodeDetails) return;
    nodeDetails.data.nodeStatus=NodeRunStatus.PipelineModified;
  }
  async updateNodeStatusNotConfigured(id:string): Promise<void>{
    var nodeDetails=this.viewModel.dataRefineryConfig.nodes.find(node=>node.id===id);
    if (!nodeDetails) return;
    nodeDetails.data.nodeStatus=NodeRunStatus.NotConfigured;
  }


      async ShowTransformerType(): Promise<void> {
       
        const clickedNodeId = this.id;
        const configJson = await this.configService.getAllConfigs(1);
        
        // Find only the clicked node
        const node = this.viewModel.dataRefineryConfig.nodes.find(n => n.id === clickedNodeId);
        if (!node) {
          console.warn("Clicked node not found:", clickedNodeId);
          return;
        }
      
        const ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id === node.data.ingestId);
        const config = configJson.find(config => config.guid === ingestnode?.data?.configGuid);
      
        let subtitle = "";
      
       
      
        if(config){
          
      
          if(node.data.nodeboxtypeid == 2){
            let names = "";
            config.transforms
              .filter(trans => trans.nodeID === node.id)
              .sort((a,b) => a.index - b.index)
              .forEach(transform => {
                let val = TransformTypeUtil.toString(transform.transformType).replace(/\s*Transform\s*$/, '');
                names += val + " > ";
              });
            if(names !== ""){
              subtitle = names.replace(/>\s*$/, "");
            }
          }
        }
      
        node.data.subtitle = subtitle;
      
      }
      
  async ShowTransformerNames(){

    const clickedNodeId = this.id;
    const configJson = await this.configService.getAllConfigs(1);
    
    // Find only the clicked node
    const node = this.viewModel.dataRefineryConfig.nodes.find(n => n.id === clickedNodeId);
    if (!node) {
      console.warn("Clicked node not found:", clickedNodeId);
      return;
    }
  
    const ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id === node.data.ingestId);
    const config = configJson.find(config => config.guid === ingestnode?.data?.configGuid);
  
    let subtitle = "";
  
   
  
    if(config){
      if(node.data.nodeboxtypeid == 2){
        var names="";
            config.transforms.filter(trans=>trans.nodeID==node.id).sort((a,b)=>a.index-b.index).forEach(transform=>{
              names=names+transform.name+" > ";
            })
            if(names!=""){
              subtitle=names.replace(/>\s*$/, "");
            }
      }
    }
  
      node.data.subtitle = subtitle;
      //this.transformerLabel = 'Show Transformer Type'; // Next toggle label
     this.cdr.detectChanges();  // force Angular to update the UI

    
  }
  toggleTransformerView() {
  // Flip toggle state (true/false)
   const nodeId = this.id;
  this.transformerToggleState[nodeId] = !this.transformerToggleState[nodeId];

  if (this.transformerToggleState[nodeId]) {
    this.ShowTransformerType();
  } else {
    this.ShowTransformerNames();
  }

  // Update label if you maintain labels map
  this.updateTransformerToggleLabels();
}
// Update labels for all nodes based on toggle state
updateTransformerToggleLabels() {
  this.viewModel.dataRefineryConfig.nodes.forEach(node => {
    const isShowType = this.transformerToggleState[node.id] ?? true; // default true if undefined
    // Assign only a string here — no objects!
    this.transformerToggleLabels[node.id] = isShowType ? 'Show Transformer Name' : 'Show Transformer Type';
  });
}



isTransformerTypeEnabled(): boolean {
    const id = this.id;
  const nodedetail = this.viewModel.dataRefineryConfig.nodes.find(nd => nd.id == id);
  const isType2 = nodedetail?.data?.nodeboxtypeid === 2;
  const subtitle = nodedetail?.data?.subtitle?.trim();
  const hasValidSubtitle = subtitle && subtitle !== '**No Transformers Added**';
  return isType2 && hasValidSubtitle;
}

  source: string="";

  selectValues?: any[]=[];
  selectValuesInput?: any[]=[];
  selectValuesOutput?: any[]=[];
  joinerSelectValues: any[][] = [];
  joinerSelectEmptyColumns: any[][] = [];
  joinerSelectFilterValues: any[][] = [];
  joinerTotalSummaryRows: string[] = [];

  selectEmptyColumns?: any[]=[];
  selectEmptyColumnsInput?: any[]=[];
  selectEmptyColumnsOutput?: any[]=[];

  selectFilterValues?: any[]=[];
  selectFilterValuesInput?: any[]=[];
  selectFilterValuesOutput?: any[]=[];

  menuTrigger: MatMenuTrigger=null;
  totalSummaryRowsInput:string="";
  totalSummaryRowsOutput:string="";

  prevSource: string="";

  async refreshSummaryDataFarmPreviewAsync(sender: PreviewTableComponent, isNewCache: boolean = false): Promise<void> {
    const busyIndicator = this.showBusyDialog('Loading Data Preview Summary.');
    this.userData.setIsProcessrInputsummryprevwClicked(false);
    try {
      if(this.selectFilterValues.length==0){
        //this.displayWarning("No columns have been selected.","Warning");
      }else{
        const filters = sender.activeFilterSet?.map(f => {
          const filterInfo = new ColumnFilter();
          filterInfo.field = f.columnName;
          filterInfo.values = f.values;
          return filterInfo;
        });
        const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage);
        options.filters = filters;
        options.sortInfo=sender.activeSortsSet ?? []; 

        var request :GetSummaryDataFarmPreviewRequest = null;
        if (sender === this.summaryDataFarmPreviewTableInput) {
          this.totalSummaryRowsInput="";
          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryInput);
          const parentFilters = (this.inputDataFarmPreviewTable.activeFilterSet ?? []).map(f => {
            const filterInfo = new ColumnFilter();
            filterInfo.field = f.columnName;
            filterInfo.values = f.values;
            return filterInfo;
          });
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            options,
            this.selectFilterValuesInput.join(',') ?? '');
          request.parentFilters = parentFilters;
        }else if (sender === this.summaryDataFarmPreviewTableOutput) {
          this.totalSummaryRowsOutput="";
          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryOutput);
          const parentFilters = (this.outputDataFarmPreviewTable.activeFilterSet ?? []).map(f => {
            const filterInfo = new ColumnFilter();
            filterInfo.field = f.columnName;
            filterInfo.values = f.values;
            return filterInfo;
          });
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            options,
            this.selectFilterValuesOutput.join(',') ?? '');
          request.parentFilters = parentFilters;
        }else {
          const joinerIdx = this.joinerSummaryPreviewTables?.toArray().indexOf(sender) ?? -1;
          if (joinerIdx >= 0) {
            this.joinerTotalSummaryRows[joinerIdx] = "";
            const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[joinerIdx]);
            const inputTable = this.joinerInputPreviewTables?.toArray()[joinerIdx];
            const parentFilters = (inputTable?.activeFilterSet ?? []).map(f => {
              const filterInfo = new ColumnFilter();
              filterInfo.field = f.columnName;
              filterInfo.values = f.values;
              return filterInfo;
            });
            request = new GetSummaryDataFarmPreviewRequest(
              cachekeyRequest.userId,
              cachekeyRequest.orgId,
              cachekeyRequest.refineryId,
              cachekeyRequest.nodeId,
              cachekeyRequest.transformId,
              cachekeyRequest.cacheKeyType,
              options,
              (this.joinerSelectFilterValues[joinerIdx] ?? []).join(','));
            request.parentFilters = parentFilters;
          }
        }
        if(request != null){
          request.isNewCache=isNewCache;
        
        const response = await this.configService.getSummaryDataFarm(request);
        if(response.data.totalRows==0){
          //this.totalSummaryRows="";
        //later implement input or output have file or not
        }
        else{
          const totalRows = Number(response.data.totalSummaryFarmRows).toLocaleString();
          if (sender === this.summaryDataFarmPreviewTableInput) {
            this.totalSummaryRowsInput="Total Row Count: "+totalRows;
          } else if (sender === this.summaryDataFarmPreviewTableOutput) {
            this.totalSummaryRowsOutput="Total Row Count: "+totalRows;
          } else {
            const joinerIdx = this.joinerSummaryPreviewTables?.toArray().indexOf(sender) ?? -1;
            if (joinerIdx >= 0) {
              this.joinerTotalSummaryRows[joinerIdx] = "Total Row Count: " + totalRows;
            }
          }
          //this.totalSummaryRows="Total Row Count: "+response.data.totalSummaryFarmRows.toLocaleString();
          // remove 0 should be remove in python later
          const countColumns = response.data.columns
            .filter(col => col.columnName.includes('count'));

          var rowdata=Object.values(response.data.rows);
          rowdata.forEach(row => {
            countColumns.forEach(col => {
              const colIndex = col.index.toString();
              if (row[colIndex] === 0) {
                row[colIndex] = ''; // Replace 0 with blank
              }
            });
          });

          sender.bindData(response.data, 'No Summary preview data');
        }
      }
     }
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
      busyIndicator.close();
    }
  }
  
  async onApplySelect(info: SelectFilterInfo): Promise<void> {
    this.source=info.source;
    this.selectFilterValues=info.values.filter(cl=>cl!=null).map(col=>col);
    this.menuTrigger.closeMenu();
    this.prevSource=this.source;
    if(info.source == "Input"){
      this.selectFilterValuesInput=[...this.selectFilterValues];
      await this.clearAllSortFilterCache(this.summaryDataFarmPreviewTableInput,true);
    }else if(info.source == "Output") {
      this.selectFilterValuesOutput=[...this.selectFilterValues];
      await this.clearAllSortFilterCache(this.summaryDataFarmPreviewTableOutput,true);
    }else if(info.source.includes("Node")) {
      const idx = this.joinerPreviewTabs.findIndex(t => t.nodeName === info.source);
      if (idx >= 0) {
        this.joinerSelectFilterValues[idx] = [...this.selectFilterValues];
        const summaryTable = this.joinerSummaryPreviewTables?.toArray()[idx];
        if (summaryTable) {
          await this.clearAllSortFilterCache(summaryTable, true);
        }
      }
    }
  }

  async onClearSelect(colName: string): Promise<void> {
    // this.source=this.prevSource;
    // await this.bindSummary(this.source);
    this.menuTrigger.closeMenu();
  }

  onCloseSelect(): void {
    this.menuTrigger.closeMenu();
  }
  async showSelectFilter(menuTrigger: MatMenuTrigger,source:string="Input"): Promise<void> {
    this.source=source;
    this.menuTrigger=menuTrigger;
    //this.menuTrigger.closeMenu();
    await this.bindSummary(this.source);
    this.menuTrigger.openMenu();
  }
  async onChangeSource(sourcetype:string){
    await this.bindSummary(sourcetype);
  }
  async bindSummary(sourcetype:string): Promise<void> {
    if(sourcetype=="Input"){
      if(this.selectValuesInput.length==0){
        await this.bindSelectValues(sourcetype);
      }
      this.selectValues =[...new Set(this.selectValuesInput)];
      this.selectEmptyColumns =[...new Set(this.selectEmptyColumnsInput)];
      this.selectFilterValues=[...new Set(this.selectFilterValuesInput)];
    }else if(sourcetype=="Output"){
      if(this.selectValuesOutput.length==0){
        await this.bindSelectValues(sourcetype);
      }
      this.selectValues =[...new Set(this.selectValuesOutput)];
      this.selectEmptyColumns =[...new Set(this.selectEmptyColumnsOutput)];
      this.selectFilterValues=[...new Set(this.selectFilterValuesOutput)];
    }else if(sourcetype.includes("Node")){
      const idx = this.joinerPreviewTabs.findIndex(t => t.nodeName === sourcetype);
      if (idx >= 0) {
        this.selectFilterValues = [...new Set(this.joinerSelectFilterValues[idx] ?? [])];
        if (!(this.joinerSelectValues[idx]?.length)) {
          await this.bindSelectValues(sourcetype);
        }
        this.selectValues = [...new Set(this.joinerSelectValues[idx] ?? [])];
        this.selectEmptyColumns = [...new Set(this.joinerSelectEmptyColumns[idx] ?? [])];
      }
    }
    this.cdr.detectChanges();
  }
  async bindSelectValues(sourcetype:string): Promise<void> {
    try {
      var request :GetSummaryDataFarmPreviewRequest = null;
      if(sourcetype=="Input"){
        this.selectValuesInput = [...this.inputDataFarmPreviewTable.displayedColumnInfos.map(map => map.name).filter(mp=>mp!='row')];
        const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryInput);
        request = new GetSummaryDataFarmPreviewRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          cachekeyRequest.transformId,
          cachekeyRequest.cacheKeyType,
          null,
          this.selectFilterValues.join(',') ?? '',
          null);
        const response = await this.configService.getSummaryEmptyColslist(request);
        this.selectEmptyColumnsInput=response.blanks_cols_list;
      }else if(sourcetype=="Output"){
        if(this.outputDataFarmPreviewTable.displayedColumnInfos){
          this.selectValuesOutput = [...this.outputDataFarmPreviewTable.displayedColumnInfos.map(map => map.name).filter(mp=>mp!='row')];
          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryOutput);
          const parentFilters = (this.outputDataFarmPreviewTable.activeFilterSet ?? []).map(f => {
              const filterInfo = new ColumnFilter();
              filterInfo.field = f.columnName;
              filterInfo.values = f.values;
              return filterInfo;
            });
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            null,
            this.selectFilterValues.join(',') ?? '',
            null);
          const response = await this.configService.getSummaryEmptyColslist(request);
          request.parentFilters = parentFilters;
          this.selectEmptyColumnsOutput=response.blanks_cols_list;
        }else{
          this.displayWarning("There is no Output Farm, please run the Processor/Ingest Node/Transformer.","Warning");
          this.selectValuesOutput = [...new Set([])];
        }
      }else if(sourcetype.includes("Node")){
        const idx = this.joinerPreviewTabs.findIndex(t => t.nodeName === sourcetype);
        if (idx >= 0) {
          const inputTable = this.joinerInputPreviewTables?.toArray()[idx];
          if (inputTable) {
            this.joinerSelectValues[idx] = [...inputTable.displayedColumnInfos.map(map => map.name).filter(mp => mp !== 'row')];
          }
          const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[idx]);
          request = new GetSummaryDataFarmPreviewRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            null,
            this.selectFilterValues.join(',') ?? '',
            null);
          const response = await this.configService.getSummaryEmptyColslist(request);
          this.joinerSelectEmptyColumns[idx] = response.blanks_cols_list;
        }
      }
    }catch (err) {
      this.displayError('Failed to get data Empty column list', 'Error', err);
    } finally {
      //sender.isGettingData.next(false);
    }
  }

  async isConfigureAll():Promise<boolean>{
    var status=true;
    const notConfiguredNodes=this.viewModel.dataRefineryConfig.nodes.filter(node => node.data?.nodeStatus==NodeRunStatus.NotConfigured);
    if(notConfiguredNodes.length>0){
      status=false;
    }
    return status;
  }
  async resetAllPreviewData(): Promise<void> {
    // Clear the preview before loading new data...
    if(this.inputDataFarmPreviewTable){
      this.inputDataFarmPreviewTable.clear();
    }
    if(this.outputDataFarmPreviewTable){
      this.outputDataFarmPreviewTable.clear();
    }
    if(this.summaryDataFarmPreviewTableInput){
      this.summaryDataFarmPreviewTableInput.clear();
      this.totalSummaryRowsInput="";
      const pvb: PreviewData = {
        columns: [],
        rows: {},
        totalRows: 0,
        totalSummaryFarmRows: 0,
        cacheFileCreationDtTime:''
      };
      this.summaryDataFarmPreviewTableOutput.bindData(pvb, 'No Summary preview data');
    }
    if(this.summaryDataFarmPreviewTableOutput){
      this.summaryDataFarmPreviewTableOutput.clear();
      this.totalSummaryRowsOutput="";
      const pvb: PreviewData = {
        columns: [],
        rows: {},
        totalRows: 0,
        totalSummaryFarmRows: 0,
        cacheFileCreationDtTime:''
      };
      this.summaryDataFarmPreviewTableOutput.bindData(pvb, 'No Summary preview data');
    }

    const pvbEmpty: PreviewData = {
      columns: [],
      rows: {},
      totalRows: 0,
      totalSummaryFarmRows: 0,
      cacheFileCreationDtTime:''
    };
    this.joinerSummaryPreviewTables?.forEach((table, i) => {
      table.clear();
      this.joinerTotalSummaryRows[i] = "";
      table.bindData(pvbEmpty, 'No Summary preview data');
    });

    this.source="";
    this.prevSource="";
    this.selectValues=[];
    this.selectValuesInput=[];
    this.selectValuesOutput=[];
    this.joinerSelectValues = this.joinerPreviewTabs.map(() => []);

    this.selectEmptyColumns=[];
    this.selectEmptyColumnsInput=[];
    this.selectEmptyColumnsOutput=[];
    this.joinerSelectEmptyColumns = this.joinerPreviewTabs.map(() => []);

    this.selectFilterValues=[];
    this.selectFilterValuesInput=[];
    this.selectFilterValuesOutput=[];
    this.joinerSelectFilterValues = this.joinerPreviewTabs.map(() => []);
  }
  //Preview Table Delegate
  async onRefreshClicked(sender: PreviewTableComponent): Promise<void> {
    await this.refreshPreviewTable(sender);
  }

  async onPageChanged(sender: PreviewTableComponent, totalRows: number, pageSize: number, pageIndex: number): Promise<number> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    await this.refreshPreviewTable(sender);
    busyIndicator.close();
    return totalRows;
  }

  async onShowFilter(sender: PreviewTableComponent, columnName: string): Promise<void> {
    if(sender.activeFilterSet == undefined || sender.activeFilterSet.length == 0) {
        const busyIndicator = this.showBusyDialog('Please wait...');
        var cachekeyRequest:GetCacheKeyRequest=null;
        if(sender === this.inputDataFarmPreviewTable) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryInput);
        }else if (sender === this.outputDataFarmPreviewTable) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryOutput);
        }else if (sender === this.summaryDataFarmPreviewTableInput) {
            cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryInput);
        } else if (sender === this.summaryDataFarmPreviewTableOutput) {
          cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.refineryOutput);
        } else {
          const summaryIdx = this.joinerSummaryPreviewTables?.toArray().indexOf(sender) ?? -1;
          const inputIdx = this.joinerInputPreviewTables?.toArray().indexOf(sender) ?? -1;
          if (summaryIdx >= 0) {
            cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[summaryIdx]);
          } else if (inputIdx >= 0) {
            cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[inputIdx]);
          }
        }
        
        try{
          var request = new GetFilteredselcolvalsRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.transformId,
            cachekeyRequest.cacheKeyType,
            columnName);
          await sender.fetchselectedcolsvalsfrmAPI(request);
        } catch(ex) {
          console.error('Error fetching data:', ex);
          this.displayError('Failed to fetch filter values. Please try again later.',"Failed to fetch");
        } finally {
          busyIndicator.close();
        }
    } else {
        sender.applyStackFilters(columnName);
    }
  }

  async onApplyFilter(sender: PreviewTableComponent, filterSet: ColumnFilterInfo[], info: ColumnFilterInfo): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    await this.refreshPreviewTable(sender);
    busyIndicator.close();
  }

  async onClearFilter(sender: PreviewTableComponent, filterSet: ColumnFilterInfo[], columnName: string): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    if(this.viewModelt.activeFilters){
      this.viewModelt.activeFilters = this.viewModelt.activeFilters.filter(f => f.field !== columnName);
    }
    await this.refreshPreviewTable(sender);
    busyIndicator.close();
  }

  async onApplySort(sender: PreviewTableComponent, sortData: SortInfo[]): Promise<void> {
    this.activeSortsSet = sortData;
  }

  async onClearAllSortFilter(sender: PreviewTableComponent): Promise<void> {
    this.activeSortsSet = [];
    this.clearAllSortFilterCache(sender,false);
  }
  async clearAllSortFilterCache(sender: PreviewTableComponent, isNewCache: boolean = false): Promise<void> {
    sender.activeFilterSet=[];
    sender.activeSortsSet=[];
    this.refreshSummaryDataFarmPreviewAsync(sender,isNewCache);
  }
  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, columns: ColumnInfo[]): string {
    return null;
  }
  //Preview Table Delegate End
  async GetCacheKeyRequest(previewType:PreviewType): Promise<GetCacheKeyRequest> {
      var request = new GetCacheKeyRequest(
          this.userData.getUserId(),
          this.userData.getOrgId(),
          this.userData.getRefineryId(),
          this.userData.getNodeId(),
          this.userData.getTransformId(),
          CacheKeyType.node);

      var node = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == this.previewNodeId);
      var ingestnode = this.viewModel.dataRefineryConfig.nodes.find(x => x.id == node.data.ingestId);
      var configGuid=ingestnode.data.configGuid;
      if(configGuid){
        var configJson = await this.configService.getConfigByGuidAsync(configGuid);
      }
      var transformers=configJson.transforms.find(t=>t.nodeID==this.previewNodeId);

      if(previewType === PreviewType.refineryInput) {
        if(node.data.nodeboxtypeid == 1){
          request.nodeId = node.id;
        }else{
          const parentNode = this.userData.getNodeParentDataLine();
          if (parentNode) {
            request.nodeId = parentNode[0].source;
          }else{
            var LinksforNode_Data = this.viewModel.dataRefineryConfig.links.filter(l => l.target == node.id && (l.data.linetype == "line" || l.data.linetype == "joiner") ) ;
            request.nodeId = LinksforNode_Data[0].source;
          }
        }
        request.cacheKeyType = CacheKeyType.node;
      }else if (previewType === PreviewType.refineryOutput) {
        request.cacheKeyType=CacheKeyType.node;
      }else {
        const idx = this.joinerInputPreviewTypes.indexOf(previewType);
        if (idx >= 0) {
          request.nodeId=(transformers.transformConfig.fieldMap as any).find((x: any)=>x.index===idx).nodeID;
          request.transformId="";
          request.cacheKeyType=CacheKeyType.node;
        }
      }
  
      return request;
    }

  getIconClass(field: any): string | null {
    switch (field) {
      case 'database':
        return 'fa-solid fa-database';
      case 'file':
        return 'fa-solid fa-file';
      case 'excel':
        return 'fa-solid fa-file-excel';
      case 'feather':
        return 'fa-solid fa-feather';
      default:
        return 'fa-solid fa-database';
    }
  }


  getIconImageSrcByStatus(dbWriterType: any, dataWriterStatus: NodeRunStatus): string | null {
    if (dbWriterType === 'parquet') {
      if (dataWriterStatus === NodeRunStatus.Completed) return 'assets/images/parquet_icon_green.png';
      if (dataWriterStatus === NodeRunStatus.Error)     return 'assets/images/parquet_icon_red.png';
      return 'assets/images/parquet_icon_gray.png';
    }
    return null;
  }
  async runDataWriter(nodeid:string) {
    await this.refreshBeforeMutatingAction();
    var nd=this.userData.getSelectedRefineryDetails();
    var confignode=nd.nodes.find(node=>node.id==nodeid);
    if(confignode.data?.nodeboxtypeid == 1 ){
       return;       
    }
    if (confignode.data.nodeStatus!=NodeRunStatus.Completed) {
       return;         
    }
    if(!confignode.data.isdbupdater){
      return;         
    }

    const busyIndicator = this.showBusyDialog('Please wait running data writer...');
    try {
        var tws = new TestWriterRequest();
        tws.nodeID = nodeid;
        tws.refineryConfigID = this.userData.getRefineryId();

        tws.userId = this.userData.getUserId();
        tws.orgId = this.userData.getOrgId();
        tws.refineryId = this.userData.getRefineryId();
        tws.nodeId = nodeid;
        tws.transformId = "";
        tws.tabId = this.refineryPresence.tabId;
        tws.cacheKeyType = CacheKeyType.node;


        var testwriter = await this.configService.testWriter(tws);
        
        if (testwriter.status === "Completed") {
            this.snackBar.open(testwriter.message, 'Dismiss', {
                duration: 5000
            });
        } else {
            this.displayError(`Failed to write data writer`, 'Error', testwriter.message);
        }

        busyIndicator.close();
    } catch (err) {
        busyIndicator.close();
        this.displayError(`Failed to write data writer`, 'Error', err);
    }
  }
}

